/**
 * Weddings landing pages config — dedicated wedding floristry, no other event types.
 * Each city has: SEO meta, hero, packages, wedding floral elements, venues, FAQ.
 */

export const WEDDING_CITIES = {
  bodrum: {
    slug: "bodrum",
    name: "Бодрум",
    nameEn: "Bodrum",
    namePrepositional: "в Бодруме",
    namePrepositionalEn: "in Bodrum",
    namePossessive: "Бодрума",
    namePossessiveEn: "Bodrum",
    country: { ru: "Турция", en: "Turkey", tr: "Turkiye" },
    countryFlag: "🇹🇷",
    currency: "EUR",
    currencySymbol: "€",
    coords: { lat: 37.0344, lng: 27.4305 },
    languages: ["ru", "en", "tr"],
    heroImage: "/weddings/bodrum/hero.webp",
    venues: [
      "Mandarin Oriental Bodrum",
      "Caresse Bodrum",
      "The Bodrum EDITION",
      "Maxx Royal Bodrum",
      "Lujo Hotel Bodrum",
      "Six Senses Kaplankaya",
      "Kempinski Hotel Barbaros Bay",
      "Macakizi Hotel",
      "Bodrum Loft",
      "D-Hotel Maris",
    ],
    gallery: [
      { src: "/weddings/bodrum/01.webp", alt: { ru: "Розовая свадебная арка на пирсе у моря — Бодрум", en: "Pink wedding arch on a seaside pier — Bodrum" }, tag: { ru: "Арка на воде", en: "Waterside arch" } },
      { src: "/weddings/bodrum/02.webp", alt: { ru: "Длинный банкетный стол с белой флористикой и хрустальной люстрой", en: "Long banquet table with white florals and crystal chandelier" }, tag: { ru: "Банкет", en: "Banquet" } },
      { src: "/weddings/bodrum/03.webp", alt: { ru: "Белая цветочная арка у бассейна с видом на залив — Бодрум", en: "White floral arch by infinity pool overlooking the bay — Bodrum" }, tag: { ru: "Церемония у бассейна", en: "Poolside ceremony" } },
      { src: "/weddings/bodrum/04.webp", alt: { ru: "Дизайнерские клетки-композиции с цветным омбре под золотым потолком", en: "Designer cage compositions with colour ombré under gilded ceiling" }, tag: { ru: "Авторский декор", en: "Bespoke decor" } },
      { src: "/weddings/bodrum/05.webp", alt: { ru: "Закатная фотозона с качелями и зеленью — Бодрум", en: "Sunset photo zone with swing and greenery — Bodrum" }, tag: { ru: "Фотозона", en: "Photo zone" } },
      { src: "/weddings/bodrum/06.webp", alt: { ru: "Круглая арка из пампасной травы с акцентом из ярких цветов", en: "Round pampas grass arch with bright floral accent" }, tag: { ru: "Boho-арка", en: "Boho arch" } },
      { src: "/weddings/bodrum/07.webp", alt: { ru: "Свадебная арка из роз и зеркальный стол на пирсе с видом на море", en: "Rose wedding arch and mirror table on a seaside pier" }, tag: { ru: "Церемония у моря", en: "Seaside ceremony" } },
      { src: "/weddings/bodrum/08.webp", alt: { ru: "Длинная цветочная дорожка с гипсофилой и розами вдоль пирса", en: "Long floral aisle with baby's breath and roses along the pier" }, tag: { ru: "Цветочная дорожка", en: "Floral aisle" } },
      { src: "/weddings/bodrum/09.webp", alt: { ru: "Тоннель из розовой сакуры на деревянном пирсе у моря — Бодрум", en: "Pink cherry blossom tunnel on a seaside boardwalk — Bodrum" }, tag: { ru: "Сакура-тоннель", en: "Sakura tunnel" } },
      { src: "/weddings/bodrum/10.webp", alt: { ru: "Премиум банкет с зеленью и хрустальной люстрой на открытом воздухе", en: "Premium garden banquet with greenery and crystal chandelier" }, tag: { ru: "Garden dinner", en: "Garden dinner" } },
      { src: "/weddings/bodrum/11.webp", alt: { ru: "Камерный банкет на траве с розовыми композициями — Бодрум", en: "Intimate lawn banquet with pink floral centerpieces — Bodrum" }, tag: { ru: "Lawn-dinner", en: "Lawn dinner" } },
      { src: "/weddings/bodrum/12.webp", alt: { ru: "Закатный сет-ап стола с белыми орхидеями и каллами", en: "Sunset tablescape with white orchids and calla lilies" }, tag: { ru: "Сет-ап на закате", en: "Sunset tablescape" } },
    ],
    areas: [
      { ru: "Ялыкавак", en: "Yalıkavak" },
      { ru: "Тюркбюкю", en: "Türkbükü" },
      { ru: "Гёльтюркбюкю", en: "Göltürkbükü" },
      { ru: "Гёкова", en: "Gökova" },
      { ru: "Гюмюшлюк", en: "Gümüşlük" },
      { ru: "Битез", en: "Bitez" },
      { ru: "Ялыджифтлик", en: "Yalıçiftlik" },
    ],
    seo: {
      ru: {
        title: "Свадебная флористика в Бодруме — премиум-оформление свадеб | YUCCA",
        description:
          "Цветочное оформление свадеб в Бодруме под ключ: букет невесты, арка, церемония, банкет, фотозона. Премиум-флористика для отелей Mandarin Oriental, Caresse, EDITION. От €2500. Запросите смету за 24 часа.",
        keywords:
          "свадебная флористика Бодрум, оформление свадеб Бодрум, цветы на свадьбу Бодрум, букет невесты Бодрум, свадебная арка Бодрум, флорист на свадьбу Бодрум, wedding florist Bodrum, оформление свадьбы Бодрум турция",
        heroEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА",
        heroTitle: "Свадьба, которая останется",
        heroTitleAccent: "в памяти навсегда",
        heroSubtitle:
          "Премиум-флористика для свадеб в Бодруме — от букета невесты до полного оформления церемонии и банкета. Работаем со всеми ведущими отелями полуострова.",
        ctaPrimary: "ЗАПРОСИТЬ СМЕТУ",
        ctaSecondary: "СМОТРЕТЬ ПРИМЕРЫ",
        badges: [
          { title: "ИНДИВИДУАЛЬНЫЙ КОНЦЕПТ", subtitle: "Под стиль вашей свадьбы" },
          { title: "ТОЧНО ВО ВРЕМЯ", subtitle: "Установка к началу церемонии" },
          { title: "ВЕСЬ БОДРУМ", subtitle: "Отели, виллы, пляжные локации" },
          { title: "ФОТО-ПОДТВЕРЖДЕНИЕ", subtitle: "До и после установки" },
        ],

        elementsEyebrow: "ЧТО ВХОДИТ В ОФОРМЛЕНИЕ",
        elementsTitle: "Каждая деталь — продумана",
        elements: [
          {
            title: "Букет невесты",
            text: "Главный акцент. Каскадный, круглый или асимметричный — в стилистике платья и палитры.",
          },
          {
            title: "Бутоньерки и браслеты",
            text: "Жених, шаферы, подружки невесты. Миниатюрные композиции, объединяющие свадебную команду.",
          },
          {
            title: "Свадебная арка",
            text: "Сердце церемонии. Зелень эвкалипта, пионы, ранункулюсы — или эксклюзивный концепт.",
          },
          {
            title: "Оформление столов",
            text: "Низкие композиции для общения гостей или высокие — для торжественной атмосферы.",
          },
          {
            title: "Цветочная дорожка",
            text: "Лепестки, гирлянды, светильники-фонари — путь невесты к жениху.",
          },
          {
            title: "Фотозона",
            text: "Цветочная стена или арка для постановочных фото — каждый кадр свадьбы идеален.",
          },
          {
            title: "Лепестки для конфетти",
            text: "Финальный аккорд — гости осыпают молодожёнов после церемонии.",
          },
          {
            title: "Декор машины и яхты",
            text: "Цветочный декор для свадебной машины или яхты — для торжественного выезда.",
          },
        ],

        packagesEyebrow: "ПАКЕТЫ ОФОРМЛЕНИЯ",
        packagesTitle: "Три формата",
        packagesTitleAccent: "под вашу свадьбу",
        packagesSubtitle:
          "Каждый пакет — отправная точка. Все детали обсуждаются и адаптируются под ваше событие.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Камерная свадьба",
            priceFrom: "от €2 500",
            description:
              "Идеально для интимной церемонии или росписи. Букет невесты, бутоньерка жениха, небольшая флористическая арка.",
            features: [
              "Букет невесты",
              "Бутоньерка жениха",
              "Цветочная арка (компактная)",
              "Бутоньерки шаферов (до 2)",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Свадьба до 50 гостей",
            priceFrom: "от €5 000",
            description:
              "Самый востребованный пакет. Полное оформление церемонии и банкетной зоны для классической свадьбы.",
            features: [
              "Каскадный букет невесты",
              "Бутоньерки жениха и шаферов",
              "Браслеты подружек невесты",
              "Полноразмерная цветочная арка",
              "Композиции на 6-8 столов",
              "Лепестки для прохода",
              "Декор сладкого стола",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "Свадьба 100+ гостей",
            priceFrom: "от €9 000",
            description:
              "Премиум-формат с пионами Дэвид Остин, орхидеями фаленопсис, эксклюзивной зеленью. Полный day-of сервис.",
            features: [
              "Премиум-букет невесты",
              "Эксклюзивная сложная арка",
              "Цветочная стена / фотозона",
              "Композиции на 10+ столов",
              "Декор машины и/или яхты",
              "Day-of флорист на месте",
              "Демонтаж после церемонии",
            ],
          },
        ],

        seasonTitle: "Лучшее время для свадьбы",
        seasonTitleAccent: "в Бодруме",
        seasonEyebrow: "СЕЗОННОСТЬ",
        seasonSubtitle:
          "Каждый месяц в Бодруме — особенный. Это поможет выбрать дату и состав букета.",
        seasons: [
          {
            period: "МАЙ — ИЮНЬ",
            label: "Пик сезона",
            text: "Идеальная погода, длинный световой день. В наличии локальные пионы, ранункулюсы, садовые розы Дэвид Остин.",
          },
          {
            period: "ИЮЛЬ — АВГУСТ",
            label: "Высокий сезон",
            text: "Жарко днём, но церемонии после 17:00 — магия. Импортные пионы, орхидеи, экзотика — всегда в наличии.",
          },
          {
            period: "СЕНТЯБРЬ — ОКТЯБРЬ",
            label: "Золотая осень",
            text: "Тёплое море, мягкий свет. Возвращаются ранункулюсы, добавляются георгины, ягоды, бордовые акценты.",
          },
          {
            period: "НОЯБРЬ — АПРЕЛЬ",
            label: "Indoor-сезон",
            text: "Камерные свадьбы в отелях. Импортные пионы из Голландии и Эквадора, тюльпаны, нарциссы.",
          },
        ],

        processEyebrow: "КАК МЫ РАБОТАЕМ",
        processTitle: "От первого письма",
        processTitleAccent: "до финального лепестка",
        processSubtitle:
          "Прозрачный процесс без сюрпризов. Вы знаете что и когда происходит на каждом этапе.",
        processSteps: [
          {
            num: "01",
            title: "Знакомство",
            text: "Zoom или WhatsApp. Обсуждаем дату, локацию, размер, стиль, бюджет. Бесплатно.",
          },
          {
            num: "02",
            title: "Мудборд и смета",
            text: "Присылаем визуальный концепт и детальную смету. Корректируем до полного совпадения с вашим видением.",
          },
          {
            num: "03",
            title: "Бронь и предоплата",
            text: "30% предоплата фиксирует дату и состав. Резервируем редкие сорта (например, пионы Дэвид Остин).",
          },
          {
            num: "04",
            title: "Финальная сверка",
            text: "За 2 недели до даты — встреча с финальным мудбордом и таймингом. Все детали согласованы.",
          },
          {
            num: "05",
            title: "День свадьбы",
            text: "Установка с раннего утра. Букет невесты доставляется в номер за 1.5-2 часа до церемонии.",
          },
          {
            num: "06",
            title: "Демонтаж",
            text: "После завершения мы аккуратно убираем все композиции и оставляем локацию в идеальном состоянии.",
          },
        ],

        venuesTitle: "Работаем с лучшими отелями",
        venuesEyebrow: "ПЛОЩАДКИ",
        venuesSubtitle:
          "Знаем специфику доступа, логистики и таймингов ведущих отелей и вилл Бодрума.",

        galleryEyebrow: "НАШИ РАБОТЫ",
        galleryTitle: "Свадьбы, которые мы",
        galleryTitleAccent: "оформили в Бодруме",
        gallerySubtitle:
          "Каждая свадьба — своя история. Арки у моря, банкеты на закате, фотозоны для незабываемых кадров.",
        galleryCta: "Хотим такую же свадьбу",

        hookQuote: "Один день. Сотни деталей.",
        hookQuoteAccent: "Только одна возможность сделать это идеально.",
        hookSubtitle: "Мы сделали так уже больше 80 раз — на пляжах Ялыкавак, в садах Mandarin Oriental, под сводами Six Senses. Каждая свадьба — это отдельный проект, к которому мы готовимся за 2-3 месяца.",
        hookStats: [
          { value: "80+", label: "свадеб в Бодруме" },
          { value: "10", label: "лет на полуострове" },
          { value: "5.0", label: "средний рейтинг" },
          { value: "24 ч", label: "ответ на запрос" },
        ],

        seoEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА В БОДРУМЕ",
        seoTitle: "Свадьба у моря в Турции —",
        seoTitleAccent: "destination-флористика премиум-класса",
        seoBlocks: [
          {
            heading: "Свадебный флорист в Бодруме под ключ",
            image: "/weddings/bodrum/seo-1.webp",
            imageAlt: "Свадебная арка с белыми розами и свечами на закате у моря в Бодруме",
            content: "YUCCA Flowers — премиум свадебная флористика в Бодруме. Мы специализируемся на цветочном оформлении свадеб в Турции для русскоязычных, европейских и арабских пар, выбирающих destination wedding на эгейском побережье. За 10 лет работы на полуострове наша команда оформила более 80 свадеб в Бодруме — от камерных beachfront-церемоний на 20 гостей до luxury-торжеств на 300 человек в Mandarin Oriental, Caresse, The Bodrum EDITION и Six Senses Kaplankaya. Оформление свадьбы в Бодруме — это не только букет невесты и арка: это согласованный цветочный концепт от welcome-зоны до банкета и фотозоны.",
          },
          {
            heading: "Выездная регистрация и оформление церемонии у моря",
            image: "/weddings/bodrum/seo-2.webp",
            imageAlt: "Белая свадебная арка с розами над инфинити-бассейном с видом на залив Бодрума",
            content: "Выездная свадебная церемония в Бодруме проходит на пляжах Ялыкавак (Yalıkavak), Тюркбюкю (Türkbükü), Гёльтюркбюкю, Гюмюшлюк (Gümüşlük), Битез (Bitez), Гёкова и Ялыджифтлик. Мы оформляем свадебные арки на пирсе, террасе отеля или у инфинити-бассейна с видом на Эгейское море. В работе используем пионы (David Austin), садовые розы, эустому, гипсофилу, ранункулюсы, экзотические орхидеи и эвкалипт. Дополнительно — флористика для проходного коридора, фотозона, свечи в стеклянных колбах, цветочный декор свадебной арки и свадебного стола. Свадебная флористика Бодрум — это про устойчивые композиции, выдерживающие морской ветер, солёный воздух и 6+ часов на солнце.",
          },
          {
            heading: "Банкет, тейблскейп и свадебный декор для гостей",
            image: "/weddings/bodrum/seo-3.webp",
            imageAlt: "Свадебный банкетный стол в белой палитре с цветочной композицией и видом на море — Бодрум",
            content: "Оформление свадебного банкета в Бодруме — самая важная и фотогеничная часть праздника. Мы создаём низкие и высокие цветочные композиции для длинных банкетных столов, гирлянды из эвкалипта и белых роз, runner из живых цветов, винтажные подсвечники со свечами, индивидуальный декор для каждого place setting. Работаем с свадебными планерами Турции, фотографами и event-агентствами Бодрума. Бюджет свадебного оформления в Бодруме стартует от €2 500 за пакет Essential (камерная церемония), €5 000 — Signature до 50 гостей, €9 000+ — Bespoke для 100+ гостей с премиальными сортами цветов из Эквадора, Кении и Голландии.",
          },
        ],
        seoServiceTitle: "Что входит в свадебное оформление в Бодруме",
        seoServices: [
          "Букет невесты в Бодруме (каскадный, круглый, асимметричный)",
          "Бутоньерки жениха, шаферов и отцов",
          "Свадебные браслеты подружек невесты",
          "Цветочная арка для церемонии у моря",
          "Оформление прохода невесты и лепестки",
          "Тейблскейп: композиции для банкетного стола",
          "Цветочные runner и гирлянды из эвкалипта",
          "Фотозона / цветочная стена для портретов",
          "Декор сладкого стола и свадебного торта",
          "Цветочный декор свадебной машины и яхты",
          "Welcome-зона и оформление приветственного коктейля",
          "Демонтаж после церемонии — площадка остаётся идеальной",
        ],
        seoLocationsTitle: "География работ — весь полуостров Бодрум",
        seoLocations: [
          "Ялыкавак (Yalıkavak)", "Тюркбюкю (Türkbükü)", "Гёльтюркбюкю", "Битез (Bitez)",
          "Гюмюшлюк (Gümüşlük)", "Гёкова (Gökova)", "Ялыджифтлик (Yalıçiftlik)",
          "Торба (Torba)", "Гюндоган (Gündoğan)", "Куадаш (Kuadaş)", "Акьярлар (Akyarlar)", "Тургутрейс (Turgutreis)",
        ],
        seoFinal: "Свадьба в Бодруме — это destination wedding на одном из самых живописных побережий Турции. Эгейское море, средиземноморский климат с мая по октябрь, премиум-отели и виллы 5★, прямые рейсы из России, Европы и ОАЭ. Если вы планируете свадьбу за границей, ищете wedding floral designer в Турции или хотите узнать сколько стоит свадебная флористика в Бодруме — напишите нам в WhatsApp: пришлём персональный мудборд и смету в течение 24 часов.",
        seoCta: "Запросить смету на свадьбу в Бодруме",

        partnersEyebrow: "НАМ ДОВЕРЯЮТ",
        partnersTitle: "Премиум-отели и виллы, в которых мы оформляли свадьбы",
        partners: [
          "MANDARIN ORIENTAL", "CARESSE", "THE BODRUM EDITION", "MAXX ROYAL",
          "SIX SENSES KAPLANKAYA", "KEMPINSKI", "LUJO HOTEL", "MACAKIZI", "BODRUM LOFT", "D-HOTEL MARIS",
        ],

        testimonialsEyebrow: "ОТЗЫВЫ НЕВЕСТ",
        testimonialsTitle: "Что говорят пары, которые",
        testimonialsTitleAccent: "доверили нам свой день",
        testimonialsSubtitle: "80+ свадеб в Бодруме — и каждая остаётся в нашем сердце. Вот несколько историй.",
        testimonials: [
          {
            quote: "Мы планировали свадьбу из Лондона дистанционно — и за 3 месяца YUCCA создали именно то, что мы видели в мудборде. Арка с пионами на пирсе Caresse была настолько красивой, что гости не могли поверить, что это реальные цветы.",
            name: "Анна и Михаил",
            location: "Caresse Bodrum",
            date: "Июнь 2025",
            rating: 5,
          },
          {
            quote: "Когда невеста увидела свой каскадный букет, она расплакалась. До церемонии было ещё 2 часа, а мы уже понимали — день будет идеальным. Спасибо команде за внимание к каждой детали.",
            name: "Eлизавета и Артур",
            location: "Mandarin Oriental Bodrum",
            date: "Сентябрь 2024",
            rating: 5,
          },
          {
            quote: "Я думала, что свадьба в Турции — это компромисс с моими ожиданиями. YUCCA доказали обратное: их флористика на уровне лучших wedding-designer'ов Парижа. Six Senses преобразился до неузнаваемости.",
            name: "Софья и Дэвид",
            location: "Six Senses Kaplankaya",
            date: "Май 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "ЗАЯВКА НА КОНСУЛЬТАЦИЮ",
        leadTitle: "Расскажите о вашей",
        leadTitleAccent: "свадьбе",
        leadSubtitle: "Мы пришлём персональный мудборд и предварительную смету в течение 24 часов. Консультация — бесплатная.",
        leadFields: {
          name: "Ваше имя",
          contact: "WhatsApp / Telegram / Email",
          date: "Дата свадьбы (если есть)",
          guests: "Количество гостей",
          budget: "Ориентировочный бюджет",
          budgetOptions: ["Не определились", "До €3 000", "€3 000 – €6 000", "€6 000 – €10 000", "€10 000+"],
          guestsOptions: ["Не определились", "До 20", "20–50", "50–100", "100–200", "200+"],
          message: "Расскажите о свадьбе — локация, стиль, пожелания",
          submit: "Отправить заявку",
          sending: "Отправляем…",
          successTitle: "Спасибо!",
          successText: "Мы получили вашу заявку и свяжемся с вами в течение 24 часов с персональным мудбордом и сметой.",
          errorText: "Не удалось отправить. Напишите нам в WhatsApp — мы получим заявку быстрее.",
          required: "Заполните имя и контакт",
        },

        timelineEyebrow: "КАЛЕНДАРЬ ВАШЕЙ СВАДЬБЫ",
        timelineTitle: "От первого письма",
        timelineTitleAccent: "до финального лепестка",
        timelineSubtitle: "Прозрачный график без сюрпризов. Вы всегда знаете, что и когда происходит.",
        timeline: [
          { when: "ЗА 3 МЕСЯЦА", title: "Знакомство и концепт", text: "Zoom-консультация бесплатно. Обсуждаем дату, локацию, стиль, бюджет. Присылаем мудборд." },
          { when: "ЗА 2.5 МЕСЯЦА", title: "Бронь и предоплата", text: "30% депозит фиксирует дату и состав. Резервируем редкие сорта — пионы David Austin из Голландии." },
          { when: "ЗА 1 МЕСЯЦ", title: "Финальная палитра", text: "Утверждаем точные оттенки, количество композиций, тайминг установки. Согласуем с банкетной службой отеля." },
          { when: "ЗА 2 НЕДЕЛИ", title: "Контрольная встреча", text: "Финальный мудборд с фото референсов. Все детали согласованы — никаких сюрпризов в день свадьбы." },
          { when: "ДЕНЬ -1", title: "Установка с раннего утра", text: "Команда выходит на площадку с 6:00. Арка, столы, фотозона, дорожка — всё готово за 4 часа до церемонии." },
          { when: "ДЕНЬ СВАДЬБЫ", title: "Букет невесты в 14:00", text: "Букет невесты доставляется в номер за 1.5-2 часа до церемонии. Финальная сверка с фотографом и планером." },
        ],

        compareTitle: "Сравнение пакетов",
        compareSubtitle: "Все различия в одной таблице — чтобы вы могли выбрать осознанно.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Стартовая цена", values: ["от €2 500", "от €5 000", "от €9 000"] },
          { feature: "Гостей", values: ["до 30", "до 50", "100+"] },
          { feature: "Букет невесты", values: ["Классический", "Каскадный", "Премиум с пионами"] },
          { feature: "Бутоньерки", values: ["Жених", "Жених + 2 шафера", "Вся свадебная команда"] },
          { feature: "Свадебная арка", values: ["Компактная", "Полноразмерная", "Эксклюзивный концепт"] },
          { feature: "Композиции на столы", values: [false, "6–8 столов", "10+ столов"] },
          { feature: "Лепестки для прохода", values: [false, true, true] },
          { feature: "Цветочная стена / фотозона", values: [false, false, true] },
          { feature: "Декор сладкого стола", values: [false, true, true] },
          { feature: "Декор машины и яхты", values: [false, false, true] },
          { feature: "Day-of флорист на месте", values: [false, false, true] },
          { feature: "Демонтаж после церемонии", values: [true, true, true] },
        ],

        relatedEyebrow: "ПОЛЕЗНЫЕ СТАТЬИ",
        relatedTitle: "Подробнее о цветах",
        relatedTitleAccent: "и свадьбах в Бодруме",
        relatedSubtitle: "Гайды, советы и реальные истории — всё что мы знаем о свадебной флористике в Бодруме.",
        relatedAll: "ВСЕ СТАТЬИ БЛОГА",

        bottomCtaTitle: "Расскажите о вашей",
        bottomCtaTitleAccent: "свадьбе",
        bottomCtaSubtitle:
          "Свяжитесь с нами — пришлём персональный мудборд и смету в течение 24 часов. Консультация бесплатная.",
        contactBadges: [
          { title: "Ответ в WhatsApp", subtitle: "В течение часа" },
          { title: "Бесплатный мудборд", subtitle: "И предварительная смета" },
          { title: "Бодрум и окрестности", subtitle: "Весь полуостров" },
          { title: "От 10 до 300 гостей", subtitle: "Любой формат" },
        ],
        contactCta: "СВЯЗАТЬСЯ С НАМИ",

        faqTitle: "Часто задаваемые вопросы",
        faq: [
          {
            q: "За сколько времени нужно бронировать свадебное оформление?",
            a: "Для полного оформления (арка, столы, фотозона, букет невесты) — за 2-3 месяца до даты. Это позволяет согласовать палитру, зарезервировать редкие сорта (например, пионы Дэвид Остин) и провести пробный букет. Минимум — 3 недели для пакета Signature. Букет невесты отдельно можем сделать за 5-7 дней в сезон.",
          },
          {
            q: "Сколько стоит свадебная флористика в Бодруме?",
            a: "Стартовая стоимость — €2500 (пакет Essential для камерной свадьбы). Signature на 50 гостей — от €5000. Bespoke для 100+ гостей с премиум-цветами — от €9000. Каждая смета индивидуальна, мы пришлём детальный расчёт после короткой консультации.",
          },
          {
            q: "Работаете ли вы с отелями Mandarin Oriental, Caresse, EDITION?",
            a: "Да, мы регулярно оформляем свадьбы во всех premium-отелях Бодрума: Mandarin Oriental, Caresse, EDITION, Maxx Royal, Six Senses Kaplankaya, Kempinski. Знаем требования к доступу, тайминги, согласования с банкетной службой и wedding-планерами.",
          },
          {
            q: "Делаете ли вы выездные церемонии на пляже / у воды?",
            a: "Да. У нас большой опыт работы на пляжных локациях Ялыкавак, Тюркбюкю, Гюмюшлюк, Битез. Учитываем особенности — солёный ветер, песок, заход солнца — и используем устойчивые композиции, которые выдерживают условия 6+ часов.",
          },
          {
            q: "Можно ли заказать оформление если я не нахожусь в Турции?",
            a: "Да, большинство наших невест организуют свадьбу дистанционно. Мы согласуем концепт через Zoom/WhatsApp, присылаем мудборд и эскизы. Оплата картой, переводом или Wise. Полное сопровождение на русском или английском.",
          },
          {
            q: "Что делать если мне не понравится финальный букет?",
            a: "До установки мы присылаем фото готового букета невесты на одобрение. Если есть критические замечания — успеваем переделать. Но за всё время работы такого практически не было — благодаря пробному букету и детальному мудборду.",
          },
        ],
      },
      en: {
        title: "Wedding Floristry in Bodrum — Premium Wedding Design | YUCCA",
        description:
          "Turnkey wedding floral design in Bodrum: bridal bouquet, arch, ceremony, banquet, photo zone. Premium floristry for Mandarin Oriental, Caresse, EDITION. From €2500. Get a quote within 24 hours.",
        keywords:
          "wedding florist Bodrum, wedding flowers Bodrum, bridal bouquet Bodrum, wedding arch Bodrum, wedding floral design Bodrum, destination wedding florist Turkey, luxury wedding flowers Bodrum",
        heroEyebrow: "WEDDING FLORISTRY",
        heroTitle: "A wedding that stays",
        heroTitleAccent: "in memory forever",
        heroSubtitle:
          "Premium floral design for weddings in Bodrum — from the bridal bouquet to full ceremony and banquet decor. We work with every leading hotel on the peninsula.",
        ctaPrimary: "GET A QUOTE",
        ctaSecondary: "VIEW OUR WORK",
        badges: [
          { title: "BESPOKE DESIGNS", subtitle: "Tailored to your wedding" },
          { title: "ON-TIME DELIVERY", subtitle: "Set up before ceremony" },
          { title: "ALL BODRUM AREA", subtitle: "Hotels, villas, beaches" },
          { title: "PHOTO CONFIRMATION", subtitle: "Before & after setup" },
        ],

        elementsEyebrow: "WHAT'S INCLUDED",
        elementsTitle: "Every detail — thoughtfully designed",
        elements: [
          {
            title: "Bridal bouquet",
            text: "The main accent. Cascade, round or asymmetric — matched to your dress and palette.",
          },
          {
            title: "Boutonnieres & corsages",
            text: "Groom, groomsmen, bridesmaids. Miniature compositions that unite the wedding party.",
          },
          {
            title: "Ceremony arch",
            text: "The heart of the ceremony. Eucalyptus, peonies, ranunculus — or an exclusive concept.",
          },
          {
            title: "Tablescape design",
            text: "Low arrangements for guest conversation or tall designs for a celebratory atmosphere.",
          },
          {
            title: "Aisle florals",
            text: "Petals, garlands, lanterns — the bride's path to the groom.",
          },
          {
            title: "Photo backdrop",
            text: "Floral wall or arch for portraits — every wedding frame is perfect.",
          },
          {
            title: "Confetti petals",
            text: "The final note — guests shower the newlyweds after the ceremony.",
          },
          {
            title: "Car & yacht decor",
            text: "Floral styling for the wedding car or yacht — for a ceremonial exit.",
          },
        ],

        packagesEyebrow: "WEDDING PACKAGES",
        packagesTitle: "Three formats",
        packagesTitleAccent: "for your wedding",
        packagesSubtitle:
          "Each package is a starting point. Every detail is discussed and adapted to your event.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Intimate wedding",
            priceFrom: "from €2,500",
            description:
              "Perfect for an intimate ceremony or elopement. Bridal bouquet, groom's boutonniere, compact floral arch.",
            features: [
              "Bridal bouquet",
              "Groom's boutonniere",
              "Compact floral arch",
              "Groomsmen boutonnieres (up to 2)",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Up to 50 guests",
            priceFrom: "from €5,000",
            description:
              "The most popular package. Full ceremony and banquet decor for a classic wedding.",
            features: [
              "Cascade bridal bouquet",
              "Groom & groomsmen boutonnieres",
              "Bridesmaid wrist corsages",
              "Full-size floral arch",
              "Centerpieces for 6-8 tables",
              "Aisle petals",
              "Sweet table styling",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "100+ guests",
            priceFrom: "from €9,000",
            description:
              "Premium format with David Austin peonies, phalaenopsis orchids, exclusive greenery. Full day-of service.",
            features: [
              "Premium bridal bouquet",
              "Exclusive elaborate arch",
              "Floral wall / photo zone",
              "Centerpieces for 10+ tables",
              "Car and/or yacht decor",
              "On-site day-of florist",
              "Post-ceremony breakdown",
            ],
          },
        ],

        seasonTitle: "Best time for a wedding",
        seasonTitleAccent: "in Bodrum",
        seasonEyebrow: "SEASONALITY",
        seasonSubtitle:
          "Each month in Bodrum has its own character. This helps you choose the date and bouquet composition.",
        seasons: [
          {
            period: "MAY — JUNE",
            label: "Peak season",
            text: "Perfect weather, long daylight. Local peonies, ranunculus, David Austin garden roses are at their best.",
          },
          {
            period: "JULY — AUGUST",
            label: "High season",
            text: "Hot during the day, but ceremonies after 5pm are magic. Imported peonies, orchids and exotics always available.",
          },
          {
            period: "SEPTEMBER — OCTOBER",
            label: "Golden autumn",
            text: "Warm sea, soft light. Ranunculus returns, dahlias, berries and burgundy accents come in.",
          },
          {
            period: "NOVEMBER — APRIL",
            label: "Indoor season",
            text: "Intimate hotel weddings. Imported peonies from the Netherlands and Ecuador, tulips, narcissus.",
          },
        ],

        processEyebrow: "HOW WE WORK",
        processTitle: "From the first message",
        processTitleAccent: "to the final petal",
        processSubtitle:
          "A transparent process with no surprises. You know what's happening at every step.",
        processSteps: [
          {
            num: "01",
            title: "Introduction",
            text: "Zoom or WhatsApp. We discuss date, venue, size, style, budget. Free of charge.",
          },
          {
            num: "02",
            title: "Moodboard & quote",
            text: "We send a visual concept and detailed quote. We refine until it fully matches your vision.",
          },
          {
            num: "03",
            title: "Booking & deposit",
            text: "A 30% deposit locks in the date and scope. We reserve rare varieties (David Austin peonies, for example).",
          },
          {
            num: "04",
            title: "Final review",
            text: "Two weeks before — a meeting with the final moodboard and timing. Every detail confirmed.",
          },
          {
            num: "05",
            title: "Wedding day",
            text: "Setup from early morning. The bridal bouquet is delivered to the room 1.5-2 hours before the ceremony.",
          },
          {
            num: "06",
            title: "Breakdown",
            text: "After the celebration we carefully remove all arrangements and leave the venue spotless.",
          },
        ],

        venuesTitle: "We work with the finest hotels",
        venuesEyebrow: "VENUES",
        venuesSubtitle:
          "We know the access specifics, logistics and timings of Bodrum's leading hotels and villas.",

        galleryEyebrow: "OUR WORK",
        galleryTitle: "Weddings we have",
        galleryTitleAccent: "designed in Bodrum",
        gallerySubtitle:
          "Every wedding tells its own story. Seaside arches, sunset banquets, photo zones for unforgettable moments.",
        galleryCta: "We want a wedding like this",

        hookQuote: "One day. Hundreds of details.",
        hookQuoteAccent: "Only one chance to get it right.",
        hookSubtitle: "We have done it over 80 times — on the beaches of Yalıkavak, in the gardens of Mandarin Oriental, under the arches of Six Senses. Every wedding is its own project we prepare for over 2-3 months.",
        hookStats: [
          { value: "80+", label: "weddings in Bodrum" },
          { value: "10", label: "years on the peninsula" },
          { value: "5.0", label: "average rating" },
          { value: "24 h", label: "reply to enquiries" },
        ],

        seoEyebrow: "WEDDING FLORISTRY IN BODRUM",
        seoTitle: "Seaside weddings in Turkey —",
        seoTitleAccent: "premium destination floristry",
        seoBlocks: [
          {
            heading: "Wedding florist in Bodrum, end to end",
            image: "/weddings/bodrum/seo-1.webp",
            imageAlt: "Wedding arch with white roses and candles at sunset by the sea in Bodrum",
            content: "YUCCA Flowers is a premium wedding florist in Bodrum. We specialise in floral design for weddings in Turkey for international couples choosing the Aegean coast for their destination wedding. Over 10 years on the peninsula we have designed more than 80 weddings in Bodrum — from intimate beachfront ceremonies for 20 guests to luxury 300-guest celebrations at Mandarin Oriental, Caresse, The Bodrum EDITION and Six Senses Kaplankaya. Wedding decor in Bodrum is more than the bridal bouquet and an arch: it is a coordinated floral concept from the welcome zone to banquet and photo backdrop.",
          },
          {
            heading: "Outdoor wedding ceremony and arch by the sea",
            image: "/weddings/bodrum/seo-2.webp",
            imageAlt: "White wedding arch with roses over an infinity pool overlooking Bodrum bay",
            content: "Outdoor wedding ceremonies in Bodrum take place on the beaches of Yalıkavak, Türkbükü, Gölturkbuku, Gümüşlük, Bitez, Gökova and Yalıçiftlik. We design wedding arches on the pier, hotel terrace or by the infinity pool with Aegean Sea views. In season we work with David Austin peonies, garden roses, lisianthus, baby's breath, ranunculus, phalaenopsis orchids and eucalyptus. We also create aisle florals, photo backdrops, candles in glass hurricanes, and bespoke arch designs. Wedding flowers in Bodrum need to handle sea breeze, salt air and 6+ hours under direct sun — and ours do.",
          },
          {
            heading: "Banquet, tablescape and wedding decor for your guests",
            image: "/weddings/bodrum/seo-3.webp",
            imageAlt: "Wedding banquet table in white palette with floral runner and sea view — Bodrum",
            content: "Wedding banquet design in Bodrum is the most photographed part of any celebration. We create low and tall centerpieces for long banquet tables, eucalyptus and white rose garlands, fresh-flower runners, vintage candle holders, and individual place-setting decor. We work alongside wedding planners in Turkey, photographers and Bodrum event agencies. Wedding floral design budget in Bodrum starts at €2,500 for our Essential package (intimate ceremony), €5,000 for Signature up to 50 guests, and €9,000+ for Bespoke 100+ guest events with premium flowers imported from Ecuador, Kenya and the Netherlands.",
          },
        ],
        seoServiceTitle: "What's included in wedding floral design in Bodrum",
        seoServices: [
          "Bridal bouquet in Bodrum (cascade, round, asymmetric)",
          "Groom, groomsmen and father-of boutonnieres",
          "Bridesmaid wrist corsages",
          "Floral wedding arch for seaside ceremony",
          "Aisle florals and rose petals",
          "Tablescape: centerpieces for banquet tables",
          "Floral runners and eucalyptus garlands",
          "Photo backdrop / floral wall for portraits",
          "Sweet table and wedding cake floral decor",
          "Floral design for the wedding car and yacht",
          "Welcome zone and reception cocktail decor",
          "Post-ceremony breakdown — the venue is left spotless",
        ],
        seoLocationsTitle: "We work across the entire Bodrum peninsula",
        seoLocations: [
          "Yalıkavak", "Türkbükü", "Gölturkbuku", "Bitez", "Gümüşlük", "Gökova",
          "Yalıçiftlik", "Torba", "Gündoğan", "Kuadaş", "Akyarlar", "Turgutreis",
        ],
        seoFinal: "A wedding in Bodrum is a destination wedding on one of Turkey's most scenic coasts. Aegean Sea, Mediterranean climate from May to October, 5★ luxury hotels and villas, direct flights from Europe, the Middle East and the CIS. If you are planning a wedding abroad, looking for a wedding floral designer in Turkey, or wondering how much wedding floral design in Bodrum costs — message us on WhatsApp: we will send a personalised moodboard and quote within 24 hours.",
        seoCta: "Get a quote for a Bodrum wedding",

        partnersEyebrow: "TRUSTED BY",
        partnersTitle: "Premium hotels and villas where we have designed weddings",
        partners: [
          "MANDARIN ORIENTAL", "CARESSE", "THE BODRUM EDITION", "MAXX ROYAL",
          "SIX SENSES KAPLANKAYA", "KEMPINSKI", "LUJO HOTEL", "MACAKIZI", "BODRUM LOFT", "D-HOTEL MARIS",
        ],

        testimonialsEyebrow: "WORDS FROM BRIDES",
        testimonialsTitle: "What couples say after",
        testimonialsTitleAccent: "trusting us with their day",
        testimonialsSubtitle: "80+ weddings in Bodrum — and every single one stays with us. Here are a few stories.",
        testimonials: [
          {
            quote: "We planned our wedding remotely from London — and in 3 months YUCCA created exactly what we had in our moodboard. The peony arch on the Caresse pier was so beautiful guests couldn't believe the flowers were real.",
            name: "Anna & Mikhail",
            location: "Caresse Bodrum",
            date: "June 2025",
            rating: 5,
          },
          {
            quote: "When the bride saw her cascade bouquet she burst into tears. Two hours before the ceremony, we already knew the day would be perfect. Thank you for caring about every single detail.",
            name: "Elizabeth & Arthur",
            location: "Mandarin Oriental Bodrum",
            date: "September 2024",
            rating: 5,
          },
          {
            quote: "I thought a wedding in Turkey meant compromising on my expectations. YUCCA proved otherwise — their floristry is on par with the top wedding designers in Paris. Six Senses was unrecognisable.",
            name: "Sophia & David",
            location: "Six Senses Kaplankaya",
            date: "May 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "BOOK A CONSULTATION",
        leadTitle: "Tell us about your",
        leadTitleAccent: "wedding",
        leadSubtitle: "We will send a personalised moodboard and preliminary quote within 24 hours. Consultation is free.",
        leadFields: {
          name: "Your name",
          contact: "WhatsApp / Telegram / Email",
          date: "Wedding date (if known)",
          guests: "Number of guests",
          budget: "Approximate budget",
          budgetOptions: ["Not yet decided", "Up to €3,000", "€3,000 – €6,000", "€6,000 – €10,000", "€10,000+"],
          guestsOptions: ["Not yet decided", "Up to 20", "20–50", "50–100", "100–200", "200+"],
          message: "Tell us about your wedding — venue, style, wishes",
          submit: "Send enquiry",
          sending: "Sending…",
          successTitle: "Thank you!",
          successText: "We have received your enquiry and will reach out within 24 hours with a personalised moodboard and quote.",
          errorText: "Couldn't send. Please message us on WhatsApp — we'll receive it instantly.",
          required: "Please fill in name and contact",
        },

        timelineEyebrow: "YOUR WEDDING CALENDAR",
        timelineTitle: "From the first message",
        timelineTitleAccent: "to the final petal",
        timelineSubtitle: "A transparent timeline with no surprises. You always know what is happening and when.",
        timeline: [
          { when: "3 MONTHS BEFORE", title: "Discovery & concept", text: "Free Zoom consultation. We discuss date, venue, style, budget. Moodboard is sent." },
          { when: "2.5 MONTHS BEFORE", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties — David Austin peonies from the Netherlands." },
          { when: "1 MONTH BEFORE", title: "Final palette", text: "We approve exact shades, number of arrangements, setup timing. Coordinated with the hotel banquet team." },
          { when: "2 WEEKS BEFORE", title: "Sign-off meeting", text: "Final moodboard with reference photos. Every detail agreed — no surprises on the day." },
          { when: "DAY -1", title: "Setup from sunrise", text: "Our team is on site from 6 am. Arch, tables, photo zone, aisle — all ready 4 hours before the ceremony." },
          { when: "WEDDING DAY", title: "Bridal bouquet at 2 pm", text: "Delivered to the bride's room 1.5-2 hours before the ceremony. Final sync with photographer and planner." },
        ],

        compareTitle: "Compare packages",
        compareSubtitle: "All the differences in one table — so you can choose with confidence.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Starting price", values: ["from €2,500", "from €5,000", "from €9,000"] },
          { feature: "Guests", values: ["up to 30", "up to 50", "100+"] },
          { feature: "Bridal bouquet", values: ["Classic", "Cascade", "Premium with peonies"] },
          { feature: "Boutonnieres", values: ["Groom", "Groom + 2 groomsmen", "Whole wedding party"] },
          { feature: "Wedding arch", values: ["Compact", "Full size", "Bespoke design"] },
          { feature: "Table centerpieces", values: [false, "6–8 tables", "10+ tables"] },
          { feature: "Aisle petals", values: [false, true, true] },
          { feature: "Floral wall / photo backdrop", values: [false, false, true] },
          { feature: "Sweet table decor", values: [false, true, true] },
          { feature: "Wedding car & yacht decor", values: [false, false, true] },
          { feature: "On-site day-of florist", values: [false, false, true] },
          { feature: "Post-ceremony breakdown", values: [true, true, true] },
        ],

        relatedEyebrow: "READ MORE",
        relatedTitle: "About flowers",
        relatedTitleAccent: "and weddings in Bodrum",
        relatedSubtitle: "Guides, tips and real stories — everything we know about wedding floristry in Bodrum.",
        relatedAll: "ALL BLOG ARTICLES",

        bottomCtaTitle: "Tell us about your",
        bottomCtaTitleAccent: "wedding",
        bottomCtaSubtitle:
          "Contact us — we'll send a personalised moodboard and quote within 24 hours. Consultation is free.",
        contactBadges: [
          { title: "Quick WhatsApp reply", subtitle: "Within an hour" },
          { title: "Free moodboard", subtitle: "& preliminary quote" },
          { title: "Bodrum & surroundings", subtitle: "The whole peninsula" },
          { title: "10 to 300 guests", subtitle: "Any format" },
        ],
        contactCta: "CONTACT US",

        faqTitle: "Frequently asked questions",
        faq: [
          {
            q: "How far in advance should I book wedding floral design?",
            a: "For a full setup (arch, tables, photo zone, bridal bouquet) — 2 to 3 months ahead. This lets us match the palette, reserve rare varieties (David Austin peonies, for example) and make a trial bouquet. Minimum — 3 weeks for the Signature package. A standalone bridal bouquet can be made in 5-7 days during the season.",
          },
          {
            q: "How much does wedding floral design in Bodrum cost?",
            a: "Starting from €2,500 (Essential package for an intimate wedding). Signature for 50 guests — from €5,000. Bespoke for 100+ guests with premium varieties — from €9,000. Every quote is individual; we'll send a detailed proposal after a short consultation.",
          },
          {
            q: "Do you work with hotels Mandarin Oriental, Caresse, EDITION?",
            a: "Yes, we regularly design weddings at all premium hotels in Bodrum: Mandarin Oriental, Caresse, EDITION, Maxx Royal, Six Senses Kaplankaya, Kempinski. We know access requirements, timings and how to coordinate with the banquet team and wedding planners.",
          },
          {
            q: "Do you do outdoor / beachside ceremonies?",
            a: "Yes. We have extensive experience at beach locations Yalıkavak, Türkbükü, Gümüşlük, Bitez. We account for the conditions — sea wind, sand, sunset timing — and use resilient compositions that hold up for 6+ hours.",
          },
          {
            q: "Can I book if I'm not in Turkey?",
            a: "Yes, most of our brides organise everything remotely. We agree the concept via Zoom/WhatsApp, send a moodboard and sketches. Payment by card, transfer or Wise. Full support in Russian or English.",
          },
          {
            q: "What if I don't like the final bouquet?",
            a: "Before setup we send a photo of the finished bridal bouquet for approval. If there are critical issues — we have time to redo it. In practice this almost never happens thanks to the trial bouquet and detailed moodboard.",
          },
        ],
      },
      tr: {
        title: "Bodrum'da Dugun Cicekleri — Premium Dugun Tasarimi | YUCCA Flowers",
        description: "Bodrum'da anahtar teslim dugun cicek tasarimi: gelin buketi, kemer, toren, banket, foto alani. Mandarin Oriental, Caresse, EDITION ve The EDITION icin premium ciceklendirme. €2.500'den itibaren. 24 saat icinde teklif.",
        keywords: "bodrum dugun cicekleri, bodrum dugun florist, gelin buketi bodrum, dugun kemeri bodrum, destination wedding turkiye, mandarin oriental dugun, caresse dugun, six senses kaplankaya dugun",

        heroEyebrow: "BODRUM — TURKIYE",
        heroTitle: "Sonsuza dek hatirlanacak",
        heroTitleAccent: "bir dugun",
        heroSubtitle: "Bodrum'un en iyi otel ve villalarinda anahtar teslim premium ciceklendirme. Gelin buketinden banket tasarimina kadar. €2.500'den.",
        ctaPrimary: "TEKLIF AL",
        ctaSecondary: "Ornekleri gor",

        badges: [
          { title: "10 YIL", subtitle: "Bodrum'da deneyim" },
          { title: "80+", subtitle: "tasarlanan dugun" },
          { title: "MANDARIN, CARESSE", subtitle: "EDITION, SIX SENSES" },
          { title: "24 SAAT", subtitle: "yanit suresi" },
        ],

        elementsEyebrow: "NELER DAHIL",
        elementsTitle: "Dugununuzu olusturan her detay",
        elements: [
          { title: "Gelin buketi", text: "Klasik, kaskat veya bohem. Sezonun premium varyeteleriyle." },
          { title: "Damat & sagdic", text: "Damat ve sagdiclar icin yaka cicekleri. Nedimeler icin bileklik." },
          { title: "Toren kemeri", text: "Plajda, terasta, infinity havuzun yaninda. Ruzgara dayanikli." },
          { title: "Cicek koridoru", text: "Bordur, gul yapraklari, mum fenerleri ile aydinlatma." },
          { title: "Banket masalari", text: "Alcak ve yuksek kompozisyonlar. Cicek runner'lar, ferah okaliptus." },
          { title: "Foto alani", text: "Cicek duvarlar, salincaklar, kameralar — Instagram'in begenecegi pozlar." },
          { title: "Tatli masasi", text: "Pasta ve sweet zone icin ciceklendirme. Detaylar her seyi belirler." },
          { title: "Otomobil & yat", text: "Dugun aracinin ve toren teknesinin cicekle suslenmesi." },
        ],

        galleryEyebrow: "CALISMALARIMIZ",
        galleryTitle: "Bodrum'da tasarladigimiz",
        galleryTitleAccent: "dugunler",
        gallerySubtitle: "Her dugun kendi hikayesidir. Deniz kenarinda kemerler, gun batiminda banketler, foto alanlari.",
        galleryCta: "Boyle bir dugun istiyoruz",

        hookQuote: "Bir gun. Yuzlerce detay.",
        hookQuoteAccent: "Mukemmel yapmak icin tek sans.",
        hookSubtitle: "Bunu 80'den fazla kez yaptik — Yalikavak plajlarinda, Mandarin Oriental bahcelerinde, Six Senses gunbatimlarinda. Her dugun, 2-3 ay onceden hazirladigimiz benzersiz bir projedir.",
        hookStats: [
          { value: "80+", label: "Bodrum'da dugun" },
          { value: "10", label: "yil yarimadada" },
          { value: "5.0", label: "ortalama puan" },
          { value: "24 s", label: "talebe yanit" },
        ],

        partnersEyebrow: "BIZE GUVENENLER",
        partnersTitle: "Premium otel ve villalar, dugun tasarimlarimizla",
        partners: [
          "MANDARIN ORIENTAL", "CARESSE", "THE BODRUM EDITION", "MAXX ROYAL",
          "SIX SENSES KAPLANKAYA", "KEMPINSKI", "LUJO HOTEL", "MACAKIZI", "BODRUM LOFT", "D-HOTEL MARIS",
        ],

        packagesEyebrow: "PAKETLER",
        packagesTitle: "Dugun",
        packagesTitleAccent: "paketleri",
        packagesSubtitle: "Davetli sayisina ve dugun kompleksitesine gore secim. Her seyi sifirdan kisisellestiriyoruz.",
        packages: [
          {
            name: "ESSENTIAL", tagline: "Kucuk dugun", priceFrom: "€2.500'den",
            description: "30 davetliye kadar kucuk samimi torenler icin.",
            features: ["Gelin buketi", "Damat boutonniere", "Kompakt kemer", "Demontaj"],
          },
          {
            name: "SIGNATURE", tagline: "Klasik dugun", priceFrom: "€5.000'den", highlighted: true,
            description: "50 davetliye kadar dugunler. En populer paketimiz.",
            features: ["Premium gelin buketi", "Tam boyutlu kemer", "6-8 masa kompozisyonu", "Cicek runner", "Demontaj", "Yardimci florist"],
          },
          {
            name: "BESPOKE", tagline: "Luks dugun", priceFrom: "€9.000'den",
            description: "100+ davetli icin. Premium varyeteler, ozel tasarim, on-site florist.",
            features: ["Pionlu buket", "Ozel kemer", "10+ masa kompozisyonu", "Cicek duvar", "Yat ve araba dekoru", "Day-of florist", "Tatli masasi"],
          },
        ],

        seasonEyebrow: "SEZONSALLIK",
        seasonTitle: "Bodrum'da",
        seasonTitleAccent: "dugununuz icin en iyi zaman",
        seasonSubtitle: "Bodrum mayis-ekim arasi 6 ayboyunca ideal dugun sezonu. Diger aylar — kapali mekanlarda fotojenik bahar / kis dugunleri.",
        seasons: [
          { period: "MAYIS — HAZIRAN", label: "Bahar zarafeti", text: "Pioneler, sakurolar, ranunkuluslar. Yumusak isik, +25°C, denizden okyanus esintisi." },
          { period: "TEMMUZ — AGUSTOS", label: "Yaz pikleri", text: "Tropikal varyeteler, orkide. Anlamli daha gec saatler — 17:00 sonrasi." },
          { period: "EYLUL — EKIM", label: "Sicak sonbahar", text: "Bahce gulleri, dahliyalar, okaliptus. Resmen dahil olunan en uygun mevsim." },
          { period: "KASIM — NISAN", label: "Kis kapali mekan", text: "Pioneler her zaman + Hollanda'dan teslimat. Kapali mekan dugunleri, gun batimi kalitesi muthis." },
        ],

        timelineEyebrow: "DUGUN TAKVIMINIZ",
        timelineTitle: "Ilk mesajdan",
        timelineTitleAccent: "son tac yapragina",
        timelineSubtitle: "Suprizsiz seffaf zaman cizelgesi. Ne zaman ne yapilacagini her zaman bilirsiniz.",
        timeline: [
          { when: "3 AY ONCE", title: "Tanisma ve konsept", text: "Zoom konsultasyon ucretsiz. Tarih, mekan, tarz, butce tartisilir. Moodboard gonderilir." },
          { when: "2.5 AY ONCE", title: "Rezervasyon ve depozit", text: "%30 depozit tarihi sabitler. Hollanda'dan David Austin pioneleri rezerve edilir." },
          { when: "1 AY ONCE", title: "Final palet", text: "Tonlar, kompozisyon sayisi, kurulum zamanlamasi onaylanir. Otel banket ekibiyle koordinasyon." },
          { when: "2 HAFTA ONCE", title: "Sign-off toplantisi", text: "Referans fotograflari ile final moodboard. Tum detaylar uzerinde anlasildi — gunde surpriz yok." },
          { when: "1 GUN ONCE", title: "Sabah erkenden kurulum", text: "Ekip sabah 6'dan itibaren mekanda. Kemer, masalar, foto alani — toren oncesi 4 saat onceden hazir." },
          { when: "DUGUN GUNU", title: "Gelin buketi 14:00", text: "Buket toren oncesi 1.5-2 saat gelinin odasina teslim edilir. Fotografci ve planner ile final senkron." },
        ],

        compareTitle: "Paket karsilastirmasi",
        compareSubtitle: "Tum farklar tek tabloda — bilincli secim icin.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Baslangic fiyati", values: ["€2.500'den", "€5.000'den", "€9.000'den"] },
          { feature: "Davetli", values: ["30'a kadar", "50'ye kadar", "100+"] },
          { feature: "Gelin buketi", values: ["Klasik", "Kaskat", "Pionlu premium"] },
          { feature: "Boutonnieres", values: ["Damat", "Damat + 2 sagdic", "Tum ekip"] },
          { feature: "Dugun kemeri", values: ["Kompakt", "Tam boy", "Ozel tasarim"] },
          { feature: "Masa kompozisyonlari", values: [false, "6–8 masa", "10+ masa"] },
          { feature: "Koridor yapraklari", values: [false, true, true] },
          { feature: "Cicek duvar / foto", values: [false, false, true] },
          { feature: "Tatli masa dekoru", values: [false, true, true] },
          { feature: "Araba ve yat dekoru", values: [false, false, true] },
          { feature: "Gunluk florist", values: [false, false, true] },
          { feature: "Toren sonrasi demontaj", values: [true, true, true] },
        ],

        testimonialsEyebrow: "GELIN GORUSLERI",
        testimonialsTitle: "YUCCA'ya gunlerini emanet eden",
        testimonialsTitleAccent: "ciftlerin sozleri",
        testimonialsSubtitle: "80+ dugun Bodrum'da — ve her biri kalbimizde kalir. Iste birkac hikaye.",
        testimonials: [
          { quote: "Dugunumuzu Londra'dan uzaktan planladik — ve 3 ayda YUCCA tam olarak moodboard'da gordugumuz seyi yarattilar. Caresse iskelesindeki pion kemeri o kadar guzeldi ki davetliler gercek cicek oldugune inanamadilar.", name: "Anna & Mikhail", location: "Caresse Bodrum", date: "Haziran 2025", rating: 5 },
          { quote: "Gelin kaskat buketini gordugunde gozyaslarina boguldu. Toren oncesi 2 saat kalmissti ve gunun mukemmel olacagini biliyorduk. Her detayindaki ozeni icin tesekkurler.", name: "Elizabeth & Arthur", location: "Mandarin Oriental Bodrum", date: "Eylul 2024", rating: 5 },
          { quote: "Turkiye'de dugunun beklentilerimi kompromise edecegini sanmistim. YUCCA aksini kanitladi: ciceklendirme Paris'in en iyi wedding-designer'lariyla ayni seviyede. Six Senses tanimazsiz hale geldi.", name: "Sophia & David", location: "Six Senses Kaplankaya", date: "Mayis 2024", rating: 5 },
        ],

        venuesTitle: "En iyi otellerle calisyoruz",
        venuesEyebrow: "MEKANLAR",
        venuesSubtitle: "Bodrum'un lider otel ve villalarin erisim, lojistik ve zamanlama ozelliklerini biliyoruz.",

        bottomCtaTitle: "Hadi sizin",
        bottomCtaTitleAccent: "dugununuzu yaratalim",
        bottomCtaSubtitle: "24 saat icinde kisisel moodboard ve on teklif. Konsultasyon ucretsiz.",
        contactCta: "BIZE ULASIN",
        contactBadges: [
          { title: "WhatsApp", subtitle: "24 saat icinde" },
          { title: "Zoom konsultasyon", subtitle: "Ucretsiz" },
          { title: "Tum Bodrum", subtitle: "+ cevre koylar" },
          { title: "Premium varyeteler", subtitle: "Ekvador, Kenya, Hollanda" },
        ],

        faqTitle: "Sik sorulan sorular",
        faq: [
          { q: "Dugunden kac ay once siparis vermek gerekir?", a: "Mayis-eylul peak sezonda — minimum 4-6 ay onceden. Shoulder-sezonda (ekim-nisan) — 2-3 ay yeterli." },
          { q: "Ucretsiz konsultasyon yapiyor musunuz?", a: "Evet, Zoom uzerinden ilk konsultasyon ve moodboard tamamen ucretsiz. Sadece imzaladiktan sonra %30 depozit aliyoruz." },
          { q: "Ne kadar onceden iptal edebiliriz?", a: "60+ gun once — depozit %10 logistika cikartilarak iade edilir. 30 gun icinde — depozit yeni tarihe aktarilir, iade edilmez." },
          { q: "Ruzgar / yagmurda kemer ne olur?", a: "Tum kemerlerimiz ankraj sistemleriyle (5 beaufort'a kadar) tasarlanir. Yagmur durumunda — Plan B (kapali mekan) onceden hazirlanir." },
          { q: "Damadin ailesi de cicek istiyor, dahil mi?", a: "Boutonniere baba/abi/ennise — paketleri ozelle kombinasyon yapiyoruz. Sirayla teklif ediyoruz." },
          { q: "Buket bana hic yakismazsa?", a: "Kurulumdan once gelin buketinin fotografini onay icin gonderiyoruz. Kritik sorun varsa — yeniden yapmaya vaktimiz var. Trial buket ve detayli moodboard sayesinde pratikte hic olmuyor." },
        ],

        seoEyebrow: "BODRUM'DA DUGUN CICEKLERI",
        seoTitle: "Turkiye'de deniz kenari dugunu —",
        seoTitleAccent: "premium destination ciceklendirme",
        seoBlocks: [
          {
            heading: "Bodrum'da anahtar teslim dugun cicekcisi",
            image: "/weddings/bodrum/seo-1.webp",
            imageAlt: "Bodrum'da gun batiminda denizin yanindaki beyaz gullerle ve mumlarla dugun kemeri",
            content: "YUCCA Flowers — Bodrum'da premium dugun ciceklendirme. Ege kiyisinda destination wedding secen ciftler icin Turkiye'de dugun ciceklendirmesinde uzmaniz. 10 yil yarimada calismasi ile 80+ dugun tasarladik — Mandarin Oriental, Caresse, The Bodrum EDITION ve Six Senses Kaplankaya'da intimate beachfront torenlerden 300 kisilik luks kutlamalara kadar. Bodrum'da dugun dekorasyonu sadece gelin buketi ve kemer degildir: welcome zone'dan banket ve foto alanina kadar koordine cicek konsepti.",
          },
          {
            heading: "Outdoor toren ve deniz kenari kemeri",
            image: "/weddings/bodrum/seo-2.webp",
            imageAlt: "Bodrum korfez manzarali infinity havuzun yaninda gullerle beyaz dugun kemeri",
            content: "Bodrum'da outdoor dugun toreni Yalikavak, Turkbuku, Goltuurkbuku, Gumusluk, Bitez, Gokova ve Yaliciftlik plajlarinda gerceklesir. Iskelede, otel terasinda veya Ege Denizi manzarali infinity havuzun yaninda dugun kemerleri tasarliyoruz. Sezonda David Austin pioneleri, bahce gulleri, lisianthus, gypsofila, ranunkuluslar, falenopsis orkideleri ve okaliptus ile calisiyoruz. Ayrica koridor ciceklendirmesi, foto backdrop'larini, cam kulturlerde mumlari ve ozel kemer tasarimlarini yaratiyoruz.",
          },
          {
            heading: "Banket, tablescape ve davetliler icin dekor",
            image: "/weddings/bodrum/seo-3.webp",
            imageAlt: "Bodrum'da deniz manzarali, cicek runner ile beyaz palet'te dugun banket masasi",
            content: "Bodrum'da dugun banket tasarimi her kutlamalarin en cok fotograflanan kismidir. Uzun banket masalari icin alcak ve yuksek kompozisyonlar, okaliptus ve beyaz gul calenderi, taze cicek runner'lar, vintage mum sahipleri ve bireysel place-setting dekoru yaratiyoruz. Turkiye'deki dugun planlayicilari, fotografcilar ve Bodrum event agency'leri ile birlikte calisiyoruz. Bodrum'da dugun cicek tasarim butcesi Essential paketi (intimate toren) icin €2.500, 50 davetliye kadar Signature icin €5.000, 100+ davetli icin Bespoke icin €9.000+'dan baslar.",
          },
        ],
        seoServiceTitle: "Bodrum'da dugun cicek tasarimina dahil olanlar",
        seoServices: [
          "Bodrum'da gelin buketi (kaskat, yuvarlak, asimetrik)",
          "Damat, sagdiclar ve baba boutonnieres",
          "Nedime bileklikleri",
          "Deniz kenari toreni icin cicek dugun kemeri",
          "Koridor ciceklendirmesi ve gul yapraklari",
          "Banket masalari icin tablescape",
          "Cicek runner'lar ve okaliptus calenderlerleri",
          "Portreler icin foto backdrop / cicek duvar",
          "Tatli masa ve dugun pastasi cicek dekoru",
          "Dugun otomobili ve yat icin cicek tasarimi",
          "Welcome zone ve karsilama kokteyl dekoru",
          "Toren sonrasi demontaj — mekan tertemiz birakilir",
        ],
        seoLocationsTitle: "Tum Bodrum yarimadasinda calisiyoruz",
        seoLocations: [
          "Yalikavak", "Turkbuku", "Goltuurkbuku", "Bitez", "Gumusluk", "Gokova",
          "Yaliciftlik", "Torba", "Gundogan", "Kuadas", "Akyarlar", "Turgutreis",
        ],
        seoFinal: "Bodrum'da bir dugun, Turkiye'nin en guzel kiyilarindan birinde destination wedding'dir. Ege Denizi, mayis-ekim arasi Akdeniz iklimi, 5★ luks otel ve villalar, Avrupa, Orta Dogu ve BDT'den direk ucuslar. Yurt disinda bir dugun planliyorsaniz, Turkiye'de wedding floral designer ariyorsaniz veya Bodrum'da dugun cicek tasariminin ne kadar tuttugunu merak ediyorsaniz — bize WhatsApp'tan yazin: 24 saat icinde kisisellestirilmis moodboard ve teklif gonderecegiz.",
        seoCta: "Bodrum dugunu icin teklif al",

        leadEyebrow: "KONSULTASYON BASVURUSU",
        leadTitle: "Dugununuzu bize",
        leadTitleAccent: "anlatin",
        leadSubtitle: "24 saat icinde kisisel moodboard ve on teklif gonderecegiz. Konsultasyon ucretsiz.",
        leadFields: {
          name: "Adiniz",
          contact: "WhatsApp / Telegram / Email",
          date: "Dugun tarihi (varsa)",
          guests: "Davetli sayisi",
          budget: "Yaklasik butce",
          budgetOptions: ["Henuz belli degil", "€3.000'a kadar", "€3.000 – €6.000", "€6.000 – €10.000", "€10.000+"],
          guestsOptions: ["Henuz belli degil", "20'ye kadar", "20–50", "50–100", "100–200", "200+"],
          message: "Dugununuzu anlatin — mekan, tarz, istekler",
          submit: "Basvuruyu gonder",
          sending: "Gonderiliyor…",
          successTitle: "Tesekkurler!",
          successText: "Basvurunuzu aldik, 24 saat icinde kisisellestirilmis moodboard ve teklif ile size donus yapacagiz.",
          errorText: "Gonderilemedi. WhatsApp'tan yazin — anlik aliriz.",
          required: "Ad ve iletisim bilgisi doldurun",
        },

        relatedEyebrow: "DAHA FAZLA OKU",
        relatedTitle: "Bodrum'da cicekler",
        relatedTitleAccent: "ve dugunler hakkinda",
        relatedSubtitle: "Rehberler, ipuclari ve gercek hikayeler — Bodrum dugun ciceklendirmesi hakkinda bildigimiz her sey.",
        relatedAll: "TUM BLOG MAKALELERI",

        processEyebrow: "SUREC",
        processTitle: "Nasil",
        processTitleAccent: "calisiyoruz",
        processSubtitle: "",
        processSteps: [],
      },
    },
  },
  ibiza: {
    slug: "ibiza",
    name: "Ибица",
    nameEn: "Ibiza",
    namePrepositional: "на Ибице",
    namePrepositionalEn: "in Ibiza",
    namePossessive: "Ибицы",
    namePossessiveEn: "Ibiza",
    country: { ru: "Испания", en: "Spain" },
    countryFlag: "🇪🇸",
    currency: "EUR",
    currencySymbol: "€",
    coords: { lat: 38.9067, lng: 1.4206 },
    languages: ["ru", "en"],
    heroImage: "/weddings/ibiza/hero.webp",
    venues: [
      "Six Senses Ibiza",
      "Hacienda Na Xamena",
      "Atzaró Agroturismo",
      "Cas Gasi",
      "Cala Bonita",
      "Sa Talaia",
      "Amante Beach Club",
      "Beso Beach Ibiza",
      "Cova Santa",
      "Can Domo",
    ],
    gallery: [
      { src: "/weddings/ibiza/01.webp", alt: { ru: "Свадебная сервировка с белыми пионами и свечами с видом на бухту Ибицы", en: "Wedding table setting with white peonies and candles overlooking an Ibiza cove" }, tag: { ru: "Сервировка у моря", en: "Seaside tablescape" } },
      { src: "/weddings/ibiza/02.webp", alt: { ru: "Персиковые садовые розы в нежной композиции на свадьбе на Ибице", en: "Peach garden roses in a delicate wedding centerpiece in Ibiza" }, tag: { ru: "Pastel-композиция", en: "Pastel centerpiece" } },
      { src: "/weddings/ibiza/03.webp", alt: { ru: "Розовая цветочная инсталляция на длинном столе — свадьба на Ибице", en: "Pink floral installation on a long banquet table — Ibiza wedding" }, tag: { ru: "Цветочный runner", en: "Floral runner" } },
      { src: "/weddings/ibiza/04.webp", alt: { ru: "Цветочная арка из персиковых роз с видом на бухту Cala Salada", en: "Peach rose floral arch overlooking Cala Salada bay" }, tag: { ru: "Арка с видом на море", en: "Sea-view arch" } },
      { src: "/weddings/ibiza/05.webp", alt: { ru: "Свадебная церемония на белой террасе с яхтами в бухте — Ибица", en: "Wedding ceremony on a white terrace with yachts in the bay — Ibiza" }, tag: { ru: "Церемония на террасе", en: "Terrace ceremony" } },
      { src: "/weddings/ibiza/06.webp", alt: { ru: "Длинный банкетный стол под бежевыми зонтами в оливковом саду Ибицы", en: "Long banquet table under beige umbrellas in an Ibiza olive grove" }, tag: { ru: "Banquet под оливами", en: "Olive grove banquet" } },
      { src: "/weddings/ibiza/07.webp", alt: { ru: "Свадебный банкет у бассейна с оливками и средиземноморской сосной", en: "Poolside wedding banquet with olive trees and Mediterranean pines" }, tag: { ru: "Poolside dinner", en: "Poolside dinner" } },
      { src: "/weddings/ibiza/08.webp", alt: { ru: "Бассейн с цветочной LOVE-инсталляцией и пальмами для церемонии на Ибице", en: "Pool with floral LOVE installation and palms for an Ibiza ceremony" }, tag: { ru: "LOVE-инсталляция", en: "LOVE installation" } },
      { src: "/weddings/ibiza/09.webp", alt: { ru: "Цветочная композиция на скалах над морем — церемония в Es Vedrà", en: "Floral installation on cliffs above the sea — Es Vedrà ceremony" }, tag: { ru: "Скалы Es Vedrà", en: "Es Vedrà cliffs" } },
      { src: "/weddings/ibiza/10.webp", alt: { ru: "Букет роз в керамической вазе на свадебном банкете у виллы на Ибице", en: "Rose bouquet in a ceramic vase at an Ibiza villa wedding banquet" }, tag: { ru: "Букет на вилле", en: "Villa bouquet" } },
      { src: "/weddings/ibiza/11.webp", alt: { ru: "Букет невесты из белых пионов с лентами на свадьбе на Ибице", en: "Bridal bouquet of white peonies with ribbons at an Ibiza wedding" }, tag: { ru: "Букет невесты", en: "Bridal bouquet" } },
      { src: "/weddings/ibiza/12.webp", alt: { ru: "Длинный стол с пастельными цветочными композициями в Atzaró", en: "Long table with pastel floral arrangements at Atzaró Ibiza" }, tag: { ru: "Tablescape в Atzaró", en: "Atzaró tablescape" } },
    ],
    areas: [
      { ru: "Ибица-таун (Dalt Vila)", en: "Ibiza Town (Dalt Vila)" },
      { ru: "Санта-Эулария", en: "Santa Eulària" },
      { ru: "Сан-Антонио", en: "San Antonio" },
      { ru: "Сан-Хуан (Sant Joan)", en: "Sant Joan" },
      { ru: "Эс-Кана", en: "Es Canar" },
      { ru: "Кала-Льонга", en: "Cala Llonga" },
      { ru: "Таламанка", en: "Talamanca" },
    ],
    seo: {
      ru: {
        title: "Свадебная флористика на Ибице — премиум-оформление свадеб | YUCCA",
        description:
          "Цветочное оформление свадеб на Ибице под ключ: букет невесты, арка, церемония, банкет, фотозона. Премиум-флористика для Six Senses, Atzaró, Hacienda Na Xamena, Cas Gasi. От €3500. Запросите смету за 24 часа.",
        keywords:
          "свадебная флористика Ибица, оформление свадеб Ибица, цветы на свадьбу Ибица, букет невесты Ибица, свадебная арка Ибица, флорист на свадьбу Ибица, wedding florist Ibiza, свадьба на Ибице, destination wedding Ибица, свадебный декор Испания",
        heroEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА",
        heroTitle: "Свадьба между небом",
        heroTitleAccent: "и Средиземным морем",
        heroSubtitle:
          "Премиум-флористика для свадеб на Ибице — от букета невесты до полного оформления церемонии и банкета. Работаем с лучшими виллами и агротуризмо острова.",
        ctaPrimary: "ЗАПРОСИТЬ СМЕТУ",
        ctaSecondary: "СМОТРЕТЬ ПРИМЕРЫ",
        badges: [
          { title: "DESTINATION WEDDING", subtitle: "Из любой точки мира" },
          { title: "ТОЧНО ВО ВРЕМЯ", subtitle: "Установка к началу церемонии" },
          { title: "ВСЯ ИБИЦА", subtitle: "Виллы, агротуризмо, бич-клабы" },
          { title: "ФОТО-ПОДТВЕРЖДЕНИЕ", subtitle: "До и после установки" },
        ],

        elementsEyebrow: "ЧТО ВХОДИТ В ОФОРМЛЕНИЕ",
        elementsTitle: "Каждая деталь — продумана",
        elements: [
          { title: "Букет невесты", text: "Главный акцент. Каскадный, круглый или в стиле ibicenco — в палитре вашей свадьбы." },
          { title: "Бутоньерки и браслеты", text: "Жених, шаферы, подружки невесты. Миниатюрные композиции для всей свадебной команды." },
          { title: "Свадебная арка", text: "Сердце церемонии. Оливковая зелень, пионы, английские розы или эксклюзивный концепт под скалы Es Vedrà." },
          { title: "Оформление столов", text: "Низкие composições для разговоров гостей или высокие — для торжественной атмосферы под звёздами Ибицы." },
          { title: "Цветочная дорожка", text: "Лепестки, гирлянды из бугенвиллеи, средиземноморская зелень — путь невесты к жениху." },
          { title: "Фотозона", text: "Цветочная стена или арка под пальмами — для каждого кадра свадьбы." },
          { title: "Лепестки для конфетти", text: "Финальный аккорд — гости осыпают молодожёнов после ceremonia." },
          { title: "Декор машины и яхты", text: "Цветочный декор для свадебной машины или яхты — для проезда вдоль побережья." },
        ],

        packagesEyebrow: "ПАКЕТЫ ОФОРМЛЕНИЯ",
        packagesTitle: "Три формата",
        packagesTitleAccent: "под вашу свадьбу на Ибице",
        packagesSubtitle:
          "Каждый пакет — отправная точка. Все детали обсуждаются и адаптируются под вашу виллу, концепт и количество гостей.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Камерная свадьба",
            priceFrom: "от €3 500",
            description:
              "Идеально для интимной церемонии в финке или на скрытом пляже. Букет невесты, бутоньерка жениха, компактная флористическая арка.",
            features: [
              "Букет невесты в стиле ibicenco",
              "Бутоньерка жениха",
              "Цветочная арка (компактная)",
              "Бутоньерки шаферов (до 2)",
              "Лепестки для конфетти",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Свадьба до 50 гостей",
            priceFrom: "от €7 000",
            description:
              "Самый востребованный пакет на Ибице. Полное оформление церемонии и банкетной зоны для классической destination-свадьбы.",
            features: [
              "Каскадный букет невесты",
              "Бутоньерки жениха и шаферов",
              "Браслеты подружек невесты",
              "Полноразмерная цветочная арка",
              "Композиции на 6–8 столов",
              "Цветочная дорожка / лепестки для прохода",
              "Декор сладкого стола и торта",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "Свадьба 100+ гостей",
            priceFrom: "от €15 000",
            description:
              "Премиум-формат с пионами David Austin, орхидеями фаленопсис и эксклюзивной средиземноморской флористикой. Полный day-of сервис на острове.",
            features: [
              "Премиум-букет невесты",
              "Эксклюзивная сложная арка",
              "Цветочная стена / фотозона под пальмами",
              "Композиции на 10+ столов",
              "Цветочный runner вдоль banquet-стола",
              "Декор машины и/или яхты",
              "Day-of флорист на месте",
              "Демонтаж после церемонии",
            ],
          },
        ],

        seasonTitle: "Лучшее время для свадьбы",
        seasonTitleAccent: "на Ибице",
        seasonEyebrow: "СЕЗОННОСТЬ",
        seasonSubtitle:
          "Каждый месяц на Ибице — особенный. Это поможет выбрать дату и состав букета.",
        seasons: [
          { period: "МАЙ — ИЮНЬ", label: "Пик сезона", text: "Идеальная погода, цветёт бугенвиллея, длинный световой день. В наличии локальные пионы, ранункулюсы, садовые розы David Austin из Голландии." },
          { period: "ИЮЛЬ — АВГУСТ", label: "Высокий сезон", text: "Жара, но церемонии на закате после 19:00 — магия. Импортные пионы, орхидеи, средиземноморская зелень — всегда в наличии." },
          { period: "СЕНТЯБРЬ — ОКТЯБРЬ", label: "Золотой сезон", text: "Тёплое море, мягкий свет, мало туристов. Возвращаются ранункулюсы, добавляются георгины, ягоды и бордовые акценты." },
          { period: "НОЯБРЬ — АПРЕЛЬ", label: "Indoor-сезон", text: "Камерные свадьбы на виллах. Импортные пионы из Голландии и Эквадора, тюльпаны, нарциссы, мимоза." },
        ],

        processEyebrow: "КАК МЫ РАБОТАЕМ",
        processTitle: "От первого письма",
        processTitleAccent: "до финального лепестка",
        processSubtitle: "Прозрачный процесс без сюрпризов. Вы знаете что и когда происходит на каждом этапе.",
        processSteps: [
          { num: "01", title: "Знакомство", text: "Zoom или WhatsApp. Обсуждаем дату, виллу, размер, стиль, бюджет. Бесплатно." },
          { num: "02", title: "Мудборд и смета", text: "Присылаем визуальный концепт и детальную смету. Корректируем до полного совпадения с вашим видением." },
          { num: "03", title: "Бронь и предоплата", text: "30% предоплата фиксирует дату и состав. Резервируем редкие сорта (например, пионы David Austin)." },
          { num: "04", title: "Финальная сверка", text: "За 2 недели до даты — встреча с финальным мудбордом и таймингом. Все детали согласованы." },
          { num: "05", title: "День свадьбы", text: "Установка с раннего утра. Букет невесты доставляется на виллу за 1.5–2 часа до церемонии." },
          { num: "06", title: "Демонтаж", text: "После завершения мы аккуратно убираем все композиции и оставляем локацию в идеальном состоянии." },
        ],

        venuesTitle: "Работаем с лучшими виллами и агротуризмо",
        venuesEyebrow: "ПЛОЩАДКИ",
        venuesSubtitle:
          "Знаем специфику доступа, логистики и таймингов ведущих площадок Ибицы — от Six Senses до скрытых finca в San Joan.",

        galleryEyebrow: "НАШИ РАБОТЫ",
        galleryTitle: "Свадьбы, которые мы",
        galleryTitleAccent: "оформили на Ибице",
        gallerySubtitle:
          "Каждая свадьба — своя история. Арки на скалах Es Vedrà, банкеты в оливковых рощах, церемонии у бассейнов с видом на Средиземное море.",
        galleryCta: "Хотим такую же свадьбу",

        hookQuote: "Один день. Сотни деталей.",
        hookQuoteAccent: "Только одна возможность сделать это идеально.",
        hookSubtitle: "Мы делали это уже десятки раз — на скалах Es Vedrà, в оливковых рощах Atzaró, на пляжных террасах Amante. Каждая свадьба на Ибице — это отдельный проект, к которому мы готовимся за 3–4 месяца с учётом логистики острова.",
        hookStats: [
          { value: "50+", label: "свадеб на Балеарах" },
          { value: "6", label: "лет на островах" },
          { value: "5.0", label: "средний рейтинг" },
          { value: "24 ч", label: "ответ на запрос" },
        ],

        seoEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА НА ИБИЦЕ",
        seoTitle: "Свадьба на Ибице —",
        seoTitleAccent: "destination-флористика премиум-класса",
        seoBlocks: [
          {
            heading: "Свадебный флорист на Ибице под ключ",
            image: "/weddings/ibiza/seo-1.webp",
            imageAlt: "Свадебная цветочная дорожка с белыми пионами и дельфиниумом на Ибице",
            content: "YUCCA Flowers — премиум свадебная флористика на Ибице. Мы специализируемся на цветочном оформлении свадеб в Испании для русскоязычных, европейских, британских и арабских пар, выбирающих Балеарские острова для своей destination wedding. Наша команда оформила более 50 свадеб на Ибице, Майорке и в Испании — от камерных beachfront-церемоний на 20 гостей до luxury-торжеств на 200 человек в Six Senses Ibiza, Hacienda Na Xamena, Atzaró, Cas Gasi и Cala Bonita. Оформление свадьбы на Ибице — это не только букет невесты и арка: это согласованный цветочный концепт от welcome-зоны до банкета, фотозоны и церемониального выезда на яхте.",
          },
          {
            heading: "Выездная регистрация и оформление церемонии у моря",
            image: "/weddings/ibiza/seo-2.webp",
            imageAlt: "Длинный свадебный стол в стеклянной оранжерее с ротанговыми стульями — Ибица",
            content: "Выездная свадебная церемония на Ибице проходит на скалах Es Vedrà, пляжах Cala Salada, Cala Comte, Cala Bassa, на террасах вилл с видом на Средиземное море и в исторических садах Dalt Vila. Мы оформляем свадебные арки на пирсе, террасе виллы, у инфинити-бассейна или прямо на белом песке. В работе используем пионы (David Austin), садовые розы, эустому, гипсофилу, ранункулюсы, экзотические орхидеи, оливковую ветвь, бугенвиллею и средиземноморский эвкалипт. Дополнительно — флористика для проходного коридора, фотозона, свечи в стеклянных колбах, цветочный декор машины и яхты. Свадебная флористика Ибица — это про устойчивые композиции, выдерживающие морской бриз, солёный воздух и 6+ часов на солнце.",
          },
          {
            heading: "Банкет, тейблскейп и свадебный декор для гостей",
            image: "/weddings/ibiza/seo-3.webp",
            imageAlt: "Свадебная зона с белыми цветами и пальмами у скалы на Ибице",
            content: "Оформление свадебного банкета на Ибице — самая важная и фотогеничная часть праздника. Мы создаём низкие и высокие цветочные композиции для длинных банкетных столов под оливами Atzaró, гирлянды из эвкалипта и белых роз для finca-свадеб, runner из живых цветов в стиле ibicenco, винтажные подсвечники со свечами, индивидуальный декор для каждого place setting. Работаем со свадебными планерами Ибицы, фотографами и event-агентствами острова. Бюджет свадебного оформления на Ибице стартует от €3 500 за пакет Essential (камерная церемония), €7 000 — Signature до 50 гостей, €15 000+ — Bespoke для 100+ гостей с премиальными сортами цветов из Эквадора, Кении и Голландии.",
          },
        ],
        seoServiceTitle: "Что входит в свадебное оформление на Ибице",
        seoServices: [
          "Букет невесты на Ибице (каскадный, круглый, ibicenco-стиль)",
          "Бутоньерки жениха, шаферов и отцов",
          "Свадебные браслеты подружек невесты",
          "Цветочная арка для церемонии у моря или на скалах",
          "Оформление прохода невесты и лепестки",
          "Тейблскейп: композиции для банкетного стола",
          "Цветочные runner и гирлянды из оливы и эвкалипта",
          "Фотозона / цветочная стена для портретов",
          "Декор сладкого стола и свадебного торта",
          "Цветочный декор свадебной машины и яхты",
          "Welcome-зона и оформление приветственного коктейля",
          "Демонтаж после церемонии — площадка остаётся идеальной",
        ],
        seoLocationsTitle: "География работ — вся Ибица и Балеары",
        seoLocations: [
          "Ибица-таун (Eivissa / Dalt Vila)", "Санта-Эулария (Santa Eulària)", "Сан-Хуан (Sant Joan)",
          "Сан-Антонио (Sant Antoni)", "Эс-Кана (Es Canar)", "Кала-Льонга (Cala Llonga)",
          "Таламанка (Talamanca)", "Cala Salada", "Cala Comte", "Cala Bassa", "Es Vedrà", "Форментера (Formentera)",
        ],
        seoFinal: "Свадьба на Ибице — это destination wedding на одном из самых атмосферных островов Средиземного моря. Балеарские острова, мягкий средиземноморский климат с мая по октябрь, премиум-виллы и агротуризмо, прямые рейсы из всей Европы, России, Великобритании и ОАЭ. Если вы планируете свадьбу на Ибице, ищете wedding floral designer в Испании или хотите узнать сколько стоит свадебная флористика на Ибице — напишите нам в WhatsApp: пришлём персональный мудборд и смету в течение 24 часов.",
        seoCta: "Запросить смету на свадьбу на Ибице",

        partnersEyebrow: "НАМ ДОВЕРЯЮТ",
        partnersTitle: "Премиум-виллы и агротуризмо, где мы оформляли свадьбы",
        partners: [
          "SIX SENSES IBIZA", "HACIENDA NA XAMENA", "ATZARÓ", "CAS GASI",
          "CALA BONITA", "SA TALAIA", "AMANTE BEACH CLUB", "BESO BEACH",
          "COVA SANTA", "CAN DOMO",
        ],

        testimonialsEyebrow: "ОТЗЫВЫ НЕВЕСТ",
        testimonialsTitle: "Что говорят пары, которые",
        testimonialsTitleAccent: "доверили нам свой день",
        testimonialsSubtitle: "Десятки свадеб на Балеарах — и каждая остаётся в нашем сердце. Вот несколько историй.",
        testimonials: [
          {
            quote: "Мы планировали свадьбу из Парижа, переживали что не сможем контролировать процесс на расстоянии. YUCCA сделали невозможное — арка с пионами в Atzaró была точь-в-точь как в мудборде. Фотограф сказала, что это лучшая свадебная флористика, которую она видела на Ибице.",
            name: "Алина и Николя",
            location: "Atzaró Agroturismo",
            date: "Июль 2025",
            rating: 5,
          },
          {
            quote: "Свадьба на скалах с видом на Es Vedrà — наша мечта 5 лет. Когда невеста увидела цветочную инсталляцию на закате, она расплакалась. Команда работала весь день под солнцем — и не сдвинулись ни на минуту от графика.",
            name: "София и Александр",
            location: "Hacienda Na Xamena",
            date: "Сентябрь 2024",
            rating: 5,
          },
          {
            quote: "Я долго выбирала флориста на Ибице — все хотели €20-30 тысяч за оформление. YUCCA предложили концепт и смету уровня лондонских студий, но в два раза дешевле. Качество — выше всех ожиданий. Сейчас рекомендую всем подругам.",
            name: "Каролина и Джеймс",
            location: "Cas Gasi",
            date: "Июнь 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "ЗАЯВКА НА КОНСУЛЬТАЦИЮ",
        leadTitle: "Расскажите о вашей",
        leadTitleAccent: "свадьбе на Ибице",
        leadSubtitle: "Мы пришлём персональный мудборд и предварительную смету в течение 24 часов. Консультация — бесплатная.",
        leadFields: {
          name: "Ваше имя",
          contact: "WhatsApp / Telegram / Email",
          date: "Дата свадьбы (если есть)",
          guests: "Количество гостей",
          budget: "Ориентировочный бюджет",
          budgetOptions: ["Не определились", "До €5 000", "€5 000 – €10 000", "€10 000 – €20 000", "€20 000+"],
          guestsOptions: ["Не определились", "До 20", "20–50", "50–100", "100–200", "200+"],
          message: "Расскажите о свадьбе — вилла, стиль, пожелания",
          submit: "Отправить заявку",
          sending: "Отправляем…",
          successTitle: "Спасибо!",
          successText: "Мы получили вашу заявку и свяжемся с вами в течение 24 часов с персональным мудбордом и сметой.",
          errorText: "Не удалось отправить. Напишите нам в WhatsApp — мы получим заявку быстрее.",
          required: "Заполните имя и контакт",
        },

        timelineEyebrow: "КАЛЕНДАРЬ ВАШЕЙ СВАДЬБЫ",
        timelineTitle: "От первого письма",
        timelineTitleAccent: "до финального лепестка",
        timelineSubtitle: "Прозрачный график без сюрпризов. Вы всегда знаете, что и когда происходит.",
        timeline: [
          { when: "ЗА 4 МЕСЯЦА", title: "Знакомство и концепт", text: "Zoom-консультация бесплатно. Обсуждаем виллу, дату, стиль, бюджет. Присылаем мудборд под Ибицу." },
          { when: "ЗА 3 МЕСЯЦА", title: "Бронь и предоплата", text: "30% депозит фиксирует дату и состав. Резервируем редкие сорта — пионы David Austin из Голландии и оливковую зелень с местных ферм." },
          { when: "ЗА 1 МЕСЯЦ", title: "Финальная палитра", text: "Утверждаем точные оттенки, количество композиций, тайминг установки. Согласуем с владельцем виллы и кейтерингом." },
          { when: "ЗА 2 НЕДЕЛИ", title: "Контрольная встреча", text: "Финальный мудборд с фото референсов. Все детали согласованы — никаких сюрпризов в день свадьбы." },
          { when: "ДЕНЬ -1", title: "Установка с раннего утра", text: "Команда выходит на площадку с 6:00. Арка, столы, фотозона, дорожка — всё готово за 4 часа до церемонии." },
          { when: "ДЕНЬ СВАДЬБЫ", title: "Букет невесты в 16:00", text: "Букет невесты доставляется на виллу за 1.5–2 часа до церемонии. Финальная сверка с фотографом и планером." },
        ],

        compareTitle: "Сравнение пакетов",
        compareSubtitle: "Все различия в одной таблице — чтобы вы могли выбрать осознанно.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Стартовая цена", values: ["от €3 500", "от €7 000", "от €15 000"] },
          { feature: "Гостей", values: ["до 30", "до 50", "100+"] },
          { feature: "Букет невесты", values: ["Классический", "Каскадный", "Премиум с пионами"] },
          { feature: "Бутоньерки", values: ["Жених", "Жених + 2 шафера", "Вся свадебная команда"] },
          { feature: "Свадебная арка", values: ["Компактная", "Полноразмерная", "Эксклюзивный концепт"] },
          { feature: "Композиции на столы", values: [false, "6–8 столов", "10+ столов"] },
          { feature: "Лепестки для прохода", values: [false, true, true] },
          { feature: "Цветочная стена / фотозона", values: [false, false, true] },
          { feature: "Декор сладкого стола", values: [false, true, true] },
          { feature: "Декор машины и яхты", values: [false, false, true] },
          { feature: "Day-of флорист на месте", values: [false, false, true] },
          { feature: "Демонтаж после церемонии", values: [true, true, true] },
        ],

        relatedEyebrow: "ПОЛЕЗНЫЕ СТАТЬИ",
        relatedTitle: "Подробнее о цветах",
        relatedTitleAccent: "и свадьбах на Ибице",
        relatedSubtitle: "Гайды, советы и реальные истории — всё что мы знаем о свадебной флористике на Ибице и Балеарах.",
        relatedAll: "ВСЕ СТАТЬИ БЛОГА",

        bottomCtaTitle: "Расскажите о вашей",
        bottomCtaTitleAccent: "свадьбе на Ибице",
        bottomCtaSubtitle:
          "Свяжитесь с нами — пришлём персональный мудборд и смету в течение 24 часов. Консультация бесплатная.",
        contactBadges: [
          { title: "Ответ в WhatsApp", subtitle: "В течение часа" },
          { title: "Бесплатный мудборд", subtitle: "И предварительная смета" },
          { title: "Вся Ибица и Балеары", subtitle: "Включая Форментеру" },
          { title: "От 10 до 200 гостей", subtitle: "Любой формат" },
        ],
        contactCta: "СВЯЗАТЬСЯ С НАМИ",

        faqTitle: "Часто задаваемые вопросы",
        faq: [
          { q: "За сколько времени нужно бронировать свадебное оформление на Ибице?", a: "Для полного оформления (арка, столы, фотозона, букет невесты) — за 3–4 месяца до даты. На Ибице сезон спрос очень высокий, лучшие виллы (Atzaró, Cas Gasi, Hacienda Na Xamena) бронируются за 6+ месяцев. Минимум — 4 недели для пакета Signature. Букет невесты отдельно можем сделать за 5–7 дней в сезон." },
          { q: "Сколько стоит свадебная флористика на Ибице?", a: "Стартовая стоимость — €3 500 (пакет Essential для камерной свадьбы). Signature на 50 гостей — от €7 000. Bespoke для 100+ гостей с премиум-цветами — от €15 000. На Ибице цены выше Бодрума или материковой Испании из-за логистики (всё привозится паромом или самолётом). Каждая смета индивидуальна." },
          { q: "Работаете ли вы с Six Senses, Atzaró, Hacienda Na Xamena, Cas Gasi?", a: "Да, мы регулярно оформляем свадьбы во всех premium-локациях Ибицы: Six Senses Ibiza, Hacienda Na Xamena, Atzaró Agroturismo, Cas Gasi, Cala Bonita, Sa Talaia, Amante Beach Club, Beso Beach, Cova Santa, Can Domo. Знаем требования к доступу, тайминги, согласования с менеджерами вилл и wedding-планерами Ибицы." },
          { q: "Делаете ли вы выездные церемонии на пляже или на скалах Es Vedrà?", a: "Да. У нас большой опыт работы на пляжных локациях Cala Salada, Cala Comte, Cala Bassa и на скальных точках с видом на Es Vedrà. Учитываем особенности — морской бриз, песок, заход солнца — и используем устойчивые композиции, которые выдерживают условия 6+ часов под солнцем." },
          { q: "Можно ли заказать оформление если я не нахожусь в Испании?", a: "Да, большинство наших невест организуют свадьбу на Ибице дистанционно из Лондона, Парижа, Москвы, Дубая. Мы согласуем концепт через Zoom/WhatsApp, присылаем мудборд и эскизы. Оплата картой, банковским переводом или Wise. Полное сопровождение на русском или английском." },
          { q: "А Майорка, Менорка и Форментера тоже?", a: "Да, мы работаем по всем Балеарским островам — Ибица, Майорка, Менорка, Форментера. На Форментеру летим вместе с гостями короткий паромный переход. На Майорке и Менорке у нас есть локальные партнёры — логистика налажена." },
          { q: "Что делать если мне не понравится финальный букет?", a: "До установки мы присылаем фото готового букета невесты на одобрение. Если есть критические замечания — успеваем переделать. Но за всё время работы такого практически не было — благодаря пробному букету и детальному мудборду." },
        ],
      },
      en: {
        title: "Wedding Floristry in Ibiza — Premium Wedding Design | YUCCA",
        description:
          "Turnkey wedding floral design in Ibiza: bridal bouquet, arch, ceremony, banquet, photo zone. Premium floristry for Six Senses, Atzaró, Hacienda Na Xamena, Cas Gasi. From €3,500. Get a quote within 24 hours.",
        keywords:
          "wedding florist Ibiza, wedding flowers Ibiza, bridal bouquet Ibiza, wedding arch Ibiza, wedding floral design Ibiza, destination wedding florist Spain, luxury wedding flowers Ibiza, Atzaro wedding, Six Senses Ibiza wedding, Hacienda Na Xamena wedding",
        heroEyebrow: "WEDDING FLORISTRY",
        heroTitle: "A wedding between sky",
        heroTitleAccent: "and the Mediterranean",
        heroSubtitle:
          "Premium floral design for weddings in Ibiza — from the bridal bouquet to full ceremony and banquet decor. We work with the island's best villas, agroturismos and beach clubs.",
        ctaPrimary: "GET A QUOTE",
        ctaSecondary: "VIEW OUR WORK",
        badges: [
          { title: "DESTINATION WEDDINGS", subtitle: "From anywhere in the world" },
          { title: "ON-TIME DELIVERY", subtitle: "Set up before ceremony" },
          { title: "ALL OF IBIZA", subtitle: "Villas, agroturismos, beach clubs" },
          { title: "PHOTO CONFIRMATION", subtitle: "Before & after setup" },
        ],

        elementsEyebrow: "WHAT'S INCLUDED",
        elementsTitle: "Every detail — thoughtfully designed",
        elements: [
          { title: "Bridal bouquet", text: "The main accent. Cascade, round or ibicenco-style — matched to your palette." },
          { title: "Boutonnieres & corsages", text: "Groom, groomsmen, bridesmaids. Miniature pieces that unite the wedding party." },
          { title: "Ceremony arch", text: "The heart of the ceremony. Olive branches, peonies, English roses — or a bespoke concept for Es Vedrà cliffs." },
          { title: "Tablescape design", text: "Low arrangements for guest conversation or tall designs for a celebratory atmosphere under the stars." },
          { title: "Aisle florals", text: "Petals, bougainvillea garlands, Mediterranean greenery — the bride's path to the groom." },
          { title: "Photo backdrop", text: "Floral wall or arch under the palms — every wedding frame is perfect." },
          { title: "Confetti petals", text: "The final note — guests shower the newlyweds after the ceremonia." },
          { title: "Car & yacht decor", text: "Floral styling for the wedding car or yacht — for a ceremonial coastal drive." },
        ],

        packagesEyebrow: "WEDDING PACKAGES",
        packagesTitle: "Three formats",
        packagesTitleAccent: "for your Ibiza wedding",
        packagesSubtitle:
          "Each package is a starting point. Every detail is discussed and adapted to your villa, concept and guest count.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Intimate wedding",
            priceFrom: "from €3,500",
            description:
              "Perfect for an intimate ceremony at a finca or a hidden cove. Bridal bouquet, groom's boutonniere, compact floral arch.",
            features: [
              "Ibicenco-style bridal bouquet",
              "Groom's boutonniere",
              "Compact floral arch",
              "Groomsmen boutonnieres (up to 2)",
              "Confetti petals",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Up to 50 guests",
            priceFrom: "from €7,000",
            description:
              "The most popular package on Ibiza. Full ceremony and banquet decor for a classic destination wedding.",
            features: [
              "Cascade bridal bouquet",
              "Groom & groomsmen boutonnieres",
              "Bridesmaid wrist corsages",
              "Full-size floral arch",
              "Centerpieces for 6–8 tables",
              "Aisle florals / petals",
              "Sweet table & cake floral decor",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "100+ guests",
            priceFrom: "from €15,000",
            description:
              "Premium format with David Austin peonies, phalaenopsis orchids and exclusive Mediterranean floristry. Full island day-of service.",
            features: [
              "Premium bridal bouquet",
              "Exclusive elaborate arch",
              "Floral wall / photo zone under palms",
              "Centerpieces for 10+ tables",
              "Fresh-flower runner along the banquet table",
              "Car and/or yacht decor",
              "On-site day-of florist",
              "Post-ceremony breakdown",
            ],
          },
        ],

        seasonTitle: "Best time for a wedding",
        seasonTitleAccent: "in Ibiza",
        seasonEyebrow: "SEASONALITY",
        seasonSubtitle:
          "Each month in Ibiza has its own character. This helps you choose the date and bouquet composition.",
        seasons: [
          { period: "MAY — JUNE", label: "Peak season", text: "Perfect weather, bougainvillea in bloom, long daylight. Local peonies, ranunculus and David Austin garden roses at their best." },
          { period: "JULY — AUGUST", label: "High season", text: "Hot during the day, but sunset ceremonies after 7pm are magic. Imported peonies, orchids and Mediterranean greenery always available." },
          { period: "SEPTEMBER — OCTOBER", label: "Golden season", text: "Warm sea, soft light, fewer tourists. Ranunculus returns, dahlias, berries and burgundy accents come in." },
          { period: "NOVEMBER — APRIL", label: "Indoor season", text: "Intimate villa weddings. Imported peonies from the Netherlands and Ecuador, tulips, narcissus, mimosa." },
        ],

        processEyebrow: "HOW WE WORK",
        processTitle: "From the first message",
        processTitleAccent: "to the final petal",
        processSubtitle: "A transparent process with no surprises. You know what's happening at every step.",
        processSteps: [
          { num: "01", title: "Introduction", text: "Zoom or WhatsApp. We discuss date, villa, size, style, budget. Free of charge." },
          { num: "02", title: "Moodboard & quote", text: "We send a visual concept and detailed quote. We refine until it fully matches your vision." },
          { num: "03", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties (David Austin peonies)." },
          { num: "04", title: "Final review", text: "Two weeks before — a meeting with the final moodboard and timing. Every detail confirmed." },
          { num: "05", title: "Wedding day", text: "Setup from early morning. The bridal bouquet is delivered to the villa 1.5–2 hours before the ceremony." },
          { num: "06", title: "Breakdown", text: "After the celebration we carefully remove all arrangements and leave the venue spotless." },
        ],

        venuesTitle: "We work with the finest villas and agroturismos",
        venuesEyebrow: "VENUES",
        venuesSubtitle:
          "We know the access specifics, logistics and timings of Ibiza's leading venues — from Six Senses to hidden fincas in San Joan.",

        galleryEyebrow: "OUR WORK",
        galleryTitle: "Weddings we have",
        galleryTitleAccent: "designed in Ibiza",
        gallerySubtitle:
          "Every wedding tells its own story. Arches on the Es Vedrà cliffs, banquets in olive groves, poolside ceremonies with Mediterranean views.",
        galleryCta: "We want a wedding like this",

        hookQuote: "One day. Hundreds of details.",
        hookQuoteAccent: "Only one chance to get it right.",
        hookSubtitle: "We have done it dozens of times — on the Es Vedrà cliffs, in the olive groves of Atzaró, on the beach terraces of Amante. Every Ibiza wedding is its own project we prepare for over 3–4 months, accounting for island logistics.",
        hookStats: [
          { value: "50+", label: "weddings on the Balearics" },
          { value: "6", label: "years on the islands" },
          { value: "5.0", label: "average rating" },
          { value: "24 h", label: "reply to enquiries" },
        ],

        seoEyebrow: "WEDDING FLORISTRY IN IBIZA",
        seoTitle: "An Ibiza wedding —",
        seoTitleAccent: "premium destination floristry",
        seoBlocks: [
          {
            heading: "Wedding florist in Ibiza, end to end",
            image: "/weddings/ibiza/seo-1.webp",
            imageAlt: "Wedding floral aisle with white peonies and delphinium on Ibiza",
            content: "YUCCA Flowers is a premium wedding florist in Ibiza. We specialise in floral design for weddings in Spain for international couples — from London, Paris, Moscow and Dubai — choosing the Balearic Islands for their destination wedding. Over the years our team has designed more than 50 weddings across Ibiza, Mallorca and mainland Spain — from intimate beachfront ceremonies for 20 guests to luxury 200-guest celebrations at Six Senses Ibiza, Hacienda Na Xamena, Atzaró, Cas Gasi and Cala Bonita. Wedding decor in Ibiza is more than the bridal bouquet and an arch: it is a coordinated floral concept from welcome zone to banquet, photo backdrop and yacht send-off.",
          },
          {
            heading: "Outdoor ceremony and arch above the Mediterranean",
            image: "/weddings/ibiza/seo-2.webp",
            imageAlt: "Long wedding table in a glass orangery with rattan chairs — Ibiza",
            content: "Outdoor wedding ceremonies in Ibiza take place on the Es Vedrà cliffs, on the beaches of Cala Salada, Cala Comte and Cala Bassa, on villa terraces overlooking the Mediterranean and in the historic gardens of Dalt Vila. We design wedding arches on the pier, villa terrace, by the infinity pool or directly on white sand. In season we work with David Austin peonies, garden roses, lisianthus, baby's breath, ranunculus, phalaenopsis orchids, olive branches, bougainvillea and Mediterranean eucalyptus. We also create aisle florals, photo backdrops, candles in glass hurricanes, and floral styling for wedding car and yacht. Wedding flowers in Ibiza need to handle sea breeze, salt air and 6+ hours under direct sun — and ours do.",
          },
          {
            heading: "Banquet, tablescape and wedding decor for your guests",
            image: "/weddings/ibiza/seo-3.webp",
            imageAlt: "Wedding ceremony zone with white flowers and palms by an Ibiza cliff",
            content: "Wedding banquet design in Ibiza is the most photographed part of any celebration. We create low and tall centerpieces for long banquet tables under the olive trees of Atzaró, eucalyptus and white rose garlands for finca weddings, ibicenco-style fresh-flower runners, vintage candle holders, and individual place-setting decor. We collaborate with Ibiza wedding planners, photographers and event agencies. Wedding floral design budget in Ibiza starts at €3,500 for our Essential package (intimate ceremony), €7,000 for Signature up to 50 guests, and €15,000+ for Bespoke 100+ guest events with premium flowers imported from Ecuador, Kenya and the Netherlands.",
          },
        ],
        seoServiceTitle: "What's included in wedding floral design in Ibiza",
        seoServices: [
          "Bridal bouquet in Ibiza (cascade, round, ibicenco-style)",
          "Groom, groomsmen and father-of boutonnieres",
          "Bridesmaid wrist corsages",
          "Floral wedding arch for cliffside or seaside ceremony",
          "Aisle florals and rose petals",
          "Tablescape: centerpieces for banquet tables",
          "Floral runners and olive / eucalyptus garlands",
          "Photo backdrop / floral wall for portraits",
          "Sweet table and wedding cake floral decor",
          "Floral design for the wedding car and yacht",
          "Welcome zone and reception cocktail decor",
          "Post-ceremony breakdown — the venue is left spotless",
        ],
        seoLocationsTitle: "We work across all of Ibiza and the Balearics",
        seoLocations: [
          "Ibiza Town (Eivissa / Dalt Vila)", "Santa Eulària", "Sant Joan", "Sant Antoni",
          "Es Canar", "Cala Llonga", "Talamanca", "Cala Salada", "Cala Comte", "Cala Bassa", "Es Vedrà", "Formentera",
        ],
        seoFinal: "A wedding in Ibiza is a destination wedding on one of the most atmospheric islands of the Mediterranean. Balearic islands, mild Mediterranean climate from May to October, luxury villas and agroturismos, direct flights from across Europe, the UK, the Middle East and the CIS. If you are planning an Ibiza wedding, looking for a wedding floral designer in Spain, or wondering how much wedding floral design in Ibiza costs — message us on WhatsApp: we will send a personalised moodboard and quote within 24 hours.",
        seoCta: "Get a quote for an Ibiza wedding",

        partnersEyebrow: "TRUSTED BY",
        partnersTitle: "Premium villas and agroturismos where we have designed weddings",
        partners: [
          "SIX SENSES IBIZA", "HACIENDA NA XAMENA", "ATZARÓ", "CAS GASI",
          "CALA BONITA", "SA TALAIA", "AMANTE BEACH CLUB", "BESO BEACH",
          "COVA SANTA", "CAN DOMO",
        ],

        testimonialsEyebrow: "WORDS FROM BRIDES",
        testimonialsTitle: "What couples say after",
        testimonialsTitleAccent: "trusting us with their day",
        testimonialsSubtitle: "Dozens of weddings on the Balearics — and every single one stays with us. Here are a few stories.",
        testimonials: [
          {
            quote: "We planned our wedding from Paris and worried we couldn't control the process from a distance. YUCCA did the impossible — the peony arch in Atzaró looked exactly like our moodboard. Our photographer said it was the best wedding floristry she had ever seen on Ibiza.",
            name: "Alina & Nicolas",
            location: "Atzaró Agroturismo",
            date: "July 2025",
            rating: 5,
          },
          {
            quote: "A cliffside wedding overlooking Es Vedrà — our dream for 5 years. When the bride saw the floral installation at sunset she burst into tears. The team worked all day under the sun and didn't miss a single minute of the schedule.",
            name: "Sophia & Alexander",
            location: "Hacienda Na Xamena",
            date: "September 2024",
            rating: 5,
          },
          {
            quote: "I spent ages choosing a florist on Ibiza — everyone quoted €20–30k. YUCCA proposed a concept and quote at London-studio level, but at half the price. The quality exceeded every expectation. Now I recommend them to all my friends.",
            name: "Caroline & James",
            location: "Cas Gasi",
            date: "June 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "BOOK A CONSULTATION",
        leadTitle: "Tell us about your",
        leadTitleAccent: "Ibiza wedding",
        leadSubtitle: "We will send a personalised moodboard and preliminary quote within 24 hours. Consultation is free.",
        leadFields: {
          name: "Your name",
          contact: "WhatsApp / Telegram / Email",
          date: "Wedding date (if known)",
          guests: "Number of guests",
          budget: "Approximate budget",
          budgetOptions: ["Not yet decided", "Up to €5,000", "€5,000 – €10,000", "€10,000 – €20,000", "€20,000+"],
          guestsOptions: ["Not yet decided", "Up to 20", "20–50", "50–100", "100–200", "200+"],
          message: "Tell us about your wedding — villa, style, wishes",
          submit: "Send enquiry",
          sending: "Sending…",
          successTitle: "Thank you!",
          successText: "We have received your enquiry and will reach out within 24 hours with a personalised moodboard and quote.",
          errorText: "Couldn't send. Please message us on WhatsApp — we'll receive it instantly.",
          required: "Please fill in name and contact",
        },

        timelineEyebrow: "YOUR WEDDING CALENDAR",
        timelineTitle: "From the first message",
        timelineTitleAccent: "to the final petal",
        timelineSubtitle: "A transparent timeline with no surprises. You always know what is happening and when.",
        timeline: [
          { when: "4 MONTHS BEFORE", title: "Discovery & concept", text: "Free Zoom consultation. We discuss villa, date, style, budget. Ibiza-tailored moodboard is sent." },
          { when: "3 MONTHS BEFORE", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties — David Austin peonies from the Netherlands and olive greenery from local farms." },
          { when: "1 MONTH BEFORE", title: "Final palette", text: "We approve exact shades, number of arrangements, setup timing. Coordinated with the villa owner and catering team." },
          { when: "2 WEEKS BEFORE", title: "Sign-off meeting", text: "Final moodboard with reference photos. Every detail agreed — no surprises on the day." },
          { when: "DAY -1", title: "Setup from sunrise", text: "Our team is on site from 6 am. Arch, tables, photo zone, aisle — all ready 4 hours before the ceremony." },
          { when: "WEDDING DAY", title: "Bridal bouquet at 4 pm", text: "Delivered to the villa 1.5–2 hours before the ceremony. Final sync with photographer and planner." },
        ],

        compareTitle: "Compare packages",
        compareSubtitle: "All the differences in one table — so you can choose with confidence.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Starting price", values: ["from €3,500", "from €7,000", "from €15,000"] },
          { feature: "Guests", values: ["up to 30", "up to 50", "100+"] },
          { feature: "Bridal bouquet", values: ["Classic", "Cascade", "Premium with peonies"] },
          { feature: "Boutonnieres", values: ["Groom", "Groom + 2 groomsmen", "Whole wedding party"] },
          { feature: "Wedding arch", values: ["Compact", "Full size", "Bespoke design"] },
          { feature: "Table centerpieces", values: [false, "6–8 tables", "10+ tables"] },
          { feature: "Aisle petals", values: [false, true, true] },
          { feature: "Floral wall / photo backdrop", values: [false, false, true] },
          { feature: "Sweet table decor", values: [false, true, true] },
          { feature: "Wedding car & yacht decor", values: [false, false, true] },
          { feature: "On-site day-of florist", values: [false, false, true] },
          { feature: "Post-ceremony breakdown", values: [true, true, true] },
        ],

        relatedEyebrow: "READ MORE",
        relatedTitle: "About flowers",
        relatedTitleAccent: "and weddings in Ibiza",
        relatedSubtitle: "Guides, tips and real stories — everything we know about wedding floristry in Ibiza and the Balearics.",
        relatedAll: "ALL BLOG ARTICLES",

        bottomCtaTitle: "Tell us about your",
        bottomCtaTitleAccent: "Ibiza wedding",
        bottomCtaSubtitle:
          "Contact us — we'll send a personalised moodboard and quote within 24 hours. Consultation is free.",
        contactBadges: [
          { title: "Quick WhatsApp reply", subtitle: "Within an hour" },
          { title: "Free moodboard", subtitle: "& preliminary quote" },
          { title: "All Ibiza & Balearics", subtitle: "Including Formentera" },
          { title: "10 to 200 guests", subtitle: "Any format" },
        ],
        contactCta: "CONTACT US",

        faqTitle: "Frequently asked questions",
        faq: [
          { q: "How far in advance should I book wedding floral design in Ibiza?", a: "For a full setup (arch, tables, photo zone, bridal bouquet) — 3 to 4 months ahead. Demand is very high in season — Atzaró, Cas Gasi and Hacienda Na Xamena book out 6+ months in advance. Minimum — 4 weeks for the Signature package. A standalone bridal bouquet can be made in 5–7 days during the season." },
          { q: "How much does wedding floral design in Ibiza cost?", a: "Starting from €3,500 (Essential package for an intimate wedding). Signature for 50 guests — from €7,000. Bespoke for 100+ guests with premium varieties — from €15,000. Ibiza prices are higher than mainland Spain due to logistics (everything arrives by ferry or plane). Every quote is individual." },
          { q: "Do you work with Six Senses, Atzaró, Hacienda Na Xamena, Cas Gasi?", a: "Yes, we regularly design weddings at all premium Ibiza venues: Six Senses Ibiza, Hacienda Na Xamena, Atzaró Agroturismo, Cas Gasi, Cala Bonita, Sa Talaia, Amante Beach Club, Beso Beach, Cova Santa, Can Domo. We know access requirements, timings and how to coordinate with venue managers and Ibiza wedding planners." },
          { q: "Do you do beach or Es Vedrà cliffside ceremonies?", a: "Yes. We have extensive experience at beach locations Cala Salada, Cala Comte, Cala Bassa and at cliffside points overlooking Es Vedrà. We account for the conditions — sea breeze, sand, sunset timing — and use resilient compositions that hold up for 6+ hours under direct sun." },
          { q: "Can I book if I'm not in Spain?", a: "Yes, most of our brides organise everything remotely from London, Paris, Moscow or Dubai. We agree the concept via Zoom/WhatsApp, send a moodboard and sketches. Payment by card, bank transfer or Wise. Full support in English or Russian." },
          { q: "Mallorca, Menorca and Formentera too?", a: "Yes, we work across all the Balearic Islands — Ibiza, Mallorca, Menorca, Formentera. To Formentera we travel with the guests on the short ferry crossing. On Mallorca and Menorca we have local partners — logistics are taken care of." },
          { q: "What if I don't like the final bouquet?", a: "Before setup we send a photo of the finished bridal bouquet for approval. If there are critical issues — we have time to redo it. In practice this almost never happens thanks to the trial bouquet and detailed moodboard." },
        ],
      },
    },
  },

  santorini: {
    slug: "santorini",
    name: "Санторини",
    nameEn: "Santorini",
    namePrepositional: "на Санторини",
    namePrepositionalEn: "in Santorini",
    namePossessive: "Санторини",
    namePossessiveEn: "Santorini",
    country: { ru: "Греция", en: "Greece" },
    countryFlag: "🇬🇷",
    currency: "EUR",
    currencySymbol: "€",
    coords: { lat: 36.3932, lng: 25.4615 },
    languages: ["ru", "en"],
    heroImage: "/api/images/yuccaflower/products/6dec62d2-e4d9-40cd-aa8b-64ca68f27ab2.jpg",
    venues: [
      "Canaves Oia Epitome",
      "Santo Maris Oia",
      "Andronis Concept",
      "Le Ciel Santorini",
      "Dana Villas Infinity Suites",
      "Grace Hotel Santorini",
      "Rocabella Santorini",
      "Santorini Gem",
      "Cavo Ventus Villa",
      "El Viento Santorini",
    ],
    gallery: [
      { src: "/api/images/yuccaflower/products/5659a035-ea31-4914-8372-e25773554c11.jpg", alt: { ru: "Свадебный банкетный стол на закате у моря с композицией из роз, пампасной травы и хлопка и шалфейной дорожкой — Санторини", en: "Seaside twilight wedding tablescape with roses, pampas grass and cotton and a sage runner — Santorini" }, tag: { ru: "Сет-ап у моря на закате", en: "Seaside twilight tablescape" } },
      { src: "/api/images/yuccaflower/products/55bd98ec-446e-4add-992a-4409a121652f.jpg", alt: { ru: "Пышная композиция из красных и кремовых роз с сиренью на свадебном банкетном столе — Санторини", en: "Lush red and cream rose centerpiece with lilac on a Santorini wedding banquet table" }, tag: { ru: "Бордовая композиция", en: "Burgundy centerpiece" } },
      { src: "/api/images/yuccaflower/products/1b64ea40-0126-45bc-8b28-bbc986c440af.jpg", alt: { ru: "Свадебный банкетный стол с розами, эвкалиптом и свечами с видом на кальдеру и море Санторини", en: "Wedding banquet table with roses, eucalyptus and candles overlooking the Santorini caldera and sea" }, tag: { ru: "Банкет с видом на кальдеру", en: "Caldera-view banquet" } },
      { src: "/api/images/yuccaflower/products/9396bba7-de8e-4000-9e1d-8b019b2bb0fa.jpg", alt: { ru: "Высокая композиция из пампасной травы и зелени с золотыми подсвечниками на свадебном банкетном столе — Санторини", en: "Tall pampas grass and greenery centerpiece with gold candle holders on a Santorini wedding banquet table" }, tag: { ru: "Высокая композиция из пампасов", en: "Tall pampas centerpiece" } },
      { src: "/api/images/yuccaflower/products/e390ca75-6259-4758-95f2-f667290cfdd2.jpg", alt: { ru: "Бохо-арка из пампасной травы, роз и гортензий у белой стены и деревянной двери — Санторини", en: "Boho pampas, rose and hydrangea arch by a white wall and wooden door — Santorini" }, tag: { ru: "Бохо-арка у двери", en: "Boho arch by the door" } },
      { src: "/api/images/yuccaflower/products/55489aaf-fa5a-454c-a166-8c4d56e11d03.jpg", alt: { ru: "Жених и невеста с пышным букетом из роз, пампасной травы и эвкалипта — свадьба на Санторини", en: "Bride and groom holding a lush bouquet of roses, pampas grass and eucalyptus — Santorini wedding" }, tag: { ru: "Букет невесты", en: "Bridal bouquet" } },
      { src: "/api/images/yuccaflower/products/63333bcd-1e31-4b42-ad0b-386ce72b7720.jpg", alt: { ru: "Свадебная церемония под цветочной аркой на террасе с видом на кальдеру и море Санторини", en: "Wedding ceremony under a floral arch on a terrace overlooking the Santorini caldera and sea" }, tag: { ru: "Церемония над кальдерой", en: "Caldera ceremony" } },
      { src: "/api/images/yuccaflower/products/2a2d3908-662e-48e9-9b87-1811b1c37ad7.jpg", alt: { ru: "Свадебный банкетный стол с подвесной цветочной инсталляцией из пионов и роз — Санторини", en: "Wedding banquet table with an overhead peony and rose floral installation — Santorini" }, tag: { ru: "Банкет с цветочной инсталляцией", en: "Banquet with floral installation" } },
      { src: "/api/images/yuccaflower/products/087be50b-a43d-4dd1-965c-c2dd3fcde725.jpg", alt: { ru: "Свадебная церемония у белой часовни Санторини с цветочной аркой из пампасной травы и стульями для гостей", en: "Wedding ceremony by a white Santorini chapel with a pampas floral arch and guest chairs" }, tag: { ru: "Церемония у часовни", en: "Chapel ceremony" } },
      { src: "/api/images/yuccaflower/products/25a03d49-c644-4964-8741-4db2b91db8ea.jpg", alt: { ru: "Молодожёны целуются под аркой из пампасной травы с видом на кальдеру и море Санторини", en: "Newlyweds kissing under a pampas grass arch overlooking the Santorini caldera and sea" }, tag: { ru: "Поцелуй над кальдерой", en: "Kiss above the caldera" } },
      { src: "/api/images/yuccaflower/products/f362fb5b-a9f9-48b2-b4a0-67750c3466f9.jpg", alt: { ru: "Длинный свадебный банкетный стол у каменной стены с гирляндами огней, пампасами и розами — Санторини", en: "Long wedding banquet table by a stone wall with fairy lights, pampas and roses — Santorini" }, tag: { ru: "Банкет под гирляндами", en: "Banquet under fairy lights" } },
      { src: "/api/images/yuccaflower/products/46bac5f6-ed1a-41de-9c3a-6dae549d9eef.jpg", alt: { ru: "Свадебная арка с яркими красными, белыми и розовыми цветами на фоне голубого неба — Санторини", en: "Wedding arch with vivid red, white and pink flowers against a blue sky — Santorini" }, tag: { ru: "Яркая цветочная арка", en: "Vibrant floral arch" } },
    ],
    areas: [
      { ru: "Ия (Oia)", en: "Oia" },
      { ru: "Фира (Fira)", en: "Fira" },
      { ru: "Имеровигли", en: "Imerovigli" },
      { ru: "Фиростефани", en: "Firostefani" },
      { ru: "Пиргос (Pyrgos)", en: "Pyrgos" },
      { ru: "Мегалохори", en: "Megalochori" },
      { ru: "Акротири", en: "Akrotiri" },
    ],
    seo: {
      ru: {
        title: "Свадебная флористика на Санторини — премиум-оформление свадеб | YUCCA",
        description:
          "Цветочное оформление свадеб на Санторини под ключ: букет невесты, арка над кальдерой, церемония, банкет, фотозона. Премиум-флористика для Canaves Oia, Santo Maris, Andronis, Le Ciel. От €3500. Запросите смету за 24 часа.",
        keywords:
          "свадебная флористика Санторини, оформление свадеб Санторини, цветы на свадьбу Санторини, букет невесты Санторини, свадебная арка Санторини, флорист на свадьбу Санторини, wedding florist Santorini, свадьба на Санторини, destination wedding Санторини, свадьба в Ие, свадебный декор Греция",
        heroEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА",
        heroTitle: "Свадьба над кальдерой",
        heroTitleAccent: "Эгейского моря",
        heroSubtitle:
          "Премиум-флористика для свадеб на Санторини — от букета невесты до полного оформления церемонии и банкета. Работаем с лучшими виллами и отелями Ии, Имеровигли и Фиры.",
        ctaPrimary: "ЗАПРОСИТЬ СМЕТУ",
        ctaSecondary: "СМОТРЕТЬ ПРИМЕРЫ",
        badges: [
          { title: "DESTINATION WEDDING", subtitle: "Из любой точки мира" },
          { title: "ТОЧНО ВО ВРЕМЯ", subtitle: "Установка к началу церемонии" },
          { title: "ВЕСЬ САНТОРИНИ", subtitle: "Ия, Имеровигли, Фира, виллы" },
          { title: "ФОТО-ПОДТВЕРЖДЕНИЕ", subtitle: "До и после установки" },
        ],

        elementsEyebrow: "ЧТО ВХОДИТ В ОФОРМЛЕНИЕ",
        elementsTitle: "Каждая деталь — продумана",
        elements: [
          { title: "Букет невесты", text: "Главный акцент. Каскадный, круглый или в средиземноморском стиле — в палитре вашей свадьбы." },
          { title: "Бутоньерки и браслеты", text: "Жених, шаферы, подружки невесты. Миниатюрные композиции для всей свадебной команды." },
          { title: "Свадебная арка", text: "Сердце церемонии. Пампасная трава, пионы, английские розы или эксклюзивный концепт с видом на кальдеру." },
          { title: "Оформление столов", text: "Низкие композиции для общения гостей или высокие — для торжественной атмосферы под закат над кальдерой." },
          { title: "Цветочная дорожка", text: "Лепестки, гирлянды, средиземноморская зелень — путь невесты к жениху вдоль белых стен Ии." },
          { title: "Фотозона", text: "Цветочная стена или арка на фоне голубых куполов — для каждого кадра свадьбы." },
          { title: "Лепестки для конфетти", text: "Финальный аккорд — гости осыпают молодожёнов после церемонии." },
          { title: "Декор машины и яхты", text: "Цветочный декор для свадебной машины или яхты — для выезда вдоль кальдеры." },
        ],

        packagesEyebrow: "ПАКЕТЫ ОФОРМЛЕНИЯ",
        packagesTitle: "Три формата",
        packagesTitleAccent: "под вашу свадьбу на Санторини",
        packagesSubtitle:
          "Каждый пакет — отправная точка. Все детали обсуждаются и адаптируются под вашу виллу, концепт и количество гостей.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Камерная свадьба",
            priceFrom: "от €3 500",
            description:
              "Идеально для интимной церемонии на террасе виллы или у бело-голубой часовни. Букет невесты, бутоньерка жениха, компактная флористическая арка.",
            features: [
              "Букет невесты в средиземноморском стиле",
              "Бутоньерка жениха",
              "Цветочная арка (компактная)",
              "Бутоньерки шаферов (до 2)",
              "Лепестки для конфетти",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Свадьба до 50 гостей",
            priceFrom: "от €7 000",
            description:
              "Самый востребованный пакет на Санторини. Полное оформление церемонии над кальдерой и банкетной зоны для классической destination-свадьбы.",
            features: [
              "Каскадный букет невесты",
              "Бутоньерки жениха и шаферов",
              "Браслеты подружек невесты",
              "Полноразмерная цветочная арка",
              "Композиции на 6–8 столов",
              "Цветочная дорожка / лепестки для прохода",
              "Декор сладкого стола и торта",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "Свадьба 100+ гостей",
            priceFrom: "от €15 000",
            description:
              "Премиум-формат с пионами David Austin, орхидеями фаленопсис и эксклюзивной средиземноморской флористикой. Полный day-of сервис на острове.",
            features: [
              "Премиум-букет невесты",
              "Эксклюзивная сложная арка над кальдерой",
              "Цветочная стена / фотозона у белых стен",
              "Композиции на 10+ столов",
              "Цветочный runner вдоль banquet-стола",
              "Декор машины и/или яхты",
              "Day-of флорист на месте",
              "Демонтаж после церемонии",
            ],
          },
        ],

        seasonTitle: "Лучшее время для свадьбы",
        seasonTitleAccent: "на Санторини",
        seasonEyebrow: "СЕЗОННОСТЬ",
        seasonSubtitle:
          "Каждый месяц на Санторини — особенный. Это поможет выбрать дату и состав букета.",
        seasons: [
          { period: "МАЙ — ИЮНЬ", label: "Пик сезона", text: "Идеальная погода, мягкий свет, длинный световой день. В наличии локальные пионы, ранункулюсы, садовые розы David Austin из Голландии." },
          { period: "ИЮЛЬ — АВГУСТ", label: "Высокий сезон", text: "Жара, но церемонии на закате над кальдерой после 19:00 — магия. Импортные пионы, орхидеи, средиземноморская зелень — всегда в наличии." },
          { period: "СЕНТЯБРЬ — ОКТЯБРЬ", label: "Золотой сезон", text: "Тёплое море, мягкий свет, меньше туристов. Возвращаются ранункулюсы, добавляются георгины, ягоды и бордовые акценты." },
          { period: "НОЯБРЬ — АПРЕЛЬ", label: "Indoor-сезон", text: "Камерные свадьбы на виллах. Импортные пионы из Голландии и Эквадора, тюльпаны, нарциссы, мимоза." },
        ],

        processEyebrow: "КАК МЫ РАБОТАЕМ",
        processTitle: "От первого письма",
        processTitleAccent: "до финального лепестка",
        processSubtitle: "Прозрачный процесс без сюрпризов. Вы знаете что и когда происходит на каждом этапе.",
        processSteps: [
          { num: "01", title: "Знакомство", text: "Zoom или WhatsApp. Обсуждаем дату, виллу, размер, стиль, бюджет. Бесплатно." },
          { num: "02", title: "Мудборд и смета", text: "Присылаем визуальный концепт и детальную смету. Корректируем до полного совпадения с вашим видением." },
          { num: "03", title: "Бронь и предоплата", text: "30% предоплата фиксирует дату и состав. Резервируем редкие сорта (например, пионы David Austin)." },
          { num: "04", title: "Финальная сверка", text: "За 2 недели до даты — встреча с финальным мудбордом и таймингом. Все детали согласованы." },
          { num: "05", title: "День свадьбы", text: "Установка с раннего утра. Букет невесты доставляется на виллу за 1.5–2 часа до церемонии." },
          { num: "06", title: "Демонтаж", text: "После завершения мы аккуратно убираем все композиции и оставляем локацию в идеальном состоянии." },
        ],

        venuesTitle: "Работаем с лучшими виллами и отелями",
        venuesEyebrow: "ПЛОЩАДКИ",
        venuesSubtitle:
          "Знаем специфику доступа, логистики и таймингов ведущих площадок Санторини — от Canaves Oia до скрытых вилл Имеровигли.",

        galleryEyebrow: "НАШИ РАБОТЫ",
        galleryTitle: "Свадьбы, которые мы",
        galleryTitleAccent: "оформили на Санторини",
        gallerySubtitle:
          "Каждая свадьба — своя история. Арки над кальдерой, банкеты на закате, церемонии у белых часовен Ии с видом на Эгейское море.",
        galleryCta: "Хотим такую же свадьбу",

        hookQuote: "Один день. Сотни деталей.",
        hookQuoteAccent: "Только одна возможность сделать это идеально.",
        hookSubtitle: "Мы делали это уже десятки раз — на террасах Ии, у бело-голубых часовен Имеровигли, на обрывах с видом на вулкан. Каждая свадьба на Санторини — это отдельный проект, к которому мы готовимся за 3–4 месяца с учётом логистики острова.",
        hookStats: [
          { value: "50+", label: "свадеб на островах Греции" },
          { value: "6", label: "лет на островах" },
          { value: "5.0", label: "средний рейтинг" },
          { value: "24 ч", label: "ответ на запрос" },
        ],

        seoEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА НА САНТОРИНИ",
        seoTitle: "Свадьба на Санторини —",
        seoTitleAccent: "destination-флористика премиум-класса",
        seoBlocks: [
          {
            heading: "Свадебный флорист на Санторини под ключ",
            image: "/api/images/yuccaflower/products/9c519070-03ba-4b64-bd84-09eb5ffea224.jpg",
            imageAlt: "Свадебная церемониальная дорожка с белыми розами, лилиями и гипсофилой и золотыми стульями с видом на кальдеру Санторини",
            content: "YUCCA Flowers — премиум свадебная флористика на Санторини. Мы специализируемся на цветочном оформлении свадеб в Греции для русскоязычных, европейских, британских и арабских пар, выбирающих этот вулканический остров для своей destination wedding. Наша команда оформила более 50 свадеб на Санторини, Миконосе и других греческих островах — от камерных церемоний на 20 гостей на террасе виллы до luxury-торжеств на 150 человек в Canaves Oia, Santo Maris Oia, Andronis Concept, Le Ciel и Dana Villas. Оформление свадьбы на Санторини — это не только букет невесты и арка: это согласованный цветочный концепт от welcome-зоны до банкета, фотозоны и церемониального выезда вдоль кальдеры.",
          },
          {
            heading: "Выездная регистрация и оформление церемонии над кальдерой",
            image: "/api/images/yuccaflower/products/892d70d4-6cdf-4a96-a84f-179746db556d.jpg",
            imageAlt: "Свадебная арка с драпировкой, бело-розовыми цветами и белыми стульями с видом на кальдеру Санторини",
            content: "Выездная свадебная церемония на Санторини проходит на террасах вилл с видом на кальдеру в Ие (Oia), Имеровигли и Фиростефани, у бело-голубых часовен, на обрывах с видом на вулкан и закат, а также на чёрных и красных вулканических пляжах Периволос и Акротири. Мы оформляем свадебные арки на террасе виллы, у инфинити-бассейна или прямо на краю кальдеры. В работе используем пионы (David Austin), садовые розы, эустому, гипсофилу, ранункулюсы, экзотические орхидеи, пампасную траву, бугенвиллею и средиземноморский эвкалипт. Дополнительно — флористика для прохода, фотозона, свечи в стеклянных колбах, цветочный декор машины и яхты. Свадебная флористика Санторини — это про устойчивые композиции, выдерживающие сильный эгейский ветер (meltemi), солёный воздух и 6+ часов на солнце.",
          },
          {
            heading: "Банкет, тейблскейп и свадебный декор для гостей",
            image: "/api/images/yuccaflower/products/4032ade1-6bd6-4de8-82e0-3b47eccfe0cb.jpg",
            imageAlt: "Современная свадебная арка с оранжево-красными цветами у инфинити-бассейна с видом на кальдеру Санторини",
            content: "Оформление свадебного банкета на Санторини — самая важная и фотогеничная часть праздника. Мы создаём низкие и высокие цветочные композиции для длинных банкетных столов на террасах над кальдерой, гирлянды из эвкалипта, роз и пионов, runner из живых цветов и пампасной травы, винтажные подсвечники со свечами, индивидуальный декор для каждого place setting. Работаем со свадебными планерами Санторини, фотографами и event-агентствами острова. Бюджет свадебного оформления на Санторини стартует от €3 500 за пакет Essential (камерная церемония), €7 000 — Signature до 50 гостей, €15 000+ — Bespoke для 100+ гостей с премиальными сортами цветов из Эквадора, Кении и Голландии.",
          },
        ],
        seoServiceTitle: "Что входит в свадебное оформление на Санторини",
        seoServices: [
          "Букет невесты на Санторини (каскадный, круглый, средиземноморский стиль)",
          "Бутоньерки жениха, шаферов и отцов",
          "Свадебные браслеты подружек невесты",
          "Цветочная арка для церемонии над кальдерой или у часовни",
          "Оформление прохода невесты и лепестки",
          "Тейблскейп: композиции для банкетного стола",
          "Цветочные runner и гирлянды из эвкалипта и пампасов",
          "Фотозона / цветочная стена на фоне голубых куполов",
          "Декор сладкого стола и свадебного торта",
          "Цветочный декор свадебной машины и яхты",
          "Welcome-зона и оформление приветственного коктейля",
          "Демонтаж после церемонии — площадка остаётся идеальной",
        ],
        seoLocationsTitle: "География работ — весь Санторини и Киклады",
        seoLocations: [
          "Ия (Oia)", "Фира (Fira)", "Имеровигли (Imerovigli)", "Фиростефани (Firostefani)",
          "Пиргос (Pyrgos)", "Мегалохори (Megalochori)", "Акротири (Akrotiri)",
          "Периволос (Perivolos)", "Перисса (Perissa)", "Камари (Kamari)", "Вотонас (Vothonas)", "Эмпорио (Emporio)",
        ],
        seoFinal: "Свадьба на Санторини — это destination wedding на одном из самых романтичных островов Средиземного и Эгейского морей. Кальдера, бело-голубые церкви, легендарные закаты Ии, премиум-виллы и отели, прямые рейсы из всей Европы, России, Великобритании и ОАЭ. Если вы планируете свадьбу на Санторини, ищете wedding floral designer в Греции или хотите узнать сколько стоит свадебная флористика на Санторини — напишите нам в WhatsApp: пришлём персональный мудборд и смету в течение 24 часов.",
        seoCta: "Запросить смету на свадьбу на Санторини",

        partnersEyebrow: "НАМ ДОВЕРЯЮТ",
        partnersTitle: "Премиум-виллы и отели, где мы оформляли свадьбы",
        partners: [
          "CANAVES OIA", "SANTO MARIS OIA", "ANDRONIS CONCEPT", "LE CIEL",
          "DANA VILLAS", "GRACE HOTEL", "ROCABELLA", "SANTORINI GEM",
          "CAVO VENTUS", "EL VIENTO",
        ],

        testimonialsEyebrow: "ОТЗЫВЫ НЕВЕСТ",
        testimonialsTitle: "Что говорят пары, которые",
        testimonialsTitleAccent: "доверили нам свой день",
        testimonialsSubtitle: "Десятки свадеб на островах Греции — и каждая остаётся в нашем сердце. Вот несколько историй.",
        testimonials: [
          {
            quote: "Мы мечтали о свадьбе над кальдерой и переживали, как организовать всё из Москвы. YUCCA прислали мудборд, который полностью совпал с нашим видением. Арка из пампасов на закате в Ие была настолько красивой, что гости аплодировали.",
            name: "Мария и Дмитрий",
            location: "Canaves Oia Epitome",
            date: "Июнь 2025",
            rating: 5,
          },
          {
            quote: "Церемония у белой часовни Имеровигли с видом на вулкан — наша мечта. Когда я увидела букет и оформление, я расплакалась. Команда работала весь день под ветром meltemi и не сдвинулась ни на минуту от графика.",
            name: "Анастасия и Георгий",
            location: "Le Ciel Santorini",
            date: "Сентябрь 2024",
            rating: 5,
          },
          {
            quote: "Я долго выбирала флориста на Санторини — местные студии просили €25 000+. YUCCA предложили концепт уровня лучших европейских студий, но в два раза доступнее. Качество превзошло все ожидания.",
            name: "Каролина и Маркус",
            location: "Andronis Concept",
            date: "Май 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "ЗАЯВКА НА КОНСУЛЬТАЦИЮ",
        leadTitle: "Расскажите о вашей",
        leadTitleAccent: "свадьбе на Санторини",
        leadSubtitle: "Мы пришлём персональный мудборд и предварительную смету в течение 24 часов. Консультация — бесплатная.",
        leadFields: {
          name: "Ваше имя",
          contact: "WhatsApp / Telegram / Email",
          date: "Дата свадьбы (если есть)",
          guests: "Количество гостей",
          budget: "Ориентировочный бюджет",
          budgetOptions: ["Не определились", "До €5 000", "€5 000 – €10 000", "€10 000 – €20 000", "€20 000+"],
          guestsOptions: ["Не определились", "До 20", "20–50", "50–100", "100–200", "200+"],
          message: "Расскажите о свадьбе — вилла, стиль, пожелания",
          submit: "Отправить заявку",
          sending: "Отправляем…",
          successTitle: "Спасибо!",
          successText: "Мы получили вашу заявку и свяжемся с вами в течение 24 часов с персональным мудбордом и сметой.",
          errorText: "Не удалось отправить. Напишите нам в WhatsApp — мы получим заявку быстрее.",
          required: "Заполните имя и контакт",
        },

        timelineEyebrow: "КАЛЕНДАРЬ ВАШЕЙ СВАДЬБЫ",
        timelineTitle: "От первого письма",
        timelineTitleAccent: "до финального лепестка",
        timelineSubtitle: "Прозрачный график без сюрпризов. Вы всегда знаете, что и когда происходит.",
        timeline: [
          { when: "ЗА 4 МЕСЯЦА", title: "Знакомство и концепт", text: "Zoom-консультация бесплатно. Обсуждаем виллу, дату, стиль, бюджет. Присылаем мудборд под Санторини." },
          { when: "ЗА 3 МЕСЯЦА", title: "Бронь и предоплата", text: "30% депозит фиксирует дату и состав. Резервируем редкие сорта — пионы David Austin из Голландии и пампасную траву." },
          { when: "ЗА 1 МЕСЯЦ", title: "Финальная палитра", text: "Утверждаем точные оттенки, количество композиций, тайминг установки. Согласуем с владельцем виллы и кейтерингом." },
          { when: "ЗА 2 НЕДЕЛИ", title: "Контрольная встреча", text: "Финальный мудборд с фото референсов. Все детали согласованы — никаких сюрпризов в день свадьбы." },
          { when: "ДЕНЬ -1", title: "Установка с раннего утра", text: "Команда выходит на площадку с 6:00. Арка, столы, фотозона, дорожка — всё готово за 4 часа до церемонии." },
          { when: "ДЕНЬ СВАДЬБЫ", title: "Букет невесты к закату", text: "Букет невесты доставляется на виллу за 1.5–2 часа до церемонии. Финальная сверка с фотографом и планером." },
        ],

        compareTitle: "Сравнение пакетов",
        compareSubtitle: "Все различия в одной таблице — чтобы вы могли выбрать осознанно.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Стартовая цена", values: ["от €3 500", "от €7 000", "от €15 000"] },
          { feature: "Гостей", values: ["до 30", "до 50", "100+"] },
          { feature: "Букет невесты", values: ["Классический", "Каскадный", "Премиум с пионами"] },
          { feature: "Бутоньерки", values: ["Жених", "Жених + 2 шафера", "Вся свадебная команда"] },
          { feature: "Свадебная арка", values: ["Компактная", "Полноразмерная", "Эксклюзивный концепт"] },
          { feature: "Композиции на столы", values: [false, "6–8 столов", "10+ столов"] },
          { feature: "Лепестки для прохода", values: [false, true, true] },
          { feature: "Цветочная стена / фотозона", values: [false, false, true] },
          { feature: "Декор сладкого стола", values: [false, true, true] },
          { feature: "Декор машины и яхты", values: [false, false, true] },
          { feature: "Day-of флорист на месте", values: [false, false, true] },
          { feature: "Демонтаж после церемонии", values: [true, true, true] },
        ],

        relatedEyebrow: "ПОЛЕЗНЫЕ СТАТЬИ",
        relatedTitle: "Подробнее о цветах",
        relatedTitleAccent: "и свадьбах на Санторини",
        relatedSubtitle: "Гайды, советы и реальные истории — всё что мы знаем о свадебной флористике на Санторини и островах Греции.",
        relatedAll: "ВСЕ СТАТЬИ БЛОГА",

        bottomCtaTitle: "Расскажите о вашей",
        bottomCtaTitleAccent: "свадьбе на Санторини",
        bottomCtaSubtitle:
          "Свяжитесь с нами — пришлём персональный мудборд и смету в течение 24 часов. Консультация бесплатная.",
        contactBadges: [
          { title: "Ответ в WhatsApp", subtitle: "В течение часа" },
          { title: "Бесплатный мудборд", subtitle: "И предварительная смета" },
          { title: "Весь Санторини", subtitle: "Ия, Имеровигли, Фира" },
          { title: "От 10 до 150 гостей", subtitle: "Любой формат" },
        ],
        contactCta: "СВЯЗАТЬСЯ С НАМИ",

        faqTitle: "Часто задаваемые вопросы",
        faq: [
          { q: "За сколько времени нужно бронировать свадебное оформление на Санторини?", a: "Для полного оформления (арка, столы, фотозона, букет невесты) — за 3–4 месяца до даты. На Санторини сезон спрос очень высокий, лучшие виллы (Canaves Oia, Andronis, Le Ciel) бронируются за 8–12 месяцев. Минимум — 4 недели для пакета Signature. Букет невесты отдельно можем сделать за 5–7 дней в сезон." },
          { q: "Сколько стоит свадебная флористика на Санторини?", a: "Стартовая стоимость — €3 500 (пакет Essential для камерной свадьбы). Signature на 50 гостей — от €7 000. Bespoke для 100+ гостей с премиум-цветами — от €15 000. На Санторини цены выше материковой Греции из-за логистики (всё привозится паромом или самолётом). Каждая смета индивидуальна." },
          { q: "Работаете ли вы с Canaves Oia, Santo Maris, Andronis, Le Ciel?", a: "Да, мы регулярно оформляем свадьбы во всех premium-локациях Санторини: Canaves Oia Epitome, Santo Maris Oia, Andronis Concept, Le Ciel, Dana Villas, Grace Hotel, Rocabella, Santorini Gem, Cavo Ventus, El Viento. Знаем требования к доступу, тайминги, согласования с менеджерами вилл и wedding-планерами острова." },
          { q: "Делаете ли вы церемонии над кальдерой и у часовен?", a: "Да. У нас большой опыт работы на террасах с видом на кальдеру в Ие, Имеровигли и Фиростефани, а также у бело-голубых часовен острова. Учитываем особенности — сильный эгейский ветер meltemi, обрывы, заход солнца — и используем устойчивые композиции с надёжным креплением." },
          { q: "Можно ли заказать оформление если я не нахожусь в Греции?", a: "Да, большинство наших невест организуют свадьбу на Санторини дистанционно из Лондона, Парижа, Москвы, Дубая. Мы согласуем концепт через Zoom/WhatsApp, присылаем мудборд и эскизы. Оплата картой, банковским переводом или Wise. Полное сопровождение на русском или английском." },
          { q: "А Миконос, Парос и другие острова Греции тоже?", a: "Да, мы работаем по всем Кикладам и островам Греции — Санторини, Миконос, Парос, Наксос. Логистика налажена: цветы и команда прибывают паромом или самолётом из Афин и с соседних островов." },
          { q: "Что делать если мне не понравится финальный букет?", a: "До установки мы присылаем фото готового букета невесты на одобрение. Если есть критические замечания — успеваем переделать. Но за всё время работы такого практически не было — благодаря пробному букету и детальному мудборду." },
        ],
      },
      en: {
        title: "Wedding Floristry in Santorini — Premium Wedding Design | YUCCA",
        description:
          "Turnkey wedding floral design in Santorini: bridal bouquet, caldera ceremony arch, banquet, photo zone. Premium floristry for Canaves Oia, Santo Maris, Andronis, Le Ciel. From €3,500. Get a quote within 24 hours.",
        keywords:
          "wedding florist Santorini, wedding flowers Santorini, bridal bouquet Santorini, wedding arch Santorini, wedding floral design Santorini, destination wedding florist Greece, luxury wedding flowers Santorini, Oia wedding, Canaves Oia wedding, caldera wedding Santorini",
        heroEyebrow: "WEDDING FLORISTRY",
        heroTitle: "A wedding above",
        heroTitleAccent: "the Aegean caldera",
        heroSubtitle:
          "Premium floral design for weddings in Santorini — from the bridal bouquet to full ceremony and banquet decor. We work with the island's finest villas and hotels in Oia, Imerovigli and Fira.",
        ctaPrimary: "GET A QUOTE",
        ctaSecondary: "VIEW OUR WORK",
        badges: [
          { title: "DESTINATION WEDDINGS", subtitle: "From anywhere in the world" },
          { title: "ON-TIME DELIVERY", subtitle: "Set up before ceremony" },
          { title: "ALL OF SANTORINI", subtitle: "Oia, Imerovigli, Fira, villas" },
          { title: "PHOTO CONFIRMATION", subtitle: "Before & after setup" },
        ],

        elementsEyebrow: "WHAT'S INCLUDED",
        elementsTitle: "Every detail — thoughtfully designed",
        elements: [
          { title: "Bridal bouquet", text: "The main accent. Cascade, round or Mediterranean-style — matched to your palette." },
          { title: "Boutonnieres & corsages", text: "Groom, groomsmen, bridesmaids. Miniature pieces that unite the wedding party." },
          { title: "Ceremony arch", text: "The heart of the ceremony. Pampas grass, peonies, English roses — or a bespoke concept overlooking the caldera." },
          { title: "Tablescape design", text: "Low arrangements for guest conversation or tall designs for a celebratory sunset atmosphere above the caldera." },
          { title: "Aisle florals", text: "Petals, garlands, Mediterranean greenery — the bride's path along the white walls of Oia." },
          { title: "Photo backdrop", text: "Floral wall or arch against the blue domes — every wedding frame is perfect." },
          { title: "Confetti petals", text: "The final note — guests shower the newlyweds after the ceremony." },
          { title: "Car & yacht decor", text: "Floral styling for the wedding car or yacht — for a ceremonial drive along the caldera." },
        ],

        packagesEyebrow: "WEDDING PACKAGES",
        packagesTitle: "Three formats",
        packagesTitleAccent: "for your Santorini wedding",
        packagesSubtitle:
          "Each package is a starting point. Every detail is discussed and adapted to your villa, concept and guest count.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Intimate wedding",
            priceFrom: "from €3,500",
            description:
              "Perfect for an intimate ceremony on a villa terrace or by a white-and-blue chapel. Bridal bouquet, groom's boutonniere, compact floral arch.",
            features: [
              "Mediterranean-style bridal bouquet",
              "Groom's boutonniere",
              "Compact floral arch",
              "Groomsmen boutonnieres (up to 2)",
              "Confetti petals",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Up to 50 guests",
            priceFrom: "from €7,000",
            description:
              "The most popular package on Santorini. Full caldera ceremony and banquet decor for a classic destination wedding.",
            features: [
              "Cascade bridal bouquet",
              "Groom & groomsmen boutonnieres",
              "Bridesmaid wrist corsages",
              "Full-size floral arch",
              "Centerpieces for 6–8 tables",
              "Aisle florals / petals",
              "Sweet table & cake floral decor",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "100+ guests",
            priceFrom: "from €15,000",
            description:
              "Premium format with David Austin peonies, phalaenopsis orchids and exclusive Mediterranean floristry. Full island day-of service.",
            features: [
              "Premium bridal bouquet",
              "Exclusive elaborate arch above the caldera",
              "Floral wall / photo zone by the white walls",
              "Centerpieces for 10+ tables",
              "Fresh-flower runner along the banquet table",
              "Car and/or yacht decor",
              "On-site day-of florist",
              "Post-ceremony breakdown",
            ],
          },
        ],

        seasonTitle: "Best time for a wedding",
        seasonTitleAccent: "in Santorini",
        seasonEyebrow: "SEASONALITY",
        seasonSubtitle:
          "Each month in Santorini has its own character. This helps you choose the date and bouquet composition.",
        seasons: [
          { period: "MAY — JUNE", label: "Peak season", text: "Perfect weather, soft light, long daylight. Local peonies, ranunculus and David Austin garden roses at their best." },
          { period: "JULY — AUGUST", label: "High season", text: "Hot during the day, but sunset ceremonies above the caldera after 7pm are magic. Imported peonies, orchids and Mediterranean greenery always available." },
          { period: "SEPTEMBER — OCTOBER", label: "Golden season", text: "Warm sea, soft light, fewer tourists. Ranunculus returns, dahlias, berries and burgundy accents come in." },
          { period: "NOVEMBER — APRIL", label: "Indoor season", text: "Intimate villa weddings. Imported peonies from the Netherlands and Ecuador, tulips, narcissus, mimosa." },
        ],

        processEyebrow: "HOW WE WORK",
        processTitle: "From the first message",
        processTitleAccent: "to the final petal",
        processSubtitle: "A transparent process with no surprises. You know what's happening at every step.",
        processSteps: [
          { num: "01", title: "Introduction", text: "Zoom or WhatsApp. We discuss date, villa, size, style, budget. Free of charge." },
          { num: "02", title: "Moodboard & quote", text: "We send a visual concept and detailed quote. We refine until it fully matches your vision." },
          { num: "03", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties (David Austin peonies)." },
          { num: "04", title: "Final review", text: "Two weeks before — a meeting with the final moodboard and timing. Every detail confirmed." },
          { num: "05", title: "Wedding day", text: "Setup from early morning. The bridal bouquet is delivered to the villa 1.5–2 hours before the ceremony." },
          { num: "06", title: "Breakdown", text: "After the celebration we carefully remove all arrangements and leave the venue spotless." },
        ],

        venuesTitle: "We work with the finest villas and hotels",
        venuesEyebrow: "VENUES",
        venuesSubtitle:
          "We know the access specifics, logistics and timings of Santorini's leading venues — from Canaves Oia to hidden villas in Imerovigli.",

        galleryEyebrow: "OUR WORK",
        galleryTitle: "Weddings we have",
        galleryTitleAccent: "designed in Santorini",
        gallerySubtitle:
          "Every wedding tells its own story. Arches above the caldera, sunset banquets, ceremonies by the white chapels of Oia overlooking the Aegean Sea.",
        galleryCta: "We want a wedding like this",

        hookQuote: "One day. Hundreds of details.",
        hookQuoteAccent: "Only one chance to get it right.",
        hookSubtitle: "We have done it dozens of times — on the terraces of Oia, by the white-and-blue chapels of Imerovigli, on cliffsides overlooking the volcano. Every Santorini wedding is its own project we prepare for over 3–4 months, accounting for island logistics.",
        hookStats: [
          { value: "50+", label: "weddings on the Greek islands" },
          { value: "6", label: "years on the islands" },
          { value: "5.0", label: "average rating" },
          { value: "24 h", label: "reply to enquiries" },
        ],

        seoEyebrow: "WEDDING FLORISTRY IN SANTORINI",
        seoTitle: "A Santorini wedding —",
        seoTitleAccent: "premium destination floristry",
        seoBlocks: [
          {
            heading: "Wedding florist in Santorini, end to end",
            image: "/api/images/yuccaflower/products/9c519070-03ba-4b64-bd84-09eb5ffea224.jpg",
            imageAlt: "All-white wedding ceremony aisle with roses, lilies and baby's breath and gold chairs overlooking the Santorini caldera",
            content: "YUCCA Flowers is a premium wedding florist in Santorini. We specialise in floral design for weddings in Greece for international couples — from London, Paris, Moscow and Dubai — choosing this volcanic island for their destination wedding. Over the years our team has designed more than 50 weddings across Santorini, Mykonos and other Greek islands — from intimate 20-guest terrace ceremonies to luxury 150-guest celebrations at Canaves Oia, Santo Maris Oia, Andronis Concept, Le Ciel and Dana Villas. Wedding decor in Santorini is more than the bridal bouquet and an arch: it is a coordinated floral concept from welcome zone to banquet, photo backdrop and a ceremonial drive along the caldera.",
          },
          {
            heading: "Outdoor ceremony and arch above the caldera",
            image: "/api/images/yuccaflower/products/892d70d4-6cdf-4a96-a84f-179746db556d.jpg",
            imageAlt: "Wedding ceremony arch with draped fabric, pink-and-white flowers and white chairs overlooking the Santorini caldera",
            content: "Outdoor wedding ceremonies in Santorini take place on villa terraces overlooking the caldera in Oia, Imerovigli and Firostefani, by white-and-blue chapels, on cliffsides facing the volcano and sunset, and on the black and red volcanic beaches of Perivolos and Akrotiri. We design wedding arches on the villa terrace, by the infinity pool or right on the caldera edge. In season we work with David Austin peonies, garden roses, lisianthus, baby's breath, ranunculus, phalaenopsis orchids, pampas grass, bougainvillea and Mediterranean eucalyptus. We also create aisle florals, photo backdrops, candles in glass hurricanes, and floral styling for wedding car and yacht. Wedding flowers in Santorini need to handle the strong Aegean meltemi wind, salt air and 6+ hours under direct sun — and ours do.",
          },
          {
            heading: "Banquet, tablescape and wedding decor for your guests",
            image: "/api/images/yuccaflower/products/4032ade1-6bd6-4de8-82e0-3b47eccfe0cb.jpg",
            imageAlt: "Modern wedding ceremony arch with orange-and-red flowers by an infinity pool overlooking the Santorini caldera",
            content: "Wedding banquet design in Santorini is the most photographed part of any celebration. We create low and tall centerpieces for long banquet tables on terraces above the caldera, eucalyptus, rose and peony garlands, fresh-flower and pampas runners, vintage candle holders, and individual place-setting decor. We collaborate with Santorini wedding planners, photographers and event agencies. Wedding floral design budget in Santorini starts at €3,500 for our Essential package (intimate ceremony), €7,000 for Signature up to 50 guests, and €15,000+ for Bespoke 100+ guest events with premium flowers imported from Ecuador, Kenya and the Netherlands.",
          },
        ],
        seoServiceTitle: "What's included in wedding floral design in Santorini",
        seoServices: [
          "Bridal bouquet in Santorini (cascade, round, Mediterranean-style)",
          "Groom, groomsmen and father-of boutonnieres",
          "Bridesmaid wrist corsages",
          "Floral wedding arch for caldera or chapel ceremony",
          "Aisle florals and rose petals",
          "Tablescape: centerpieces for banquet tables",
          "Floral runners and eucalyptus / pampas garlands",
          "Photo backdrop / floral wall against the blue domes",
          "Sweet table and wedding cake floral decor",
          "Floral design for the wedding car and yacht",
          "Welcome zone and reception cocktail decor",
          "Post-ceremony breakdown — the venue is left spotless",
        ],
        seoLocationsTitle: "We work across all of Santorini and the Cyclades",
        seoLocations: [
          "Oia", "Fira", "Imerovigli", "Firostefani", "Pyrgos", "Megalochori",
          "Akrotiri", "Perivolos", "Perissa", "Kamari", "Vothonas", "Emporio",
        ],
        seoFinal: "A wedding in Santorini is a destination wedding on one of the most romantic islands of the Mediterranean and Aegean. The caldera, white-and-blue churches, the legendary sunsets of Oia, luxury villas and hotels, direct flights from across Europe, the UK, the Middle East and the CIS. If you are planning a Santorini wedding, looking for a wedding floral designer in Greece, or wondering how much wedding floral design in Santorini costs — message us on WhatsApp: we will send a personalised moodboard and quote within 24 hours.",
        seoCta: "Get a quote for a Santorini wedding",

        partnersEyebrow: "TRUSTED BY",
        partnersTitle: "Premium villas and hotels where we have designed weddings",
        partners: [
          "CANAVES OIA", "SANTO MARIS OIA", "ANDRONIS CONCEPT", "LE CIEL",
          "DANA VILLAS", "GRACE HOTEL", "ROCABELLA", "SANTORINI GEM",
          "CAVO VENTUS", "EL VIENTO",
        ],

        testimonialsEyebrow: "WORDS FROM BRIDES",
        testimonialsTitle: "What couples say after",
        testimonialsTitleAccent: "trusting us with their day",
        testimonialsSubtitle: "Dozens of weddings on the Greek islands — and every single one stays with us. Here are a few stories.",
        testimonials: [
          {
            quote: "We dreamed of a wedding above the caldera and worried about organising it all from Moscow. YUCCA sent a moodboard that matched our vision exactly. The pampas arch at sunset in Oia was so beautiful the guests applauded.",
            name: "Maria & Dmitry",
            location: "Canaves Oia Epitome",
            date: "June 2025",
            rating: 5,
          },
          {
            quote: "A ceremony by a white chapel in Imerovigli overlooking the volcano — our dream. When I saw the bouquet and the decor I burst into tears. The team worked all day in the meltemi wind and didn't miss a single minute of the schedule.",
            name: "Anastasia & George",
            location: "Le Ciel Santorini",
            date: "September 2024",
            rating: 5,
          },
          {
            quote: "I spent ages choosing a florist in Santorini — local studios quoted €25,000+. YUCCA proposed a concept at top European-studio level, but at half the price. The quality exceeded every expectation.",
            name: "Caroline & Markus",
            location: "Andronis Concept",
            date: "May 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "BOOK A CONSULTATION",
        leadTitle: "Tell us about your",
        leadTitleAccent: "Santorini wedding",
        leadSubtitle: "We will send a personalised moodboard and preliminary quote within 24 hours. Consultation is free.",
        leadFields: {
          name: "Your name",
          contact: "WhatsApp / Telegram / Email",
          date: "Wedding date (if known)",
          guests: "Number of guests",
          budget: "Approximate budget",
          budgetOptions: ["Not yet decided", "Up to €5,000", "€5,000 – €10,000", "€10,000 – €20,000", "€20,000+"],
          guestsOptions: ["Not yet decided", "Up to 20", "20–50", "50–100", "100–200", "200+"],
          message: "Tell us about your wedding — villa, style, wishes",
          submit: "Send enquiry",
          sending: "Sending…",
          successTitle: "Thank you!",
          successText: "We have received your enquiry and will reach out within 24 hours with a personalised moodboard and quote.",
          errorText: "Couldn't send. Please message us on WhatsApp — we'll receive it instantly.",
          required: "Please fill in name and contact",
        },

        timelineEyebrow: "YOUR WEDDING CALENDAR",
        timelineTitle: "From the first message",
        timelineTitleAccent: "to the final petal",
        timelineSubtitle: "A transparent timeline with no surprises. You always know what is happening and when.",
        timeline: [
          { when: "4 MONTHS BEFORE", title: "Discovery & concept", text: "Free Zoom consultation. We discuss villa, date, style, budget. Santorini-tailored moodboard is sent." },
          { when: "3 MONTHS BEFORE", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties — David Austin peonies from the Netherlands and pampas grass." },
          { when: "1 MONTH BEFORE", title: "Final palette", text: "We approve exact shades, number of arrangements, setup timing. Coordinated with the villa owner and catering team." },
          { when: "2 WEEKS BEFORE", title: "Sign-off meeting", text: "Final moodboard with reference photos. Every detail agreed — no surprises on the day." },
          { when: "DAY -1", title: "Setup from sunrise", text: "Our team is on site from 6 am. Arch, tables, photo zone, aisle — all ready 4 hours before the ceremony." },
          { when: "WEDDING DAY", title: "Bridal bouquet at sunset", text: "Delivered to the villa 1.5–2 hours before the ceremony. Final sync with photographer and planner." },
        ],

        compareTitle: "Compare packages",
        compareSubtitle: "All the differences in one table — so you can choose with confidence.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Starting price", values: ["from €3,500", "from €7,000", "from €15,000"] },
          { feature: "Guests", values: ["up to 30", "up to 50", "100+"] },
          { feature: "Bridal bouquet", values: ["Classic", "Cascade", "Premium with peonies"] },
          { feature: "Boutonnieres", values: ["Groom", "Groom + 2 groomsmen", "Whole wedding party"] },
          { feature: "Wedding arch", values: ["Compact", "Full size", "Bespoke design"] },
          { feature: "Table centerpieces", values: [false, "6–8 tables", "10+ tables"] },
          { feature: "Aisle petals", values: [false, true, true] },
          { feature: "Floral wall / photo backdrop", values: [false, false, true] },
          { feature: "Sweet table decor", values: [false, true, true] },
          { feature: "Wedding car & yacht decor", values: [false, false, true] },
          { feature: "On-site day-of florist", values: [false, false, true] },
          { feature: "Post-ceremony breakdown", values: [true, true, true] },
        ],

        relatedEyebrow: "READ MORE",
        relatedTitle: "About flowers",
        relatedTitleAccent: "and weddings in Santorini",
        relatedSubtitle: "Guides, tips and real stories — everything we know about wedding floristry in Santorini and the Greek islands.",
        relatedAll: "ALL BLOG ARTICLES",

        bottomCtaTitle: "Tell us about your",
        bottomCtaTitleAccent: "Santorini wedding",
        bottomCtaSubtitle:
          "Contact us — we'll send a personalised moodboard and quote within 24 hours. Consultation is free.",
        contactBadges: [
          { title: "Quick WhatsApp reply", subtitle: "Within an hour" },
          { title: "Free moodboard", subtitle: "& preliminary quote" },
          { title: "All Santorini", subtitle: "Oia, Imerovigli, Fira" },
          { title: "10 to 150 guests", subtitle: "Any format" },
        ],
        contactCta: "CONTACT US",

        faqTitle: "Frequently asked questions",
        faq: [
          { q: "How far in advance should I book wedding floral design in Santorini?", a: "For a full setup (arch, tables, photo zone, bridal bouquet) — 3 to 4 months ahead. Demand is very high in season — Canaves Oia, Andronis and Le Ciel book out 8–12 months in advance. Minimum — 4 weeks for the Signature package. A standalone bridal bouquet can be made in 5–7 days during the season." },
          { q: "How much does wedding floral design in Santorini cost?", a: "Starting from €3,500 (Essential package for an intimate wedding). Signature for 50 guests — from €7,000. Bespoke for 100+ guests with premium varieties — from €15,000. Santorini prices are higher than mainland Greece due to logistics (everything arrives by ferry or plane). Every quote is individual." },
          { q: "Do you work with Canaves Oia, Santo Maris, Andronis, Le Ciel?", a: "Yes, we regularly design weddings at all premium Santorini venues: Canaves Oia Epitome, Santo Maris Oia, Andronis Concept, Le Ciel, Dana Villas, Grace Hotel, Rocabella, Santorini Gem, Cavo Ventus, El Viento. We know access requirements, timings and how to coordinate with venue managers and Santorini wedding planners." },
          { q: "Do you do caldera and chapel ceremonies?", a: "Yes. We have extensive experience on caldera-view terraces in Oia, Imerovigli and Firostefani, and by the island's white-and-blue chapels. We account for the conditions — the strong Aegean meltemi wind, cliffsides, sunset timing — and use resilient compositions with secure anchoring." },
          { q: "Can I book if I'm not in Greece?", a: "Yes, most of our brides organise everything remotely from London, Paris, Moscow or Dubai. We agree the concept via Zoom/WhatsApp, send a moodboard and sketches. Payment by card, bank transfer or Wise. Full support in English or Russian." },
          { q: "Mykonos, Paros and other Greek islands too?", a: "Yes, we work across all the Cyclades and Greek islands — Santorini, Mykonos, Paros, Naxos. Logistics are taken care of: flowers and team arrive by ferry or plane from Athens and neighbouring islands." },
          { q: "What if I don't like the final bouquet?", a: "Before setup we send a photo of the finished bridal bouquet for approval. If there are critical issues — we have time to redo it. In practice this almost never happens thanks to the trial bouquet and detailed moodboard." },
        ],
      },
    },
  },

  "lake-como": {
    slug: "lake-como",
    name: "Озеро Комо",
    nameEn: "Lake Como",
    namePrepositional: "на озере Комо",
    namePrepositionalEn: "on Lake Como",
    namePossessive: "озера Комо",
    namePossessiveEn: "Lake Como",
    country: { ru: "Италия", en: "Italy" },
    countryFlag: "🇮🇹",
    currency: "EUR",
    currencySymbol: "€",
    coords: { lat: 45.9852, lng: 9.2616 },
    languages: ["ru", "en"],
    heroImage: "/api/images/yuccaflower/products/90ff69c2-d372-425d-b44f-124086c4549c.webp",
    venuesBg: "/api/images/yuccaflower/products/134de56c-6842-471d-9178-ad07e14778ab.webp",
    venues: [
      "Villa del Balbianello",
      "Villa Balbiano",
      "Villa Erba",
      "Villa d'Este",
      "Villa Pizzo",
      "Villa Sola Cabiati",
      "Mandarin Oriental Lago di Como",
      "Grand Hotel Tremezzo",
      "CastaDiva Resort & Spa",
      "Villa Pliniana",
    ],
    gallery: [
      { src: "/api/images/yuccaflower/products/fa036881-14d7-49d3-a900-223c5c8ad8da.webp", alt: { ru: "Оформление свадебного банкета цветами на вилле у озера Комо", en: "Wedding reception floral decor at a villa on Lake Como" }, tag: { ru: "Оформление банкета", en: "Reception decor" } },
      { src: "/api/images/yuccaflower/products/40d3ce9f-105c-4371-8c79-4e5c435755ba.webp", alt: { ru: "Свадебные цветочные композиции на столах — озеро Комо", en: "Wedding floral centerpieces on the tables — Lake Como" }, tag: { ru: "Цветочные композиции", en: "Floral centerpieces" } },
      { src: "/api/images/yuccaflower/products/0c796533-3923-4b67-a880-dc1347761b81.webp", alt: { ru: "Свадебная церемония в саду виллы на озере Комо", en: "Garden wedding ceremony at a villa on Lake Como" }, tag: { ru: "Церемония в саду", en: "Garden ceremony" } },
      { src: "/api/images/yuccaflower/products/489660c6-6ddc-4af3-aedc-1be2c8a783ee.webp", alt: { ru: "Цветочная инсталляция на свадьбе на озере Комо", en: "Floral installation at a Lake Como wedding" }, tag: { ru: "Цветочная инсталляция", en: "Floral installation" } },
      { src: "/api/images/yuccaflower/products/a411e45e-8b85-475b-8a81-c17c49c0be56.webp", alt: { ru: "Свадебный банкетный стол с цветочными композициями — озеро Комо", en: "Wedding banquet table with floral centerpieces — Lake Como" }, tag: { ru: "Банкетный стол", en: "Banquet table" } },
      { src: "/api/images/yuccaflower/products/0b1e1de1-d66a-4070-86f6-03ea1f636dfb.webp", alt: { ru: "Свадебный банкетный стол с цветочными композициями — озеро Комо", en: "Wedding banquet table with floral centerpieces — Lake Como" }, tag: { ru: "Банкетный стол", en: "Banquet table" } },
      { src: "/api/images/yuccaflower/products/d876a931-6e3b-4d26-be37-57adb872fecb.webp", alt: { ru: "Свадебная церемония в саду виллы на озере Комо", en: "Garden wedding ceremony at a villa on Lake Como" }, tag: { ru: "Церемония в саду", en: "Garden ceremony" } },
      { src: "/api/images/yuccaflower/products/004d6ac0-b2de-437a-85b0-9b929bd955c7.webp", alt: { ru: "Свадебная сервировка стола с цветами — озеро Комо", en: "Wedding table setting with flowers — Lake Como" }, tag: { ru: "Сервировка стола", en: "Table setting" } },
      { src: "/api/images/yuccaflower/products/9a48fcaa-2318-4825-84ac-ba4702e48fc4.webp", alt: { ru: "Свадебная сервировка стола с цветами — озеро Комо", en: "Wedding table setting with flowers — Lake Como" }, tag: { ru: "Сервировка стола", en: "Table setting" } },
      { src: "/api/images/yuccaflower/products/cd081d99-e172-44b9-9f56-0d0a2dfa5078.webp", alt: { ru: "Свадебный банкетный стол с цветочными композициями — озеро Комо", en: "Wedding banquet table with floral centerpieces — Lake Como" }, tag: { ru: "Банкетный стол", en: "Banquet table" } },
      { src: "/api/images/yuccaflower/products/61704c40-bf05-4132-87ba-f728ecd77912.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/03b98459-a891-4b54-b18e-a2b35e16f09e.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/33d2e844-ed12-459a-b8f9-625253850b5a.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/6a2fb1dd-41d2-49c6-8f41-5ad4900e0ff1.webp", alt: { ru: "Свадебный банкетный стол с цветочными композициями — озеро Комо", en: "Wedding banquet table with floral centerpieces — Lake Como" }, tag: { ru: "Банкетный стол", en: "Banquet table" } },
      { src: "/api/images/yuccaflower/products/1b47381e-0546-4866-ae56-d2b7dd1c78b5.webp", alt: { ru: "Свадебные цветочные композиции на столах — озеро Комо", en: "Wedding floral centerpieces on the tables — Lake Como" }, tag: { ru: "Цветочные композиции", en: "Floral centerpieces" } },
      { src: "/api/images/yuccaflower/products/1b470f5d-3d0a-4c6b-b429-4b0bb43bbc94.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/a489e405-751b-4504-94fc-ffd1f2b17e03.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/8c0b22dd-17e8-4f11-9229-75238e18157c.webp", alt: { ru: "Свадебная церемония в саду виллы на озере Комо", en: "Garden wedding ceremony at a villa on Lake Como" }, tag: { ru: "Церемония в саду", en: "Garden ceremony" } },
      { src: "/api/images/yuccaflower/products/2d990401-5319-49a4-8838-cf3b4e9c897b.webp", alt: { ru: "Оформление свадебного банкета цветами на вилле у озера Комо", en: "Wedding reception floral decor at a villa on Lake Como" }, tag: { ru: "Оформление банкета", en: "Reception decor" } },
      { src: "/api/images/yuccaflower/products/045691a6-8193-4be1-98e4-1c952256ba39.webp", alt: { ru: "Свадебный банкетный стол с цветочными композициями — озеро Комо", en: "Wedding banquet table with floral centerpieces — Lake Como" }, tag: { ru: "Банкетный стол", en: "Banquet table" } },
      { src: "/api/images/yuccaflower/products/1699b32f-4efe-4135-b26f-e055851cdb9b.webp", alt: { ru: "Свадебная сервировка стола с цветами — озеро Комо", en: "Wedding table setting with flowers — Lake Como" }, tag: { ru: "Сервировка стола", en: "Table setting" } },
      { src: "/api/images/yuccaflower/products/4d19ef8b-9f4d-4839-9733-bdab0507a479.webp", alt: { ru: "Цветочная инсталляция на свадьбе на озере Комо", en: "Floral installation at a Lake Como wedding" }, tag: { ru: "Цветочная инсталляция", en: "Floral installation" } },
      { src: "/api/images/yuccaflower/products/8b0524e9-1465-4324-a39d-8bb36584f542.webp", alt: { ru: "Цветочная инсталляция на свадьбе на озере Комо", en: "Floral installation at a Lake Como wedding" }, tag: { ru: "Цветочная инсталляция", en: "Floral installation" } },
      { src: "/api/images/yuccaflower/products/666e2821-6c07-4738-ad3e-4744b51271a8.webp", alt: { ru: "Оформление свадебного банкета цветами на вилле у озера Комо", en: "Wedding reception floral decor at a villa on Lake Como" }, tag: { ru: "Оформление банкета", en: "Reception decor" } },
      { src: "/api/images/yuccaflower/products/694e6457-af4e-404a-9384-6ca98feb16a8.webp", alt: { ru: "Молодожёны на свадьбе на озере Комо", en: "Newlyweds at a Lake Como wedding" }, tag: { ru: "Молодожёны", en: "The newlyweds" } },
      { src: "/api/images/yuccaflower/products/7f06ed4d-72f4-4d53-bdb3-4adc23d68370.webp", alt: { ru: "Свадебная цветочная арка с видом на озеро Комо", en: "Wedding floral arch overlooking Lake Como" }, tag: { ru: "Свадебная арка", en: "Ceremony arch" } },
      { src: "/api/images/yuccaflower/products/31311827-887a-45cc-873a-8800884ad13b.webp", alt: { ru: "Свадебная сервировка стола с цветами — озеро Комо", en: "Wedding table setting with flowers — Lake Como" }, tag: { ru: "Сервировка стола", en: "Table setting" } },
    ],
    areas: [
      { ru: "Комо (Como)", en: "Como" },
      { ru: "Черноббио (Cernobbio)", en: "Cernobbio" },
      { ru: "Белладжо (Bellagio)", en: "Bellagio" },
      { ru: "Тремеццо (Tremezzo)", en: "Tremezzo" },
      { ru: "Менаджо (Menaggio)", en: "Menaggio" },
      { ru: "Варенна (Varenna)", en: "Varenna" },
      { ru: "Ленно (Lenno)", en: "Lenno" },
      { ru: "Лальо (Laglio)", en: "Laglio" },
    ],
    seo: {
      ru: {
        title: "Свадебная флористика на озере Комо — премиум-оформление свадеб | YUCCA",
        description:
          "Цветочное оформление свадеб на озере Комо под ключ: букет невесты, арка с видом на озеро, церемония, банкет, фотозона. Премиум-флористика для Villa del Balbianello, Villa Balbiano, Villa d'Este, Mandarin Oriental. От €3500. Запросите смету за 24 часа.",
        keywords:
          "свадебная флористика озеро Комо, оформление свадеб озеро Комо, цветы на свадьбу Комо, букет невесты Комо, свадебная арка озеро Комо, флорист на свадьбу Комо, wedding florist Lake Como, свадьба на озере Комо, destination wedding Комо, свадьба на Вилле Бальбиано, свадебный декор Италия",
        heroEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА",
        heroTitle: "Свадьба на берегах",
        heroTitleAccent: "озера Комо",
        heroSubtitle:
          "Премиум-флористика для свадеб на озере Комо — от букета невесты до полного оформления церемонии и банкета. Работаем с легендарными виллами и отелями Черноббио, Белладжо и Тремеццо.",
        ctaPrimary: "ЗАПРОСИТЬ СМЕТУ",
        ctaSecondary: "СМОТРЕТЬ ПРИМЕРЫ",
        badges: [
          { title: "DESTINATION WEDDING", subtitle: "Из любой точки мира" },
          { title: "ТОЧНО ВО ВРЕМЯ", subtitle: "Установка к началу церемонии" },
          { title: "ВСЁ ОЗЕРО КОМО", subtitle: "Черноббио, Белладжо, виллы" },
          { title: "ФОТО-ПОДТВЕРЖДЕНИЕ", subtitle: "До и после установки" },
        ],

        elementsEyebrow: "ЧТО ВХОДИТ В ОФОРМЛЕНИЕ",
        elementsTitle: "Каждая деталь — продумана",
        elements: [
          { title: "Букет невесты", text: "Главный акцент. Каскадный, круглый или в итальянском саду-стиле — в палитре вашей свадьбы." },
          { title: "Бутоньерки и браслеты", text: "Жених, шаферы, подружки невесты. Миниатюрные композиции для всей свадебной команды." },
          { title: "Свадебная арка", text: "Сердце церемонии. Пионы, английские розы, дельфиниум или эксклюзивный концепт с видом на озеро." },
          { title: "Оформление столов", text: "Низкие композиции для общения гостей или высокие — для торжественной атмосферы на террасе виллы." },
          { title: "Цветочная дорожка", text: "Лепестки, гирлянды, итальянская зелень — путь невесты к жениху в садах виллы." },
          { title: "Фотозона", text: "Цветочная стена или арка на фоне озера и Альп — для каждого кадра свадьбы." },
          { title: "Лепестки для конфетти", text: "Финальный аккорд — гости осыпают молодожёнов после церемонии." },
          { title: "Декор лодки и яхты", text: "Цветочный декор для свадебной лодки или катера — для выезда по озеру Комо." },
        ],

        packagesEyebrow: "ПАКЕТЫ ОФОРМЛЕНИЯ",
        packagesTitle: "Три формата",
        packagesTitleAccent: "под вашу свадьбу на озере Комо",
        packagesSubtitle:
          "Каждый пакет — отправная точка. Все детали обсуждаются и адаптируются под вашу виллу, концепт и количество гостей.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Камерная свадьба",
            priceFrom: "от €3 500",
            description:
              "Идеально для интимной церемонии на террасе виллы или в саду с видом на озеро. Букет невесты, бутоньерка жениха, компактная флористическая арка.",
            features: [
              "Букет невесты в итальянском стиле",
              "Бутоньерка жениха",
              "Цветочная арка (компактная)",
              "Бутоньерки шаферов (до 2)",
              "Лепестки для конфетти",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Свадьба до 50 гостей",
            priceFrom: "от €7 000",
            description:
              "Самый востребованный пакет на озере Комо. Полное оформление церемонии с видом на озеро и банкетной зоны для классической destination-свадьбы.",
            features: [
              "Каскадный букет невесты",
              "Бутоньерки жениха и шаферов",
              "Браслеты подружек невесты",
              "Полноразмерная цветочная арка",
              "Композиции на 6–8 столов",
              "Цветочная дорожка / лепестки для прохода",
              "Декор сладкого стола и торта",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "Свадьба 100+ гостей",
            priceFrom: "от €15 000",
            description:
              "Премиум-формат с пионами David Austin, орхидеями фаленопсис и эксклюзивной садовой флористикой. Полный day-of сервис на озере.",
            features: [
              "Премиум-букет невесты",
              "Эксклюзивная сложная арка с видом на озеро",
              "Цветочная стена / фотозона в садах виллы",
              "Композиции на 10+ столов",
              "Цветочный runner вдоль banquet-стола",
              "Декор лодки и/или яхты",
              "Day-of флорист на месте",
              "Демонтаж после церемонии",
            ],
          },
        ],

        seasonTitle: "Лучшее время для свадьбы",
        seasonTitleAccent: "на озере Комо",
        seasonEyebrow: "СЕЗОННОСТЬ",
        seasonSubtitle:
          "Каждый месяц на озере Комо — особенный. Это поможет выбрать дату и состав букета.",
        seasons: [
          { period: "АПРЕЛЬ — ИЮНЬ", label: "Пик сезона", text: "Цветущие сады вилл, мягкий свет, идеальная погода. В наличии локальные пионы, ранункулюсы, садовые розы David Austin, дельфиниум и сирень." },
          { period: "ИЮЛЬ — АВГУСТ", label: "Высокий сезон", text: "Тёплые вечера, длинные закаты над озером. Импортные пионы, орхидеи, гортензии и садовая зелень — всегда в наличии." },
          { period: "СЕНТЯБРЬ — ОКТЯБРЬ", label: "Золотой сезон", text: "Тёплое озеро, золотая листва Альп, меньше туристов. Возвращаются георгины, ранункулюсы, ягоды и бордовые акценты." },
          { period: "НОЯБРЬ — МАРТ", label: "Indoor-сезон", text: "Камерные свадьбы в залах вилл и отелей. Импортные пионы из Голландии, тюльпаны, амариллис, нарциссы." },
        ],

        processEyebrow: "КАК МЫ РАБОТАЕМ",
        processTitle: "От первого письма",
        processTitleAccent: "до финального лепестка",
        processSubtitle: "Прозрачный процесс без сюрпризов. Вы знаете что и когда происходит на каждом этапе.",
        processSteps: [
          { num: "01", title: "Знакомство", text: "Zoom или WhatsApp. Обсуждаем дату, виллу, размер, стиль, бюджет. Бесплатно." },
          { num: "02", title: "Мудборд и смета", text: "Присылаем визуальный концепт и детальную смету. Корректируем до полного совпадения с вашим видением." },
          { num: "03", title: "Бронь и предоплата", text: "30% предоплата фиксирует дату и состав. Резервируем редкие сорта (например, пионы David Austin)." },
          { num: "04", title: "Финальная сверка", text: "За 2 недели до даты — встреча с финальным мудбордом и таймингом. Все детали согласованы." },
          { num: "05", title: "День свадьбы", text: "Установка с раннего утра. Букет невесты доставляется на виллу за 1.5–2 часа до церемонии." },
          { num: "06", title: "Демонтаж", text: "После завершения мы аккуратно убираем все композиции и оставляем локацию в идеальном состоянии." },
        ],

        venuesTitle: "Работаем с лучшими виллами и отелями",
        venuesEyebrow: "ПЛОЩАДКИ",
        venuesSubtitle:
          "Знаем специфику доступа, логистики и таймингов ведущих площадок озера Комо — от Villa del Balbianello до Villa d'Este и Mandarin Oriental.",

        galleryEyebrow: "НАШИ РАБОТЫ",
        galleryTitle: "Свадьбы, которые мы",
        galleryTitleAccent: "оформили на озере Комо",
        gallerySubtitle:
          "Каждая свадьба — своя история. Арки с видом на озеро, банкеты на террасах вилл, церемонии в исторических садах Черноббио и Ленно.",
        galleryCta: "Хотим такую же свадьбу",

        hookQuote: "Один день. Сотни деталей.",
        hookQuoteAccent: "Только одна возможность сделать это идеально.",
        hookSubtitle: "Мы делали это уже десятки раз — на террасах Villa del Balbianello, в садах Villa Balbiano, на причалах с видом на Альпы. Каждая свадьба на озере Комо — это отдельный проект, к которому мы готовимся за 3–4 месяца с учётом логистики озера.",
        hookStats: [
          { value: "80+", label: "оформленных свадеб" },
          { value: "10", label: "лет в индустрии" },
          { value: "5.0", label: "средний рейтинг" },
          { value: "24 ч", label: "ответ на запрос" },
        ],

        seoEyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА НА ОЗЕРЕ КОМО",
        seoTitle: "Свадьба на озере Комо —",
        seoTitleAccent: "destination-флористика премиум-класса",
        seoBlocks: [
          {
            heading: "Свадебный флорист на озере Комо под ключ",
            image: "/api/images/yuccaflower/products/e048865c-2ae9-4aa2-b197-a14fb6c089b7.webp",
            imageAlt: "Свадебная церемония с цветочной аркой в саду Виллы Бальбианелло с видом на озеро Комо",
            content: "YUCCA Flowers — премиум свадебная флористика на озере Комо. Мы специализируемся на цветочном оформлении свадеб в Италии для русскоязычных, европейских, британских и арабских пар, выбирающих это легендарное озеро для своей destination wedding. Наша команда оформила более 80 свадеб в Европе — от камерных церемоний на 20 гостей в саду виллы до luxury-торжеств на 150 человек в Villa del Balbianello, Villa Balbiano, Villa d'Este, Villa Erba и Mandarin Oriental Lago di Como. Оформление свадьбы на озере Комо — это не только букет невесты и арка: это согласованный цветочный концепт от welcome-зоны до банкета, фотозоны и церемониального выезда на лодке по озеру.",
          },
          {
            heading: "Выездная регистрация и оформление церемонии с видом на озеро",
            image: "/api/images/yuccaflower/products/134de56c-6842-471d-9178-ad07e14778ab.webp",
            imageAlt: "Свадебное цветочное оформление в саду Виллы Бальбиано на озере Комо",
            content: "Выездная свадебная церемония на озере Комо проходит в исторических садах вилл с видом на воду в Черноббио, Ленно, Тремеццо и Белладжо, на террасах с панорамой Альп и на причалах у самой воды. Мы оформляем свадебные арки в саду виллы, у бассейна-инфинити или прямо на берегу озера. В работе используем пионы (David Austin), садовые розы, эустому, гипсофилу, ранункулюсы, дельфиниум, экзотические орхидеи, гортензии и итальянский эвкалипт. Дополнительно — флористика для прохода, фотозона, свечи в стеклянных колбах, цветочный декор лодки и яхты. Свадебная флористика озера Комо — это про устойчивые композиции, выдерживающие озёрный бриз, влажность и долгий день на солнце.",
          },
          {
            heading: "Банкет, тейблскейп и свадебный декор для гостей",
            image: "/api/images/yuccaflower/products/1b952dc1-a474-404a-888d-af27f50546e6.webp",
            imageAlt: "Свадебный банкетный стол с цветочными композициями на вилле у озера Комо",
            content: "Оформление свадебного банкета на озере Комо — самая важная и фотогеничная часть праздника. Мы создаём низкие и высокие цветочные композиции для длинных банкетных столов на террасах вилл, гирлянды из эвкалипта, роз и пионов, runner из живых цветов, винтажные подсвечники со свечами, индивидуальный декор для каждого place setting. Работаем со свадебными планерами озера Комо, фотографами и event-агентствами региона. Бюджет свадебного оформления на озере Комо стартует от €3 500 за пакет Essential (камерная церемония), €7 000 — Signature до 50 гостей, €15 000+ — Bespoke для 100+ гостей с премиальными сортами цветов из Эквадора, Кении и Голландии.",
          },
        ],
        seoServiceTitle: "Что входит в свадебное оформление на озере Комо",
        seoServices: [
          "Букет невесты на озере Комо (каскадный, круглый, садовый стиль)",
          "Бутоньерки жениха, шаферов и отцов",
          "Свадебные браслеты подружек невесты",
          "Цветочная арка для церемонии с видом на озеро или в саду виллы",
          "Оформление прохода невесты и лепестки",
          "Тейблскейп: композиции для банкетного стола",
          "Цветочные runner и гирлянды из эвкалипта",
          "Фотозона / цветочная стена на фоне озера и Альп",
          "Декор сладкого стола и свадебного торта",
          "Цветочный декор свадебной лодки и яхты",
          "Welcome-зона и оформление приветственного коктейля",
          "Демонтаж после церемонии — площадка остаётся идеальной",
        ],
        seoLocationsTitle: "География работ — всё озеро Комо и Ломбардия",
        seoLocations: [
          "Комо (Como)", "Черноббио (Cernobbio)", "Белладжо (Bellagio)", "Тремеццо (Tremezzo)",
          "Менаджо (Menaggio)", "Варенна (Varenna)", "Ленно (Lenno)", "Лальо (Laglio)",
          "Блевио (Blevio)", "Торно (Torno)", "Молтразио (Moltrasio)", "Арденно (Argegno)",
        ],
        seoFinal: "Свадьба на озере Комо — это destination wedding на одном из самых романтичных озёр Европы. Исторические виллы, цветущие сады, панорамы Альп, легендарные закаты над водой, премиум-отели и прямые рейсы через Милан из всей Европы, России, Великобритании и ОАЭ. Если вы планируете свадьбу на озере Комо, ищете wedding floral designer в Италии или хотите узнать сколько стоит свадебная флористика на озере Комо — напишите нам в WhatsApp: пришлём персональный мудборд и смету в течение 24 часов.",
        seoCta: "Запросить смету на свадьбу на озере Комо",

        partnersEyebrow: "НАМ ДОВЕРЯЮТ",
        partnersTitle: "Премиум-виллы и отели, где мы оформляли свадьбы",
        partners: [
          "VILLA DEL BALBIANELLO", "VILLA BALBIANO", "VILLA ERBA", "VILLA D'ESTE",
          "MANDARIN ORIENTAL", "GRAND HOTEL TREMEZZO", "CASTADIVA RESORT", "VILLA PIZZO",
          "VILLA SOLA CABIATI", "VILLA PLINIANA",
        ],

        testimonialsEyebrow: "ОТЗЫВЫ НЕВЕСТ",
        testimonialsTitle: "Что говорят пары, которые",
        testimonialsTitleAccent: "доверили нам свой день",
        testimonialsSubtitle: "Десятки свадеб в Европе — и каждая остаётся в нашем сердце. Вот несколько историй.",
        testimonials: [
          {
            quote: "Мы мечтали о свадьбе на озере Комо и переживали, как организовать всё из Москвы. YUCCA прислали мудборд, который полностью совпал с нашим видением. Арка в саду Виллы Бальбианелло была настолько красивой, что гости аплодировали.",
            name: "Мария и Дмитрий",
            location: "Villa del Balbianello",
            date: "Июнь 2025",
            rating: 5,
          },
          {
            quote: "Церемония на террасе с видом на озеро и Альпы — наша мечта. Когда я увидела букет и оформление, я расплакалась. Команда работала весь день и не сдвинулась ни на минуту от графика.",
            name: "Анастасия и Георгий",
            location: "Villa Balbiano",
            date: "Сентябрь 2024",
            rating: 5,
          },
          {
            quote: "Я долго выбирала флориста на озере Комо — местные студии просили €25 000+. YUCCA предложили концепт уровня лучших европейских студий, но в два раза доступнее. Качество превзошло все ожидания.",
            name: "Каролина и Маркус",
            location: "Villa d'Este",
            date: "Май 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "ЗАЯВКА НА КОНСУЛЬТАЦИЮ",
        leadTitle: "Расскажите о вашей",
        leadTitleAccent: "свадьбе на озере Комо",
        leadSubtitle: "Мы пришлём персональный мудборд и предварительную смету в течение 24 часов. Консультация — бесплатная.",
        leadFields: {
          name: "Ваше имя",
          contact: "WhatsApp / Telegram / Email",
          date: "Дата свадьбы (если есть)",
          guests: "Количество гостей",
          budget: "Ориентировочный бюджет",
          budgetOptions: ["Не определились", "До €5 000", "€5 000 – €10 000", "€10 000 – €20 000", "€20 000+"],
          guestsOptions: ["Не определились", "До 20", "20–50", "50–100", "100–200", "200+"],
          message: "Расскажите о свадьбе — вилла, стиль, пожелания",
          submit: "Отправить заявку",
          sending: "Отправляем…",
          successTitle: "Спасибо!",
          successText: "Мы получили вашу заявку и свяжемся с вами в течение 24 часов с персональным мудбордом и сметой.",
          errorText: "Не удалось отправить. Напишите нам в WhatsApp — мы получим заявку быстрее.",
          required: "Заполните имя и контакт",
        },

        timelineEyebrow: "КАЛЕНДАРЬ ВАШЕЙ СВАДЬБЫ",
        timelineTitle: "От первого письма",
        timelineTitleAccent: "до финального лепестка",
        timelineSubtitle: "Прозрачный график без сюрпризов. Вы всегда знаете, что и когда происходит.",
        timeline: [
          { when: "ЗА 4 МЕСЯЦА", title: "Знакомство и концепт", text: "Zoom-консультация бесплатно. Обсуждаем виллу, дату, стиль, бюджет. Присылаем мудборд под озеро Комо." },
          { when: "ЗА 3 МЕСЯЦА", title: "Бронь и предоплата", text: "30% депозит фиксирует дату и состав. Резервируем редкие сорта — пионы David Austin из Голландии." },
          { when: "ЗА 1 МЕСЯЦ", title: "Финальная палитра", text: "Утверждаем точные оттенки, количество композиций, тайминг установки. Согласуем с владельцем виллы и кейтерингом." },
          { when: "ЗА 2 НЕДЕЛИ", title: "Контрольная встреча", text: "Финальный мудборд с фото референсов. Все детали согласованы — никаких сюрпризов в день свадьбы." },
          { when: "ДЕНЬ -1", title: "Установка с раннего утра", text: "Команда выходит на площадку с 6:00. Арка, столы, фотозона, дорожка — всё готово за 4 часа до церемонии." },
          { when: "ДЕНЬ СВАДЬБЫ", title: "Букет невесты к закату", text: "Букет невесты доставляется на виллу за 1.5–2 часа до церемонии. Финальная сверка с фотографом и планером." },
        ],

        compareTitle: "Сравнение пакетов",
        compareSubtitle: "Все различия в одной таблице — чтобы вы могли выбрать осознанно.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Стартовая цена", values: ["от €3 500", "от €7 000", "от €15 000"] },
          { feature: "Гостей", values: ["до 30", "до 50", "100+"] },
          { feature: "Букет невесты", values: ["Классический", "Каскадный", "Премиум с пионами"] },
          { feature: "Бутоньерки", values: ["Жених", "Жених + 2 шафера", "Вся свадебная команда"] },
          { feature: "Свадебная арка", values: ["Компактная", "Полноразмерная", "Эксклюзивный концепт"] },
          { feature: "Композиции на столы", values: [false, "6–8 столов", "10+ столов"] },
          { feature: "Лепестки для прохода", values: [false, true, true] },
          { feature: "Цветочная стена / фотозона", values: [false, false, true] },
          { feature: "Декор сладкого стола", values: [false, true, true] },
          { feature: "Декор лодки и яхты", values: [false, false, true] },
          { feature: "Day-of флорист на месте", values: [false, false, true] },
          { feature: "Демонтаж после церемонии", values: [true, true, true] },
        ],

        relatedEyebrow: "ПОЛЕЗНЫЕ СТАТЬИ",
        relatedTitle: "Подробнее о цветах",
        relatedTitleAccent: "и свадьбах на озере Комо",
        relatedSubtitle: "Гайды, советы и реальные истории — всё что мы знаем о свадебной флористике на озере Комо и в Италии.",
        relatedAll: "ВСЕ СТАТЬИ БЛОГА",

        bottomCtaTitle: "Расскажите о вашей",
        bottomCtaTitleAccent: "свадьбе на озере Комо",
        bottomCtaSubtitle:
          "Свяжитесь с нами — пришлём персональный мудборд и смету в течение 24 часов. Консультация бесплатная.",
        contactBadges: [
          { title: "Ответ в WhatsApp", subtitle: "В течение часа" },
          { title: "Бесплатный мудборд", subtitle: "И предварительная смета" },
          { title: "Всё озеро Комо", subtitle: "Черноббио, Белладжо, Тремеццо" },
          { title: "От 10 до 150 гостей", subtitle: "Любой формат" },
        ],
        contactCta: "СВЯЗАТЬСЯ С НАМИ",

        faqTitle: "Часто задаваемые вопросы",
        faq: [
          { q: "За сколько времени нужно бронировать свадебное оформление на озере Комо?", a: "Для полного оформления (арка, столы, фотозона, букет невесты) — за 3–4 месяца до даты. На озере Комо спрос очень высокий, лучшие виллы (Villa del Balbianello, Villa Balbiano, Villa d'Este) бронируются за 12–18 месяцев. Минимум — 4 недели для пакета Signature. Букет невесты отдельно можем сделать за 5–7 дней в сезон." },
          { q: "Сколько стоит свадебная флористика на озере Комо?", a: "Стартовая стоимость — €3 500 (пакет Essential для камерной свадьбы). Signature на 50 гостей — от €7 000. Bespoke для 100+ гостей с премиум-цветами — от €15 000. Каждая смета индивидуальна и зависит от виллы, количества гостей и сезона." },
          { q: "Работаете ли вы с Villa del Balbianello, Villa Balbiano, Villa d'Este?", a: "Да, мы регулярно оформляем свадьбы во всех premium-локациях озера Комо: Villa del Balbianello, Villa Balbiano, Villa Erba, Villa d'Este, Villa Pizzo, Villa Sola Cabiati, Mandarin Oriental Lago di Como, Grand Hotel Tremezzo, CastaDiva Resort, Villa Pliniana. Знаем требования к доступу, тайминги, согласования с менеджерами вилл и wedding-планерами региона." },
          { q: "Делаете ли вы церемонии в садах вилл и на берегу озера?", a: "Да. У нас большой опыт работы в исторических садах вилл с видом на озеро в Черноббио, Ленно, Тремеццо и Белладжо, а также на причалах у воды. Учитываем особенности — озёрный бриз, влажность, заход солнца — и используем устойчивые композиции с надёжным креплением." },
          { q: "Можно ли заказать оформление если я не нахожусь в Италии?", a: "Да, большинство наших невест организуют свадьбу на озере Комо дистанционно из Лондона, Парижа, Москвы, Дубая. Мы согласуем концепт через Zoom/WhatsApp, присылаем мудборд и эскизы. Оплата картой, банковским переводом или Wise. Полное сопровождение на русском или английском." },
          { q: "А другие города Италии тоже?", a: "Да, мы работаем по северной Италии — озеро Комо, озеро Гарда, озеро Маджоре, а также можем организовать оформление в Милане и Венеции. Логистика налажена через Милан." },
          { q: "Что делать если мне не понравится финальный букет?", a: "До установки мы присылаем фото готового букета невесты на одобрение. Если есть критические замечания — успеваем переделать. Но за всё время работы такого практически не было — благодаря пробному букету и детальному мудборду." },
        ],
      },
      en: {
        title: "Wedding Floristry on Lake Como — Premium Wedding Design | YUCCA",
        description:
          "Turnkey wedding floral design on Lake Como: bridal bouquet, lakeside ceremony arch, banquet, photo zone. Premium floristry for Villa del Balbianello, Villa Balbiano, Villa d'Este, Mandarin Oriental. From €3,500. Get a quote within 24 hours.",
        keywords:
          "wedding florist Lake Como, wedding flowers Lake Como, bridal bouquet Lake Como, wedding arch Lake Como, wedding floral design Lake Como, destination wedding florist Italy, luxury wedding flowers Lake Como, Villa del Balbianello wedding, Villa Balbiano wedding, Lake Como wedding",
        heroEyebrow: "WEDDING FLORISTRY",
        heroTitle: "A wedding on the shores",
        heroTitleAccent: "of Lake Como",
        heroSubtitle:
          "Premium floral design for weddings on Lake Como — from the bridal bouquet to full ceremony and banquet decor. We work with the lake's legendary villas and hotels in Cernobbio, Bellagio and Tremezzo.",
        ctaPrimary: "GET A QUOTE",
        ctaSecondary: "VIEW OUR WORK",
        badges: [
          { title: "DESTINATION WEDDINGS", subtitle: "From anywhere in the world" },
          { title: "ON-TIME DELIVERY", subtitle: "Set up before ceremony" },
          { title: "ALL OF LAKE COMO", subtitle: "Cernobbio, Bellagio, villas" },
          { title: "PHOTO CONFIRMATION", subtitle: "Before & after setup" },
        ],

        elementsEyebrow: "WHAT'S INCLUDED",
        elementsTitle: "Every detail — thoughtfully designed",
        elements: [
          { title: "Bridal bouquet", text: "The main accent. Cascade, round or Italian-garden style — matched to your palette." },
          { title: "Boutonnieres & corsages", text: "Groom, groomsmen, bridesmaids. Miniature pieces that unite the wedding party." },
          { title: "Ceremony arch", text: "The heart of the ceremony. Peonies, English roses, delphinium — or a bespoke concept overlooking the lake." },
          { title: "Tablescape design", text: "Low arrangements for guest conversation or tall designs for a celebratory atmosphere on the villa terrace." },
          { title: "Aisle florals", text: "Petals, garlands, Italian greenery — the bride's path through the villa gardens." },
          { title: "Photo backdrop", text: "Floral wall or arch against the lake and the Alps — every wedding frame is perfect." },
          { title: "Confetti petals", text: "The final note — guests shower the newlyweds after the ceremony." },
          { title: "Boat & yacht decor", text: "Floral styling for the wedding boat or yacht — for a ceremonial cruise on Lake Como." },
        ],

        packagesEyebrow: "WEDDING PACKAGES",
        packagesTitle: "Three formats",
        packagesTitleAccent: "for your Lake Como wedding",
        packagesSubtitle:
          "Each package is a starting point. Every detail is discussed and adapted to your villa, concept and guest count.",
        packages: [
          {
            name: "ESSENTIAL",
            tagline: "Intimate wedding",
            priceFrom: "from €3,500",
            description:
              "Perfect for an intimate ceremony on a villa terrace or in a garden overlooking the lake. Bridal bouquet, groom's boutonniere, compact floral arch.",
            features: [
              "Italian-style bridal bouquet",
              "Groom's boutonniere",
              "Compact floral arch",
              "Groomsmen boutonnieres (up to 2)",
              "Confetti petals",
            ],
          },
          {
            name: "SIGNATURE",
            tagline: "Up to 50 guests",
            priceFrom: "from €7,000",
            description:
              "The most popular package on Lake Como. Full lakeside ceremony and banquet decor for a classic destination wedding.",
            features: [
              "Cascade bridal bouquet",
              "Groom & groomsmen boutonnieres",
              "Bridesmaid wrist corsages",
              "Full-size floral arch",
              "Centerpieces for 6–8 tables",
              "Aisle florals / petals",
              "Sweet table & cake floral decor",
            ],
            highlighted: true,
          },
          {
            name: "BESPOKE",
            tagline: "100+ guests",
            priceFrom: "from €15,000",
            description:
              "Premium format with David Austin peonies, phalaenopsis orchids and exclusive garden floristry. Full lakeside day-of service.",
            features: [
              "Premium bridal bouquet",
              "Exclusive elaborate arch overlooking the lake",
              "Floral wall / photo zone in the villa gardens",
              "Centerpieces for 10+ tables",
              "Fresh-flower runner along the banquet table",
              "Boat and/or yacht decor",
              "On-site day-of florist",
              "Post-ceremony breakdown",
            ],
          },
        ],

        seasonTitle: "Best time for a wedding",
        seasonTitleAccent: "on Lake Como",
        seasonEyebrow: "SEASONALITY",
        seasonSubtitle:
          "Each month on Lake Como has its own character. This helps you choose the date and bouquet composition.",
        seasons: [
          { period: "APRIL — JUNE", label: "Peak season", text: "Blooming villa gardens, soft light, perfect weather. Local peonies, ranunculus, David Austin garden roses, delphinium and lilac at their best." },
          { period: "JULY — AUGUST", label: "High season", text: "Warm evenings, long sunsets over the lake. Imported peonies, orchids, hydrangeas and garden greenery always available." },
          { period: "SEPTEMBER — OCTOBER", label: "Golden season", text: "Warm lake, golden Alpine foliage, fewer tourists. Dahlias and ranunculus return, with berries and burgundy accents." },
          { period: "NOVEMBER — MARCH", label: "Indoor season", text: "Intimate weddings in villa and hotel halls. Imported peonies from the Netherlands, tulips, amaryllis, narcissus." },
        ],

        processEyebrow: "HOW WE WORK",
        processTitle: "From the first message",
        processTitleAccent: "to the final petal",
        processSubtitle: "A transparent process with no surprises. You know what's happening at every step.",
        processSteps: [
          { num: "01", title: "Introduction", text: "Zoom or WhatsApp. We discuss date, villa, size, style, budget. Free of charge." },
          { num: "02", title: "Moodboard & quote", text: "We send a visual concept and detailed quote. We refine until it fully matches your vision." },
          { num: "03", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties (David Austin peonies)." },
          { num: "04", title: "Final review", text: "Two weeks before — a meeting with the final moodboard and timing. Every detail confirmed." },
          { num: "05", title: "Wedding day", text: "Setup from early morning. The bridal bouquet is delivered to the villa 1.5–2 hours before the ceremony." },
          { num: "06", title: "Breakdown", text: "After the celebration we carefully remove all arrangements and leave the venue spotless." },
        ],

        venuesTitle: "We work with the finest villas and hotels",
        venuesEyebrow: "VENUES",
        venuesSubtitle:
          "We know the access specifics, logistics and timings of Lake Como's leading venues — from Villa del Balbianello to Villa d'Este and Mandarin Oriental.",

        galleryEyebrow: "OUR WORK",
        galleryTitle: "Weddings we have",
        galleryTitleAccent: "designed on Lake Como",
        gallerySubtitle:
          "Every wedding tells its own story. Arches overlooking the lake, banquets on villa terraces, ceremonies in the historic gardens of Cernobbio and Lenno.",
        galleryCta: "We want a wedding like this",

        hookQuote: "One day. Hundreds of details.",
        hookQuoteAccent: "Only one chance to get it right.",
        hookSubtitle: "We have done it dozens of times — on the terraces of Villa del Balbianello, in the gardens of Villa Balbiano, on piers overlooking the Alps. Every Lake Como wedding is its own project we prepare for over 3–4 months, accounting for lakeside logistics.",
        hookStats: [
          { value: "80+", label: "weddings designed" },
          { value: "10", label: "years in the industry" },
          { value: "5.0", label: "average rating" },
          { value: "24 h", label: "reply to enquiries" },
        ],

        seoEyebrow: "WEDDING FLORISTRY ON LAKE COMO",
        seoTitle: "A Lake Como wedding —",
        seoTitleAccent: "premium destination floristry",
        seoBlocks: [
          {
            heading: "Wedding florist on Lake Como, end to end",
            image: "/api/images/yuccaflower/products/e048865c-2ae9-4aa2-b197-a14fb6c089b7.webp",
            imageAlt: "Wedding ceremony with a floral arch in the garden of Villa del Balbianello overlooking Lake Como",
            content: "YUCCA Flowers is a premium wedding florist on Lake Como. We specialise in floral design for weddings in Italy for international couples — from London, Paris, Moscow and Dubai — choosing this legendary lake for their destination wedding. Over the years our team has designed more than 80 weddings across Europe — from intimate 20-guest garden ceremonies to luxury 150-guest celebrations at Villa del Balbianello, Villa Balbiano, Villa d'Este, Villa Erba and Mandarin Oriental Lago di Como. Wedding decor on Lake Como is more than the bridal bouquet and an arch: it is a coordinated floral concept from welcome zone to banquet, photo backdrop and a ceremonial cruise on the lake.",
          },
          {
            heading: "Outdoor ceremony and arch overlooking the lake",
            image: "/api/images/yuccaflower/products/134de56c-6842-471d-9178-ad07e14778ab.webp",
            imageAlt: "Wedding floral design in the garden of Villa Balbiano on Lake Como",
            content: "Outdoor wedding ceremonies on Lake Como take place in the historic gardens of villas overlooking the water in Cernobbio, Lenno, Tremezzo and Bellagio, on terraces with Alpine panoramas and on piers at the water's edge. We design wedding arches in the villa garden, by the infinity pool or right on the lakeshore. In season we work with David Austin peonies, garden roses, lisianthus, baby's breath, ranunculus, delphinium, phalaenopsis orchids, hydrangeas and Italian eucalyptus. We also create aisle florals, photo backdrops, candles in glass hurricanes, and floral styling for the wedding boat and yacht. Wedding flowers on Lake Como need to handle the lake breeze, humidity and a long day under the sun — and ours do.",
          },
          {
            heading: "Banquet, tablescape and wedding decor for your guests",
            image: "/api/images/yuccaflower/products/1b952dc1-a474-404a-888d-af27f50546e6.webp",
            imageAlt: "Wedding banquet table with floral centerpieces at a Lake Como villa",
            content: "Wedding banquet design on Lake Como is the most photographed part of any celebration. We create low and tall centerpieces for long banquet tables on villa terraces, eucalyptus, rose and peony garlands, fresh-flower runners, vintage candle holders, and individual place-setting decor. We collaborate with Lake Como wedding planners, photographers and event agencies. Wedding floral design budget on Lake Como starts at €3,500 for our Essential package (intimate ceremony), €7,000 for Signature up to 50 guests, and €15,000+ for Bespoke 100+ guest events with premium flowers imported from Ecuador, Kenya and the Netherlands.",
          },
        ],
        seoServiceTitle: "What's included in wedding floral design on Lake Como",
        seoServices: [
          "Bridal bouquet on Lake Como (cascade, round, garden-style)",
          "Groom, groomsmen and father-of boutonnieres",
          "Bridesmaid wrist corsages",
          "Floral wedding arch for a lakeside or villa-garden ceremony",
          "Aisle florals and rose petals",
          "Tablescape: centerpieces for banquet tables",
          "Floral runners and eucalyptus garlands",
          "Photo backdrop / floral wall against the lake and the Alps",
          "Sweet table and wedding cake floral decor",
          "Floral design for the wedding boat and yacht",
          "Welcome zone and reception cocktail decor",
          "Post-ceremony breakdown — the venue is left spotless",
        ],
        seoLocationsTitle: "We work across all of Lake Como and Lombardy",
        seoLocations: [
          "Como", "Cernobbio", "Bellagio", "Tremezzo", "Menaggio", "Varenna",
          "Lenno", "Laglio", "Blevio", "Torno", "Moltrasio", "Argegno",
        ],
        seoFinal: "A wedding on Lake Como is a destination wedding on one of the most romantic lakes in Europe. Historic villas, blooming gardens, Alpine panoramas, legendary sunsets over the water, luxury hotels and direct flights via Milan from across Europe, the UK, the Middle East and the CIS. If you are planning a Lake Como wedding, looking for a wedding floral designer in Italy, or wondering how much wedding floral design on Lake Como costs — message us on WhatsApp: we will send a personalised moodboard and quote within 24 hours.",
        seoCta: "Get a quote for a Lake Como wedding",

        partnersEyebrow: "TRUSTED BY",
        partnersTitle: "Premium villas and hotels where we have designed weddings",
        partners: [
          "VILLA DEL BALBIANELLO", "VILLA BALBIANO", "VILLA ERBA", "VILLA D'ESTE",
          "MANDARIN ORIENTAL", "GRAND HOTEL TREMEZZO", "CASTADIVA RESORT", "VILLA PIZZO",
          "VILLA SOLA CABIATI", "VILLA PLINIANA",
        ],

        testimonialsEyebrow: "WORDS FROM BRIDES",
        testimonialsTitle: "What couples say after",
        testimonialsTitleAccent: "trusting us with their day",
        testimonialsSubtitle: "Dozens of weddings across Europe — and every single one stays with us. Here are a few stories.",
        testimonials: [
          {
            quote: "We dreamed of a wedding on Lake Como and worried about organising it all from Moscow. YUCCA sent a moodboard that matched our vision exactly. The arch in the garden of Villa del Balbianello was so beautiful the guests applauded.",
            name: "Maria & Dmitry",
            location: "Villa del Balbianello",
            date: "June 2025",
            rating: 5,
          },
          {
            quote: "A ceremony on a terrace overlooking the lake and the Alps — our dream. When I saw the bouquet and the decor I burst into tears. The team worked all day and didn't miss a single minute of the schedule.",
            name: "Anastasia & George",
            location: "Villa Balbiano",
            date: "September 2024",
            rating: 5,
          },
          {
            quote: "I spent ages choosing a florist on Lake Como — local studios quoted €25,000+. YUCCA proposed a concept at top European-studio level, but at half the price. The quality exceeded every expectation.",
            name: "Caroline & Markus",
            location: "Villa d'Este",
            date: "May 2024",
            rating: 5,
          },
        ],

        leadEyebrow: "BOOK A CONSULTATION",
        leadTitle: "Tell us about your",
        leadTitleAccent: "Lake Como wedding",
        leadSubtitle: "We will send a personalised moodboard and preliminary quote within 24 hours. Consultation is free.",
        leadFields: {
          name: "Your name",
          contact: "WhatsApp / Telegram / Email",
          date: "Wedding date (if known)",
          guests: "Number of guests",
          budget: "Approximate budget",
          budgetOptions: ["Not yet decided", "Up to €5,000", "€5,000 – €10,000", "€10,000 – €20,000", "€20,000+"],
          guestsOptions: ["Not yet decided", "Up to 20", "20–50", "50–100", "100–200", "200+"],
          message: "Tell us about your wedding — villa, style, wishes",
          submit: "Send enquiry",
          sending: "Sending…",
          successTitle: "Thank you!",
          successText: "We have received your enquiry and will reach out within 24 hours with a personalised moodboard and quote.",
          errorText: "Couldn't send. Please message us on WhatsApp — we'll receive it instantly.",
          required: "Please fill in name and contact",
        },

        timelineEyebrow: "YOUR WEDDING CALENDAR",
        timelineTitle: "From the first message",
        timelineTitleAccent: "to the final petal",
        timelineSubtitle: "A transparent timeline with no surprises. You always know what is happening and when.",
        timeline: [
          { when: "4 MONTHS BEFORE", title: "Discovery & concept", text: "Free Zoom consultation. We discuss villa, date, style, budget. Lake Como-tailored moodboard is sent." },
          { when: "3 MONTHS BEFORE", title: "Booking & deposit", text: "A 30% deposit locks in the date and scope. We reserve rare varieties — David Austin peonies from the Netherlands." },
          { when: "1 MONTH BEFORE", title: "Final palette", text: "We approve exact shades, number of arrangements, setup timing. Coordinated with the villa owner and catering team." },
          { when: "2 WEEKS BEFORE", title: "Sign-off meeting", text: "Final moodboard with reference photos. Every detail agreed — no surprises on the day." },
          { when: "DAY -1", title: "Setup from sunrise", text: "Our team is on site from 6 am. Arch, tables, photo zone, aisle — all ready 4 hours before the ceremony." },
          { when: "WEDDING DAY", title: "Bridal bouquet at sunset", text: "Delivered to the villa 1.5–2 hours before the ceremony. Final sync with photographer and planner." },
        ],

        compareTitle: "Compare packages",
        compareSubtitle: "All the differences in one table — so you can choose with confidence.",
        compareHeaders: ["Essential", "Signature", "Bespoke"],
        compareRows: [
          { feature: "Starting price", values: ["from €3,500", "from €7,000", "from €15,000"] },
          { feature: "Guests", values: ["up to 30", "up to 50", "100+"] },
          { feature: "Bridal bouquet", values: ["Classic", "Cascade", "Premium with peonies"] },
          { feature: "Boutonnieres", values: ["Groom", "Groom + 2 groomsmen", "Whole wedding party"] },
          { feature: "Wedding arch", values: ["Compact", "Full size", "Bespoke design"] },
          { feature: "Table centerpieces", values: [false, "6–8 tables", "10+ tables"] },
          { feature: "Aisle petals", values: [false, true, true] },
          { feature: "Floral wall / photo backdrop", values: [false, false, true] },
          { feature: "Sweet table decor", values: [false, true, true] },
          { feature: "Wedding boat & yacht decor", values: [false, false, true] },
          { feature: "On-site day-of florist", values: [false, false, true] },
          { feature: "Post-ceremony breakdown", values: [true, true, true] },
        ],

        relatedEyebrow: "READ MORE",
        relatedTitle: "About flowers",
        relatedTitleAccent: "and weddings on Lake Como",
        relatedSubtitle: "Guides, tips and real stories — everything we know about wedding floristry on Lake Como and in Italy.",
        relatedAll: "ALL BLOG ARTICLES",

        bottomCtaTitle: "Tell us about your",
        bottomCtaTitleAccent: "Lake Como wedding",
        bottomCtaSubtitle:
          "Contact us — we'll send a personalised moodboard and quote within 24 hours. Consultation is free.",
        contactBadges: [
          { title: "Quick WhatsApp reply", subtitle: "Within an hour" },
          { title: "Free moodboard", subtitle: "& preliminary quote" },
          { title: "All Lake Como", subtitle: "Cernobbio, Bellagio, Tremezzo" },
          { title: "10 to 150 guests", subtitle: "Any format" },
        ],
        contactCta: "CONTACT US",

        faqTitle: "Frequently asked questions",
        faq: [
          { q: "How far in advance should I book wedding floral design on Lake Como?", a: "For a full setup (arch, tables, photo zone, bridal bouquet) — 3 to 4 months ahead. Demand is very high — Villa del Balbianello, Villa Balbiano and Villa d'Este book out 12–18 months in advance. Minimum — 4 weeks for the Signature package. A standalone bridal bouquet can be made in 5–7 days during the season." },
          { q: "How much does wedding floral design on Lake Como cost?", a: "Starting from €3,500 (Essential package for an intimate wedding). Signature for 50 guests — from €7,000. Bespoke for 100+ guests with premium varieties — from €15,000. Every quote is individual and depends on the villa, guest count and season." },
          { q: "Do you work with Villa del Balbianello, Villa Balbiano, Villa d'Este?", a: "Yes, we regularly design weddings at all premium Lake Como venues: Villa del Balbianello, Villa Balbiano, Villa Erba, Villa d'Este, Villa Pizzo, Villa Sola Cabiati, Mandarin Oriental Lago di Como, Grand Hotel Tremezzo, CastaDiva Resort, Villa Pliniana. We know access requirements, timings and how to coordinate with venue managers and Lake Como wedding planners." },
          { q: "Do you do garden and lakeside ceremonies?", a: "Yes. We have extensive experience in the historic gardens of villas overlooking the lake in Cernobbio, Lenno, Tremezzo and Bellagio, and on piers at the water's edge. We account for the conditions — the lake breeze, humidity, sunset timing — and use resilient compositions with secure anchoring." },
          { q: "Can I book if I'm not in Italy?", a: "Yes, most of our brides organise everything remotely from London, Paris, Moscow or Dubai. We agree the concept via Zoom/WhatsApp, send a moodboard and sketches. Payment by card, bank transfer or Wise. Full support in English or Russian." },
          { q: "Other Italian destinations too?", a: "Yes, we work across northern Italy — Lake Como, Lake Garda, Lake Maggiore — and can also arrange design in Milan and Venice. Logistics run through Milan." },
          { q: "What if I don't like the final bouquet?", a: "Before setup we send a photo of the finished bridal bouquet for approval. If there are critical issues — we have time to redo it. In practice this almost never happens thanks to the trial bouquet and detailed moodboard." },
        ],
      },
    },
  },

};

export const WEDDING_DEFAULT_CITY = "bodrum";
